//working without model in cart
// (function installAntiScrollPatches(){
//   if (window.__bdsAntiScrollPatched) return;
//   window.__bdsAntiScrollPatched = true;

//   // 1) Patch focus() so any radio (anywhere) gets preventScroll:true by
//   //    default.  Other elements behave normally unless they're inside a
//   //    variant picker, in which case they also get preventScroll.
//   try {
//     var origFocus = HTMLElement.prototype.focus;
//     HTMLElement.prototype.focus = function(opts){
//       try {
//         var inVariant = this && this.closest && this.closest(
//           'variant-picker, .variant-picker, .variant-swatch-list, ' +
//           '.variant-swatch, fieldset.product-form__input, product-rerender'
//         );
//         var isRadio = this && this.tagName === 'INPUT' && this.type === 'radio';
//         if (isRadio || inVariant){
//           var merged = opts && typeof opts === 'object'
//             ? Object.assign({}, opts, { preventScroll: true })
//             : { preventScroll: true };
//           return origFocus.call(this, merged);
//         }
//       } catch(_e){}
//       return origFocus.call(this, opts);
//     };
//   } catch(_e){}

//   // 2) No-op scrollIntoView for anything inside the variant picker subtree.
//   try {
//     var origSIV = Element.prototype.scrollIntoView;
//     Element.prototype.scrollIntoView = function(arg){
//       try {
//         if (this.closest && this.closest(
//           'variant-picker, .variant-picker, .variant-swatch-list, ' +
//           '.variant-swatch, fieldset.product-form__input, product-rerender'
//         )) {
//           return; // suppress
//         }
//       } catch(_e){}
//       return origSIV.call(this, arg);
//     };
//   } catch(_e){}

//   // 3) CSS: disable scroll anchoring + reposition hidden radios behind
//   //    their swatch so focusing them does not jump the viewport.
//   function injectCSS(){
//     if (document.getElementById('bds-anti-scroll-css')) return;
//     var s = document.createElement('style');
//     s.id = 'bds-anti-scroll-css';
//     s.textContent = [
//       'html,body{overflow-anchor:none !important;}',
//       // Make variant radios sit exactly behind their swatch (full size,
//       // transparent, non-interactive) so the label still receives clicks
//       // and focus() on the radio is a no-op visually.
//       '.variant-swatch{position:relative;}',
//       '.variant-swatch input[type="radio"],',
//       '.variant-swatch-list input[type="radio"]{',
//         'position:absolute !important;',
//         'top:0 !important;left:0 !important;right:0 !important;bottom:0 !important;',
//         'width:100% !important;height:100% !important;',
//         'margin:0 !important;padding:0 !important;',
//         'opacity:0 !important;',
//         'clip:auto !important;clip-path:none !important;',
//         'pointer-events:none !important;',
//         'scroll-margin:0 !important;scroll-margin-top:0 !important;',
//       '}',
//       // Belt-and-braces: any focusable thing inside the picker gets
//       // scroll-margin:0 so even if scroll happens we don't add padding.
//       'variant-picker *,.variant-picker *,.variant-swatch-list *{scroll-margin:0 !important;}',
//     ].join('');
//     (document.head || document.documentElement).appendChild(s);
//   }
//   if (document.head) injectCSS();
//   else document.addEventListener('DOMContentLoaded', injectCSS);
// })();

// /* ====== Pre-existing IIFE-wrap guard (kept verbatim) ====== */
// (function(){
//   if (window.__bdsRerenderFix) return;
//   window.__bdsRerenderFix = true;
//   window.__bdsDeliveryDateFix = true;

//   function maybeWrap(node){
//     if (!node || node.nodeType !== 1) return;
//     var html = node.outerHTML;
//     if (!html || (html.indexOf("let ") === -1 && html.indexOf("const ") === -1)) return;
//     var scripts = node.tagName === "SCRIPT" ? [node] : node.querySelectorAll('script:not([src])');
//     for (var i = 0; i < scripts.length; i++){
//       var s = scripts[i], t = s.textContent;
//       if (!t || s.dataset.bdsWrapped) continue;
//       if (!/\b(let|const)\s+[A-Za-z_$]/.test(t)) continue;
//       s.textContent = "(function(){\ntry{\n" + t + "\n}catch(e){console.debug('[rerender-fix]',e.message);}\n})();";
//       s.dataset.bdsWrapped = "1";
//     }
//   }
//   function wrap(fnName){
//     var orig = Element.prototype[fnName];
//     if (!orig) return;
//     Element.prototype[fnName] = function(){
//       for (var i = 0; i < arguments.length; i++) maybeWrap(arguments[i]);
//       try { return orig.apply(this, arguments); }
//       catch(err){
//         if (err && /has already been declared/.test(String(err.message || err))) {
//           console.debug("[rerender-fix] suppressed", err.message);
//           return;
//         }
//         throw err;
//       }
//     };
//   }
//   wrap('replaceWith'); wrap('append'); wrap('after');
// })();

// (function () {
//   "use strict";

//   /* -------- 1. CONFIG -------- */
//   var BRAND_INPUT_ID  = "hiddenBrand";
//   var MODEL_INPUT_ID  = "hiddenModel";
//   var BRAND_TEXT_ID   = "selectedBrand";
//   var MODEL_TEXT_ID   = "selectedModel";
//   var BRAND_FIELD_ID  = "brandSelector";
//   var MODEL_FIELD_ID  = "modelSelector";
//   var ROOT_ID         = "bdsRoot";
//   var BRAND_PLACEHOLDER = "select brand";
//   var MODEL_PLACEHOLDER = "select device";

//   var CASE_TYPE_OPTION_LABEL = "case type";

//   var CASE_TYPE_LABEL_TO_KEY = {
//     "glossy double layer": "tough",
//     "glossy double layer case": "tough",
//     "glossy single layer": "snap",
//     "glossy single layer case": "snap",
//     "snap": "snap",
//     "snap case": "snap",
//     "hard": "hard",
//     "hard case": "hard",
//     "glass": "glass",
//     "glass case": "glass",
//   };

//   var IMAGE_PATTERN_BY_KEY = {
//     "tough": /-A\d+\./i,
//     "snap":  /angle-/i,
//     "hard":  /-G\d+\./i,
//     "glass": /-G\d+\./i,
//   };

//   /* -------- 2. STOCK DATA -------- */
//   var CASE_TYPE_MODELS = {
//     "hard": ["apple iphone 11","apple iphone 11 pro","apple iphone 11 pro max","apple iphone 12","apple iphone 12 mini","apple iphone 12 pro","apple iphone 12 pro max","apple iphone 13","apple iphone 13 mini","apple iphone 13 pro","apple iphone 13 pro max","apple iphone 14","apple iphone 14 plus","apple iphone 14 pro","apple iphone 14 pro max","apple iphone 15","apple iphone 15 plus","apple iphone 15 pro","apple iphone 15 pro max","apple iphone 16","apple iphone 16 plus","apple iphone 16 pro","apple iphone 16 pro max","apple iphone 16e","apple iphone 17","apple iphone 17 pro","apple iphone 17 pro max","apple iphone 17e","apple iphone 7","apple iphone 7 plus","apple iphone 8","apple iphone 8 plus","apple iphone air","apple iphone se 2020","apple iphone se 2022","apple iphone x","apple iphone xr","apple iphone xs","apple iphone xs max","google pixel 10","google pixel 10 pro","google pixel 10 pro xl","google pixel 10a","google pixel 6","google pixel 6 pro","google pixel 6a","google pixel 7","google pixel 7 pro","google pixel 7a","google pixel 8","google pixel 8 pro","google pixel 8a","google pixel 9","google pixel 9 pro","google pixel 9 pro xl","google pixel 9a","motorola edge 30","motorola edge 30 fusion","motorola edge 30 ultra","motorola edge 40","motorola edge 40 neo","motorola edge 50","motorola edge 50 fusion","motorola edge 50 pro","motorola edge 50 ultra","motorola edge 60 fusion","motorola edge 60 pro","motorola edge 70","motorola edge 70 fusion","motorola g96","motorola moto g45","motorola moto g54","motorola moto g64","motorola moto g84","motorola moto g85 5g","nothing cmf phone 1","nothing cmf phone 2 pro","nothing phone 1","nothing phone 2","nothing phone 2a","nothing phone 2a plus","nothing phone 3","nothing phone 3a","nothing phone 3a lite","nothing phone 3a pro","nothing phone 4a","nothing phone 4a pro","oneplus 10 pro 5g","oneplus 10r","oneplus 10t 5g","oneplus 11 5g","oneplus 11r 5g","oneplus 12","oneplus 12r","oneplus 13","oneplus 13r","oneplus 13s","oneplus 15","oneplus 15r","oneplus 6","oneplus 6t","oneplus 7","oneplus 7 pro","oneplus 7t","oneplus 7t pro","oneplus 8","oneplus 8 pro","oneplus 8t","oneplus 9","oneplus 9 pro","oneplus 9r","oneplus 9rt","oneplus ace 2v","oneplus ace racing","oneplus nord","oneplus nord 2","oneplus nord 2t 5g","oneplus nord 3 5g","oneplus nord 4","oneplus nord 5","oneplus nord ce 2 5g","oneplus nord ce 2 lite 5g","oneplus nord ce 3 5g","oneplus nord ce 3 lite","oneplus nord ce 4","oneplus nord ce 5g","oneplus nord ce4 lite 5g","oneplus nord ce5","oppo a11","oppo a11x","oppo a3 pro","oppo a5 2020","oppo a5 pro","oppo a59","oppo a73 2020","oppo a74","oppo a78 5g","oppo a9 2020","oppo a91","oppo a93","oppo f11 pro","oppo f15","oppo f17","oppo f17 pro","oppo f19","oppo f19 pro","oppo f19 pro plus","oppo f21 pro 4g","oppo f21 pro 5g","oppo f21s pro 4g","oppo f21s pro 5g","oppo f25 pro 5g","oppo f27 pro plus","oppo f29","oppo f29 pro","oppo f31 5g","oppo f31 pro 5g","oppo f31 pro plus 5g","oppo find x8","oppo find x8 pro","oppo find x9","oppo find x9 pro","oppo k12","oppo k13","oppo k13 turbo 5g","oppo k13 turbo pro 5g","oppo k3","oppo k5","oppo reno 10 5g","oppo reno 10 pro 5g","oppo reno 10 pro plus 5g","oppo reno 10x zoom","oppo reno 11","oppo reno 11 pro","oppo reno 12 5g","oppo reno 12 pro 5g","oppo reno 14","oppo reno 14 pro","oppo reno 15","oppo reno 15 pro","oppo reno 15 pro mini","oppo reno 15c","oppo reno 2","oppo reno 2f","oppo reno 2z","oppo reno 3","oppo reno 3 pro international","oppo reno 4 lite","oppo reno 4 pro","oppo reno 4f","oppo reno 5 pro","oppo reno 6 5g","oppo reno 6 pro 5g","oppo reno 7 5g","oppo reno 7 pro 5g","oppo reno 8 5g","oppo reno 8 pro 5g","oppo reno 8t 5g","oppo reno ace","oppo reno13","oppo reno13 pro","realme 10 pro 5g","realme 10 pro plus 5g","realme 11 5g","realme 11 pro","realme 11 pro plus","realme 11x 5g","realme 12","realme 12 plus","realme 12 pro 5g","realme 12 pro plus 5g","realme 12x","realme 13","realme 13 pro","realme 13 pro plus","realme 14 pro","realme 14 pro plus","realme 14x","realme 15","realme 15 pro","realme 3 pro","realme 5","realme 5 pro","realme 5s","realme 6","realme 6 pro","realme 6i","realme 6s","realme 7","realme 7 pro","realme 8","realme 8 5g","realme 8 pro","realme 8s 5g","realme 9 4g","realme 9 5g","realme 9 5g speed edition","realme 9 pro 5g","realme 9 pro plus 5g","realme 9i 4g","realme c65 5g","realme c75","realme gt 2","realme gt 2 pro","realme gt 5g","realme gt 6","realme gt 6t","realme gt 7","realme gt 7 pro","realme gt 7t","realme gt neo 2","realme gt neo 3","realme gt neo 3t","realme gt neo 6","realme gt neo 6 se","realme narzo 10","realme narzo 20 pro","realme narzo 30 5g","realme narzo 50 pro","realme narzo 60 pro","realme narzo 60x 5g","realme narzo 70","realme narzo 70 pro","realme narzo 70x","realme neo7x","realme p1","realme p1 pro","realme p2 pro","realme p3","realme p3 pro","realme p3 ultra","realme v60 pro","realme x","realme x lite","realme x2","realme x2 pro","realme x50 pro","realme x7","realme x7 max 5g","realme x7 pro","realme xt","samsung galaxy a02s","samsung galaxy a06","samsung galaxy a10","samsung galaxy a10s","samsung galaxy a11","samsung galaxy a12","samsung galaxy a14 5g","samsung galaxy a15 5g","samsung galaxy a16","samsung galaxy a17","samsung galaxy a20","samsung galaxy a22 4g","samsung galaxy a22 5g","samsung galaxy a23 5g","samsung galaxy a25 5g","samsung galaxy a26","samsung galaxy a27","samsung galaxy a30","samsung galaxy a30s","samsung galaxy a31","samsung galaxy a32 4g","samsung galaxy a32 5g","samsung galaxy a33 5g","samsung galaxy a34 5g","samsung galaxy a35 5g","samsung galaxy a36","samsung galaxy a37","samsung galaxy a40","samsung galaxy a40s","samsung galaxy a50","samsung galaxy a50s","samsung galaxy a51","samsung galaxy a52","samsung galaxy a52 5g","samsung galaxy a52s 5g","samsung galaxy a53 5g","samsung galaxy a54 5g","samsung galaxy a55 5g","samsung galaxy a56","samsung galaxy a57","samsung galaxy a60","samsung galaxy a70","samsung galaxy a70s","samsung galaxy a71","samsung galaxy a72","samsung galaxy a73 5g","samsung galaxy a81","samsung galaxy a91","samsung galaxy f02s","samsung galaxy f06 5g","samsung galaxy f07","samsung galaxy f12","samsung galaxy f14 5g","samsung galaxy f15","samsung galaxy f16","samsung galaxy f17","samsung galaxy f22","samsung galaxy f23 5g","samsung galaxy f34 5g","samsung galaxy f36","samsung galaxy f41","samsung galaxy f42 5g","samsung galaxy f54 5g","samsung galaxy f55","samsung galaxy f56 5g","samsung galaxy f62","samsung galaxy fold 6 back","samsung galaxy fold 6 front","samsung galaxy m02s","samsung galaxy m06","samsung galaxy m07","samsung galaxy m10","samsung galaxy m10s","samsung galaxy m11","samsung galaxy m12","samsung galaxy m14","samsung galaxy m16","samsung galaxy m20","samsung galaxy m21","samsung galaxy m21 2021","samsung galaxy m30","samsung galaxy m30s","samsung galaxy m31","samsung galaxy m31 prime","samsung galaxy m31s","samsung galaxy m32","samsung galaxy m32 5g","samsung galaxy m33 5g","samsung galaxy m34 5g","samsung galaxy m35","samsung galaxy m36","samsung galaxy m40","samsung galaxy m51","samsung galaxy m52 5g","samsung galaxy m53 5g","samsung galaxy m54 5g","samsung galaxy m55","samsung galaxy m56","samsung galaxy m62","samsung galaxy note 10","samsung galaxy note 10 lite","samsung galaxy note 10 plus","samsung galaxy note 20","samsung galaxy note 20 ultra","samsung galaxy note 9","samsung galaxy s10","samsung galaxy s10 lite","samsung galaxy s10 plus","samsung galaxy s10e","samsung galaxy s20","samsung galaxy s20 fe","samsung galaxy s20 fe 5g","samsung galaxy s20 plus","samsung galaxy s20 ultra","samsung galaxy s21","samsung galaxy s21 plus","samsung galaxy s21 ultra","samsung galaxy s21fe","samsung galaxy s22 5g","samsung galaxy s22 plus 5g","samsung galaxy s22 ultra 5g","samsung galaxy s23","samsung galaxy s23 plus","samsung galaxy s23 ultra","samsung galaxy s23fe","samsung galaxy s24","samsung galaxy s24 fe","samsung galaxy s24 plus","samsung galaxy s24 ultra","samsung galaxy s25","samsung galaxy s25 edge","samsung galaxy s25 fe","samsung galaxy s25 plus","samsung galaxy s25 ultra","samsung galaxy s26","samsung galaxy s26 plus","samsung galaxy s26 ultra","samsung galaxy s8","samsung galaxy s8 plus","samsung galaxy s9","samsung galaxy s9 plus","samsung galaxy z flip 3 5g bottom","samsung galaxy z flip 3 5g top","samsung galaxy z flip 4 bottom","samsung galaxy z flip 4 top","samsung galaxy z flip 5 bottom","samsung galaxy z flip 5 top","samsung galaxy z flip 6 bottom","samsung galaxy z flip 6 top","samsung galaxy z flip 7 bottom","samsung galaxy z flip 7 top","samsung galaxy z fold 3 5g back","samsung galaxy z fold 3 5g front","samsung galaxy z fold 4 back","samsung galaxy z fold 4 front","samsung galaxy z fold 5 back","samsung galaxy z fold 5 front","samsung galaxy z fold 7 back","samsung galaxy z fold 7 front","vivo iqoo 10","vivo iqoo 11","vivo iqoo 12","vivo iqoo 13","vivo iqoo 15","vivo iqoo 3","vivo iqoo 7","vivo iqoo 7 legend 5g","vivo iqoo 8 5g","vivo iqoo 9 5g","vivo iqoo 9 5g international","vivo iqoo 9 pro 5g","vivo iqoo 9 se 5g","vivo iqoo 9t 5g","vivo iqoo neo 10","vivo iqoo neo 10r","vivo iqoo neo 5","vivo iqoo neo 5 s","vivo iqoo neo 6 5g","vivo iqoo neo 7","vivo iqoo neo9","vivo iqoo neo9 pro","vivo iqoo u5e","vivo iqoo z10","vivo iqoo z10r 5g","vivo iqoo z10x","vivo iqoo z3","vivo iqoo z5","vivo iqoo z6","vivo iqoo z6 pro 5g","vivo iqoo z7 international","vivo iqoo z7 pro 5g","vivo iqoo z9","vivo iqoo z9 lite","vivo iqoo z9s","vivo iqoo z9s pro","vivo iqooz9x","vivo s1","vivo s1 pro","vivo s10e","vivo s15 pro","vivo s15e","vivo s18","vivo s18 pro","vivo s7","vivo t1 5g","vivo t1 pro 5g","vivo t2 pro 5g","vivo t3","vivo t3 5g","vivo t3 pro","vivo t3 ultra","vivo t4","vivo t4x","vivo v15 pro","vivo v17","vivo v17 pro","vivo v19","vivo v20","vivo v20 pro","vivo v20 se","vivo v21","vivo v21e","vivo v23 5g","vivo v23 pro 5g","vivo v23e 5g","vivo v25 5g","vivo v25 pro 5g","vivo v27","vivo v27 pro","vivo v27e","vivo v29","vivo v29 pro","vivo v29e","vivo v30","vivo v30 pro","vivo v30e","vivo v40","vivo v40 pro","vivo v40e","vivo v50","vivo v60","vivo v60e","vivo v70","vivo v70 elite","vivo v70 fe","vivo x100","vivo x100 pro","vivo x200","vivo x200 fe","vivo x200 pro","vivo x300","vivo x300 pro","vivo x60","vivo x60 pro","vivo x70","vivo x70 pro","vivo x80 5g","vivo x80 pro 5g","vivo x90","vivo x90 pro","vivo y100","vivo y200","vivo y200 pro","vivo y200e","vivo y22","vivo y22s","vivo y28s","vivo y29","vivo y30 5g","vivo y300","vivo y300 plus","vivo y33e","vivo y33s 5g","vivo y35","vivo y52t","vivo y55 5g","vivo y56 5g","vivo y58","vivo y73","vivo y75 5g","vivo z1 pro","vivo z1x","xiaomi 11 lite","xiaomi 11 lite ne 5g","xiaomi 11i 5g","xiaomi 11i hypercharge 5g","xiaomi 11t pro 5g","xiaomi 12 lite 5g","xiaomi 12 pro 5g","xiaomi 13 pro","xiaomi 14","xiaomi 14 civi","xiaomi 14 ultra","xiaomi 15","xiaomi 15 ultra","xiaomi 17","xiaomi 17 ultra","xiaomi mi 10i","xiaomi mi 10t","xiaomi mi 10t pro","xiaomi mi 11 ultra","xiaomi mi 11x","xiaomi mi 11x pro","xiaomi mi a3","xiaomi mi note 10 international","xiaomi poco f1","xiaomi poco f3","xiaomi poco f3 gt","xiaomi poco f4 5g","xiaomi poco f6","xiaomi poco m2 pro","xiaomi poco m3 pro 5g","xiaomi poco x2","xiaomi poco x3","xiaomi poco x3 pro","xiaomi poco x4 pro 5g","xiaomi redmi 13 5g","xiaomi redmi 13c 5g","xiaomi redmi 15 5g","xiaomi redmi 15c 5g","xiaomi redmi 7a","xiaomi redmi 9 power","xiaomi redmi 9t","xiaomi redmi k20","xiaomi redmi k20 pro","xiaomi redmi k30","xiaomi redmi k50i","xiaomi redmi note 10","xiaomi redmi note 10 5g","xiaomi redmi note 10 lite","xiaomi redmi note 10 pro","xiaomi redmi note 10 pro max","xiaomi redmi note 10s","xiaomi redmi note 10t 5g","xiaomi redmi note 11","xiaomi redmi note 11 international","xiaomi redmi note 11 pro","xiaomi redmi note 11 pro 5g international","xiaomi redmi note 11 pro plus 5g","xiaomi redmi note 11 pro plus 5g international","xiaomi redmi note 11s","xiaomi redmi note 11t 5g","xiaomi redmi note 11t pro","xiaomi redmi note 11t pro plus","xiaomi redmi note 12 5g","xiaomi redmi note 12 pro","xiaomi redmi note 12 pro plus","xiaomi redmi note 13","xiaomi redmi note 13 pro","xiaomi redmi note 13 pro plus","xiaomi redmi note 14","xiaomi redmi note 14 pro","xiaomi redmi note 14 pro plus","xiaomi redmi note 15","xiaomi redmi note 15 pro","xiaomi redmi note 15 pro plus","xiaomi redmi note 7","xiaomi redmi note 7 pro","xiaomi redmi note 7s","xiaomi redmi note 8","xiaomi redmi note 8 pro","xiaomi redmi note 9","xiaomi redmi note 9 pro","xiaomi redmi note 9 pro max","xiaomi redmi note 9s"],
//     "snap": ["apple iphone 11","apple iphone 11 pro","apple iphone 11 pro max","apple iphone 12","apple iphone 12 mini","apple iphone 12 pro","apple iphone 12 pro max","apple iphone 13","apple iphone 13 mini","apple iphone 13 pro","apple iphone 13 pro max","apple iphone 14","apple iphone 14 plus","apple iphone 14 pro","apple iphone 14 pro max","apple iphone 15","apple iphone 15 plus","apple iphone 15 pro","apple iphone 15 pro max","apple iphone 16","apple iphone 16 plus","apple iphone 16 pro","apple iphone 16 pro max","apple iphone 16e","apple iphone 17","apple iphone 17 pro","apple iphone 17 pro max","apple iphone 17e","apple iphone air","samsung galaxy s23","samsung galaxy s23 plus","samsung galaxy s23 ultra","samsung galaxy s24","samsung galaxy s24 plus","samsung galaxy s24 ultra","samsung galaxy s25","samsung galaxy s25 plus","samsung galaxy s25 ultra","samsung galaxy s26","samsung galaxy s26 plus","samsung galaxy s26 ultra"],
//     "tough": ["apple iphone 11","apple iphone 11 pro","apple iphone 11 pro max","apple iphone 12","apple iphone 12 mini","apple iphone 12 pro","apple iphone 12 pro max","apple iphone 13","apple iphone 13 mini","apple iphone 13 pro","apple iphone 13 pro max","apple iphone 14","apple iphone 14 plus","apple iphone 14 pro","apple iphone 14 pro max","apple iphone 15","apple iphone 15 plus","apple iphone 15 pro","apple iphone 15 pro max","apple iphone 16","apple iphone 16 plus","apple iphone 16 pro","apple iphone 16 pro max","apple iphone 16e","apple iphone 17","apple iphone 17 pro","apple iphone 17 pro max","apple iphone 17e","apple iphone air","samsung galaxy s23","samsung galaxy s23 plus","samsung galaxy s23 ultra","samsung galaxy s24","samsung galaxy s24 plus","samsung galaxy s24 ultra","samsung galaxy s25","samsung galaxy s25 plus","samsung galaxy s25 ultra","samsung galaxy s26","samsung galaxy s26 plus","samsung galaxy s26 ultra"],
//     "glass": ["apple iphone 11","apple iphone 11 pro","apple iphone 11 pro max","apple iphone 12","apple iphone 12 mini","apple iphone 12 pro","apple iphone 12 pro max","apple iphone 13","apple iphone 13 mini","apple iphone 13 pro","apple iphone 13 pro max","apple iphone 14","apple iphone 14 plus","apple iphone 14 pro","apple iphone 14 pro max","apple iphone 15","apple iphone 15 plus","apple iphone 15 pro","apple iphone 15 pro max","apple iphone 16","apple iphone 16 plus","apple iphone 16 pro","apple iphone 16 pro max","apple iphone 16e","apple iphone 17","apple iphone 17 pro","apple iphone 17 pro max","apple iphone 17e","apple iphone 6","apple iphone 6 plus","apple iphone 6s","apple iphone 6s plus","apple iphone 7","apple iphone 7 plus","apple iphone 8","apple iphone 8 plus","apple iphone air","apple iphone se 2020","apple iphone se 2022","apple iphone x","apple iphone xr","apple iphone xs","apple iphone xs max","google pixel 10","google pixel 10 pro","google pixel 10 pro xl","google pixel 10a","google pixel 6","google pixel 6 pro","google pixel 6a","google pixel 7","google pixel 7 pro","google pixel 7a","google pixel 8","google pixel 8 pro","google pixel 8a","google pixel 9","google pixel 9 pro","google pixel 9 pro xl","google pixel 9a","honor 90 5g","motorola edge 30","motorola edge 30 fusion","motorola edge 30 ultra","motorola edge 40","motorola edge 40 neo","motorola edge 50","motorola edge 50 fusion","motorola edge 50 pro","motorola edge 50 ultra","motorola edge 60 fusion","motorola edge 60 pro","motorola edge 70","motorola edge 70 fusion","motorola g96","motorola moto g45","motorola moto g54","motorola moto g64","motorola moto g84","motorola moto g85 5g","nothing cmf phone 1","nothing cmf phone 2 pro","nothing phone 1","nothing phone 2","nothing phone 2a","nothing phone 2a plus","nothing phone 3","nothing phone 3a","nothing phone 3a lite","nothing phone 3a pro","nothing phone 4a","nothing phone 4a pro","oneplus 10 pro 5g","oneplus 10r","oneplus 10t 5g","oneplus 11 5g","oneplus 11r 5g","oneplus 12","oneplus 12r","oneplus 13","oneplus 13r","oneplus 13s","oneplus 15","oneplus 15r","oneplus 5t","oneplus 6","oneplus 6t","oneplus 7","oneplus 7t","oneplus 7t pro","oneplus 8","oneplus 8 pro","oneplus 8t","oneplus 9","oneplus 9 pro","oneplus 9r","oneplus 9rt","oneplus ace 2 5g","oneplus ace 2v","oneplus ace 5g","oneplus ace pro 5g","oneplus ace racing","oneplus nord","oneplus nord 2","oneplus nord 2t 5g","oneplus nord 3 5g","oneplus nord 4","oneplus nord 5","oneplus nord ce 2 5g","oneplus nord ce 2 lite 5g","oneplus nord ce 3 5g","oneplus nord ce 3 lite","oneplus nord ce 4","oneplus nord ce 5g","oneplus nord ce4 lite 5g","oneplus nord ce5","oneplus nord n20 5g","oneplus open back","oneplus open front","oppo a1 pro","oppo a11","oppo a11x","oppo a3 pro","oppo a5 2020","oppo a5 pro","oppo a58 international","oppo a58x","oppo a59","oppo a73 2020","oppo a74","oppo a78 5g","oppo a79","oppo a9 2020","oppo a91","oppo a93","oppo a94","oppo a96 international","oppo f11 pro","oppo f15","oppo f17","oppo f17 pro","oppo f19","oppo f19 pro","oppo f19 pro plus","oppo f21 pro 4g","oppo f21 pro 5g","oppo f21s pro 4g","oppo f21s pro 5g","oppo f23 5g","oppo f25 pro","oppo f27 pro","oppo f27 pro plus","oppo f29","oppo f29 pro","oppo f31 5g","oppo f31 pro 5g","oppo f31 pro plus 5g","oppo find n3 back","oppo find n3 front","oppo find x8","oppo find x8 pro","oppo find x9","oppo find x9 pro","oppo k12","oppo k13","oppo k13 turbo 5g","oppo k13 turbo pro 5g","oppo k3","oppo k5","oppo reno 10 5g","oppo reno 10 pro 5g","oppo reno 10 pro plus 5g","oppo reno 10x zoom","oppo reno 11","oppo reno 11 pro","oppo reno 12 5g","oppo reno 12 pro 5g","oppo reno 14","oppo reno 14 pro","oppo reno 15","oppo reno 15 pro","oppo reno 15 pro mini","oppo reno 15c","oppo reno 2","oppo reno 2f","oppo reno 2z","oppo reno 3","oppo reno 3 pro international","oppo reno 4 lite","oppo reno 4 pro","oppo reno 4f","oppo reno 5 pro","oppo reno 6 5g","oppo reno 6 pro 5g","oppo reno 7 5g","oppo reno 7 pro 5g","oppo reno 8 5g","oppo reno 8 pro 5g","oppo reno 8t 5g","oppo reno ace","oppo reno13","oppo reno13 pro","oppo reno5 f","oppo reno5 lite","oppo reno6 pro 5g international","oppo reno6 pro plus 5g","oppo reno7","oppo reno7 lite","oppo reno7 z 5g","oppo reno8 4g","oppo reno8 lite","oppo reno8 z","realme 10 pro 5g","realme 10 pro plus 5g","realme 11 5g","realme 11 international","realme 11 pro","realme 11 pro plus","realme 11x 5g","realme 12","realme 12 plus","realme 12 pro","realme 12 pro plus","realme 12x","realme 13","realme 13 pro","realme 13 pro plus","realme 14 pro","realme 14 pro plus","realme 14x","realme 15","realme 15 pro","realme 3 pro","realme 5","realme 5 pro","realme 5s","realme 6","realme 6 pro","realme 6i","realme 6s","realme 7","realme 7 pro","realme 8","realme 8 5g","realme 8 pro","realme 8s 5g","realme 9 4g","realme 9 5g","realme 9 5g speed edition","realme 9 pro 5g","realme 9 pro plus 5g","realme 9i 4g","realme c65 5g","realme c75","realme gt 2","realme gt 2 pro","realme gt 5g","realme gt 6","realme gt 6t","realme gt 7","realme gt 7 pro","realme gt 7t","realme gt neo 2","realme gt neo 3","realme gt neo 3t","realme gt neo 6 se","realme gt neo flash","realme gt neo2t","realme gt neo6","realme narzo 10","realme narzo 20 pro","realme narzo 30 5g","realme narzo 50 pro","realme narzo 60","realme narzo 60 pro","realme narzo 60x 5g","realme narzo 70","realme narzo 70 pro","realme narzo 70x","realme neo7x","realme p1","realme p1 pro","realme p2 pro","realme p3","realme p3 pro","realme p3 ultra","realme q2 pro international","realme q3 5g","realme q3 pro 5g","realme q3i 5g","realme q5","realme q5 pro","realme v13 5g","realme v25","realme v60 pro","realme x","realme x lite","realme x2","realme x2 pro","realme x50 pro","realme x7 international","realme x7 max 5g","realme x7 pro","realme xt","samsung galaxy a02s","samsung galaxy a03s","samsung galaxy a04","samsung galaxy a05s","samsung galaxy a06","samsung galaxy a10","samsung galaxy a10s","samsung galaxy a11","samsung galaxy a12","samsung galaxy a14 4g","samsung galaxy a14 5g","samsung galaxy a15 5g","samsung galaxy a16","samsung galaxy a17","samsung galaxy a20","samsung galaxy a22 4g","samsung galaxy a22 5g","samsung galaxy a23 5g","samsung galaxy a25 5g","samsung galaxy a26","samsung galaxy a27","samsung galaxy a30","samsung galaxy a30s","samsung galaxy a31","samsung galaxy a32 4g","samsung galaxy a32 5g","samsung galaxy a33 5g","samsung galaxy a34 5g","samsung galaxy a35","samsung galaxy a36","samsung galaxy a37","samsung galaxy a40","samsung galaxy a40s","samsung galaxy a50","samsung galaxy a50s","samsung galaxy a51","samsung galaxy a52","samsung galaxy a52 5g","samsung galaxy a52s 5g","samsung galaxy a53 5g","samsung galaxy a54 5g","samsung galaxy a55","samsung galaxy a56","samsung galaxy a57","samsung galaxy a60","samsung galaxy a70","samsung galaxy a70s","samsung galaxy a71","samsung galaxy a72","samsung galaxy a73 5g","samsung galaxy a81","samsung galaxy a91","samsung galaxy f02s","samsung galaxy f06 5g","samsung galaxy f07","samsung galaxy f12","samsung galaxy f14 5g","samsung galaxy f15","samsung galaxy f16","samsung galaxy f22","samsung galaxy f23 5g","samsung galaxy f34 5g","samsung galaxy f36","samsung galaxy f41","samsung galaxy f42 5g","samsung galaxy f54 5g","samsung galaxy f55","samsung galaxy f56 5g","samsung galaxy f62","samsung galaxy fold 6 back","samsung galaxy fold 6 front","samsung galaxy m02s","samsung galaxy m06","samsung galaxy m07","samsung galaxy m10","samsung galaxy m10s","samsung galaxy m11","samsung galaxy m12","samsung galaxy m14","samsung galaxy m15","samsung galaxy m16","samsung galaxy m17","samsung galaxy m20","samsung galaxy m21","samsung galaxy m21 2021","samsung galaxy m23 5g","samsung galaxy m30","samsung galaxy m30s","samsung galaxy m31","samsung galaxy m31 prime","samsung galaxy m31s","samsung galaxy m32","samsung galaxy m32 5g","samsung galaxy m33 5g","samsung galaxy m34 5g","samsung galaxy m35","samsung galaxy m36","samsung galaxy m40","samsung galaxy m51","samsung galaxy m52 5g","samsung galaxy m53 5g","samsung galaxy m54 5g","samsung galaxy m55","samsung galaxy m56","samsung galaxy m62","samsung galaxy note 10","samsung galaxy note 10 lite","samsung galaxy note 10 plus","samsung galaxy note 20","samsung galaxy note 20 5g","samsung galaxy note 20 ultra","samsung galaxy note 9","samsung galaxy s10","samsung galaxy s10 lite","samsung galaxy s10 plus","samsung galaxy s10e","samsung galaxy s20","samsung galaxy s20 fe","samsung galaxy s20 fe 5g","samsung galaxy s20 plus","samsung galaxy s20 ultra","samsung galaxy s21","samsung galaxy s21 plus","samsung galaxy s21 ultra","samsung galaxy s21fe","samsung galaxy s22 5g","samsung galaxy s22 plus 5g","samsung galaxy s22 ultra 5g","samsung galaxy s23","samsung galaxy s23 plus","samsung galaxy s23 ultra","samsung galaxy s23fe","samsung galaxy s24","samsung galaxy s24 fe","samsung galaxy s24 plus","samsung galaxy s24 ultra","samsung galaxy s25","samsung galaxy s25 edge","samsung galaxy s25 fe","samsung galaxy s25 plus","samsung galaxy s25 ultra","samsung galaxy s26","samsung galaxy s26 plus","samsung galaxy s26 ultra","samsung galaxy s8","samsung galaxy s8 plus","samsung galaxy s9","samsung galaxy s9 plus","samsung galaxy z flip 3 5g bottom","samsung galaxy z flip 3 5g top","samsung galaxy z flip 4 bottom","samsung galaxy z flip 4 top","samsung galaxy z flip 5 bottom","samsung galaxy z flip 5 top","samsung galaxy z flip 6 bottom","samsung galaxy z flip 6 top","samsung galaxy z flip 7 bottom","samsung galaxy z flip 7 top","samsung galaxy z fold 3 5g back","samsung galaxy z fold 3 5g front","samsung galaxy z fold 4 back","samsung galaxy z fold 4 front","samsung galaxy z fold 5 back","samsung galaxy z fold 5 front","samsung galaxy z fold 7 back","samsung galaxy z fold 7 front","tecno pova 5 pro","vivo iqoo 10","vivo iqoo 11","vivo iqoo 12","vivo iqoo 13","vivo iqoo 15","vivo iqoo 3","vivo iqoo 7","vivo iqoo 7 legend 5g","vivo iqoo 8 5g","vivo iqoo 9 5g","vivo iqoo 9 5g international","vivo iqoo 9 pro 5g","vivo iqoo 9 se 5g","vivo iqoo 9t 5g","vivo iqoo neo 10","vivo iqoo neo 10r","vivo iqoo neo 5","vivo iqoo neo 5 s","vivo iqoo neo 6 5g","vivo iqoo neo 7","vivo iqoo neo 7 pro","vivo iqoo neo6 se","vivo iqoo neo7 racing","vivo iqoo neo7 se","vivo iqoo neo9","vivo iqoo neo9 pro","vivo iqoo u5e","vivo iqoo z10","vivo iqoo z10r 5g","vivo iqoo z10x","vivo iqoo z3","vivo iqoo z5","vivo iqoo z6","vivo iqoo z6 international","vivo iqoo z6 lite","vivo iqoo z6 pro 5g","vivo iqoo z6x","vivo iqoo z7 pro 5g","vivo iqoo z9","vivo iqoo z9 lite","vivo iqoo z9s","vivo iqoo z9s pro","vivo iqooz9x","vivo s1","vivo s1 pro","vivo s1 pro international","vivo s10e","vivo s12","vivo s12 pro","vivo s15 pro","vivo s15e","vivo s16","vivo s16 pro","vivo s16e","vivo s18","vivo s18 pro","vivo s7","vivo t1 5g","vivo t1 pro 5g","vivo t2 5g","vivo t2 pro 5g","vivo t2x 5g international","vivo t3 5g","vivo t3 pro","vivo t3 ultra","vivo t3x","vivo t4","vivo t4x","vivo v15 pro","vivo v17","vivo v17 pro","vivo v19","vivo v20","vivo v20 pro","vivo v20 se","vivo v21","vivo v21 5g","vivo v21e","vivo v21s","vivo v23 5g","vivo v23 pro 5g","vivo v23e 5g","vivo v25 5g","vivo v25 pro 5g","vivo v25e","vivo v27","vivo v27 pro","vivo v27e","vivo v29","vivo v29 pro","vivo v29e","vivo v30","vivo v30 pro","vivo v30e","vivo v40","vivo v40 pro","vivo v40e","vivo v50","vivo v60","vivo v60e","vivo v70","vivo v70 elite","vivo v70 fe","vivo x100","vivo x100 pro","vivo x200","vivo x200 fe","vivo x200 pro","vivo x300","vivo x300 pro","vivo x60","vivo x60 pro","vivo x60t","vivo x70","vivo x70 pro","vivo x80 5g","vivo x80 lite","vivo x80 pro 5g","vivo x90","vivo x90 pro","vivo y03","vivo y100","vivo y100 international","vivo y100a","vivo y16","vivo y18e","vivo y200","vivo y200 pro","vivo y200e","vivo y200t","vivo y22","vivo y22s","vivo y27","vivo y28s","vivo y29","vivo y30 5g","vivo y300","vivo y300 plus","vivo y300 pro","vivo y33e","vivo y33s 5g","vivo y35","vivo y35 plus 5g","vivo y36","vivo y38","vivo y52 5g","vivo y52t","vivo y55 5g","vivo y56 5g","vivo y70","vivo y72 5g international","vivo y73","vivo y73t","vivo y75 5g","vivo y75s","vivo z1 pro","vivo z1x","vivo z5x","xiaomi 11 lite","xiaomi 11 lite ne 5g","xiaomi 11i 5g","xiaomi 11i hypercharge 5g","xiaomi 11t 5g","xiaomi 11t pro 5g","xiaomi 12 lite 5g","xiaomi 12 pro 5g","xiaomi 12s pro","xiaomi 12x","xiaomi 13 pro","xiaomi 14","xiaomi 14 ultra","xiaomi 15","xiaomi 15 ultra","xiaomi 17","xiaomi 17 ultra","xiaomi mi 10i","xiaomi mi 10t","xiaomi mi 10t lite 5g","xiaomi mi 10t pro","xiaomi mi 11 ultra","xiaomi mi 11x","xiaomi mi 11x pro","xiaomi mi 9t","xiaomi mi 9t pro","xiaomi mi a3","xiaomi mi note 10 international","xiaomi poco f1","xiaomi poco f3","xiaomi poco f3 gt","xiaomi poco f4 5g","xiaomi poco f5 5g","xiaomi poco f6","xiaomi poco m2 pro","xiaomi poco m3 pro 5g","xiaomi poco m4 pro 5g","xiaomi poco m5s","xiaomi poco m6 pro 5g","xiaomi poco x2","xiaomi poco x3","xiaomi poco x3 nfc","xiaomi poco x3 pro","xiaomi poco x4 gt","xiaomi poco x4 pro 5g","xiaomi poco x5","xiaomi poco x5 5g","xiaomi poco x5 pro 5g","xiaomi poco x6","xiaomi poco x6 pro","xiaomi redmi 10x 4g","xiaomi redmi 12 4g","xiaomi redmi 12 5g","xiaomi redmi 13 5g","xiaomi redmi 13c 5g","xiaomi redmi 15 5g","xiaomi redmi 15c 5g","xiaomi redmi 7a","xiaomi redmi 9 power","xiaomi redmi 9t","xiaomi redmi k20","xiaomi redmi k20 pro","xiaomi redmi k30","xiaomi redmi k30i 5g","xiaomi redmi k40","xiaomi redmi k40 gaming","xiaomi redmi k50i","xiaomi redmi note 10","xiaomi redmi note 10 5g","xiaomi redmi note 10 lite","xiaomi redmi note 10 pro","xiaomi redmi note 10 pro max","xiaomi redmi note 10s","xiaomi redmi note 10t 5g","xiaomi redmi note 11","xiaomi redmi note 11 international","xiaomi redmi note 11 pro","xiaomi redmi note 11 pro 5g international","xiaomi redmi note 11 pro plus 5g","xiaomi redmi note 11 pro plus 5g international","xiaomi redmi note 11 se","xiaomi redmi note 11e pro","xiaomi redmi note 11s","xiaomi redmi note 11s 5g","xiaomi redmi note 11se 5g international","xiaomi redmi note 11t 5g","xiaomi redmi note 11t pro","xiaomi redmi note 11t pro plus","xiaomi redmi note 12 4g","xiaomi redmi note 12 5g","xiaomi redmi note 12 pro","xiaomi redmi note 12 pro plus","xiaomi redmi note 13","xiaomi redmi note 13 pro","xiaomi redmi note 13 pro plus","xiaomi redmi note 14","xiaomi redmi note 14 pro","xiaomi redmi note 14 pro plus","xiaomi redmi note 15","xiaomi redmi note 15 pro","xiaomi redmi note 15 pro plus","xiaomi redmi note 7","xiaomi redmi note 7 pro","xiaomi redmi note 7s","xiaomi redmi note 8","xiaomi redmi note 8 2021","xiaomi redmi note 8 pro","xiaomi redmi note 9","xiaomi redmi note 9 pro","xiaomi redmi note 9 pro 5g","xiaomi redmi note 9 pro max","xiaomi redmi note 9s"],
//   };

//   /* -------- 3. UTIL -------- */
//   function norm(s){ return String(s||"").toLowerCase().replace(/\s+/g," ").trim(); }
//   function $id(id){ return document.getElementById(id); }
//   function realPickerValue(raw){
//     var v = norm(raw);
//     if (!v) return "";
//     if (v === BRAND_PLACEHOLDER || v === MODEL_PLACEHOLDER) return "";
//     if (v.indexOf("select ") === 0) return "";
//     return v;
//   }
//   function readPicker(inputId, textId){
//     var inp = $id(inputId);
//     var v = inp ? realPickerValue(inp.value) : "";
//     if (v) return v;
//     var span = $id(textId);
//     return span ? realPickerValue(span.textContent) : "";
//   }
//   function getSelectedDevice(){
//     var brand = readPicker(BRAND_INPUT_ID, BRAND_TEXT_ID);
//     var device = readPicker(MODEL_INPUT_ID, MODEL_TEXT_ID);
//     if (!brand || !device) return "";
//     return norm(brand + " " + device);
//   }
//   function caseKeyFromLabel(label){
//     var n = norm(label);
//     if (CASE_TYPE_LABEL_TO_KEY[n]) return CASE_TYPE_LABEL_TO_KEY[n];
//     for (var k in CASE_TYPE_LABEL_TO_KEY){
//       if (n.indexOf(k) !== -1) return CASE_TYPE_LABEL_TO_KEY[k];
//     }
//     return null;
//   }
//   function caseAvailable(key, device){
//     if (!key) return false;
//     var list = CASE_TYPE_MODELS[key];
//     return list ? list.indexOf(device) !== -1 : false;
//   }

//   /* -------- 4. STATE / SESSION -------- */
//   var BRAND_DISPLAY = {
//     apple:"Apple", samsung:"Samsung", google:"Google", oneplus:"OnePlus",
//     xiaomi:"Xiaomi", oppo:"OPPO", vivo:"Vivo", realme:"realme",
//     motorola:"Motorola", nothing:"Nothing", honor:"Honor", tecno:"Tecno",
//   };
//   var BRAND_ORDER = ["apple","samsung","google","oneplus","xiaomi","vivo","oppo","realme","motorola","nothing"];
//   function brandDisplay(b){ return BRAND_DISPLAY[b] || (b.charAt(0).toUpperCase() + b.slice(1)); }
//   function titleCaseModel(modelFull, brand){
//     var m = modelFull;
//     if (m.indexOf(brand + " ") === 0) m = m.slice(brand.length + 1);
//     m = m.replace(/\b\w/g, function(c){ return c.toUpperCase(); });
//     m = m.replace(/\bIphone\b/g, "iPhone")
//          .replace(/\bIqoo/g, "iQOO")
//          .replace(/\bSe\b/g, "SE")
//          .replace(/\bXs\b/g, "XS")
//          .replace(/\bXr\b/g, "XR")
//          .replace(/\bFe\b/g, "FE")
//          .replace(/\b5g\b/gi, "5G")
//          .replace(/\b4g\b/gi, "4G")
//          .replace(/\bCmf\b/g, "CMF");
//     return m;
//   }
//   function deviceRank(name){
//     var nums = (name.match(/\d+/g) || []).map(Number).filter(function(n){ return n > 0 && n < 100; });
//     var base = nums.length ? Math.max.apply(null, nums) : 0;
//     if (/galaxy\s+s\d+/i.test(name)) base += 1000;
//     else if (/galaxy\s+note/i.test(name)) base += 900;
//     else if (/galaxy\s+z\s*fold/i.test(name)) base += 850;
//     else if (/galaxy\s+z\s*flip/i.test(name)) base += 800;
//     else if (/galaxy\s+a\d+/i.test(name)) base += 200;
//     else if (/galaxy\s+m\d+/i.test(name)) base += 100;
//     else if (/galaxy\s+f\d+/i.test(name)) base += 50;
//     if (/\bair\b/i.test(name)) base = Math.max(base, 100);
//     if (/ultra/i.test(name)) base += 0.4;
//     else if (/pro\s*max/i.test(name)) base += 0.35;
//     else if (/\bpro\b/i.test(name)) base += 0.2;
//     else if (/\bplus\b/i.test(name)) base += 0.1;
//     if (!nums.length){
//       if (/\bxs\b|\bxr\b/i.test(name)) base = 10.1;
//       else if (/\bx\b/i.test(name)) base = 10;
//       else if (/\bse\b/i.test(name)){
//         var yr = (name.match(/\b(20\d{2})\b/) || [0,0])[1];
//         base = 9 + (yr ? (yr - 2020)/10 : 0);
//       }
//     }
//     return base;
//   }
//   var DEVICE_INDEX = null;
//   function buildIndex(){
//     if (DEVICE_INDEX) return DEVICE_INDEX;
//     var all = {};
//     Object.keys(CASE_TYPE_MODELS).forEach(function(k){
//       CASE_TYPE_MODELS[k].forEach(function(d){ all[d] = true; });
//     });
//     var grouped = {};
//     Object.keys(all).forEach(function(full){
//       var brand = full.split(" ")[0];
//       (grouped[brand] = grouped[brand] || []).push(full);
//     });
//     Object.keys(grouped).forEach(function(b){
//       grouped[b].sort(function(a, c){
//         var ra = deviceRank(a), rc = deviceRank(c);
//         if (ra !== rc) return rc - ra;
//         return a < c ? -1 : a > c ? 1 : 0;
//       });
//     });
//     DEVICE_INDEX = grouped;
//     return grouped;
//   }

//   function loadSessionState(){
//     try {
//       return {
//         brandDisplay: sessionStorage.getItem("bds.brand") || "",
//         modelDisplay: sessionStorage.getItem("bds.model") || "",
//         brandKey:     sessionStorage.getItem("bds.brandKey") || "",
//       };
//     } catch(_e){ return { brandDisplay:"", modelDisplay:"", brandKey:"" }; }
//   }
//   function saveSessionState(){
//     try {
//       sessionStorage.setItem("bds.brand", STATE.brandDisplay || "");
//       sessionStorage.setItem("bds.model", STATE.modelDisplay || "");
//       sessionStorage.setItem("bds.brandKey", STATE.brandKey || "");
//     } catch(_e){}
//   }
//   if (!window.__bdsSTATE) window.__bdsSTATE = loadSessionState();
//   var STATE = window.__bdsSTATE;
//   var currentBrandKey = STATE.brandKey || "";

//   /* -------- 5. UNIFIED DROPDOWN -------- */
//   function ensurePickerStyles(){
//     if ($id("bds-picker-style")) return;
//     var s = document.createElement("style");
//     s.id = "bds-picker-style";
//     s.textContent = [
//       ".brand-device-selector{position:relative;}",
//       ".bds-dropdown{",
//         "position:absolute;top:calc(100% + 8px);left:0;right:0;",
//         "background:#fff;color:#111;border:1px solid #111;border-radius:18px;",
//         "box-shadow:0 16px 40px rgba(0,0,0,.12);z-index:99998;",
//         "display:none;flex-direction:column;max-height:380px;overflow:hidden;",
//         "font-family:inherit;",
//       "}",
//       ".bds-dropdown.open{display:flex;}",
//       ".bds-dropdown__search{padding:10px 12px;border-bottom:1px solid #eee;flex-shrink:0;}",
//       ".bds-dropdown__search input{width:100%;padding:10px 12px;border:1px solid #ddd;border-radius:9999px;font-size:13px;outline:none;box-sizing:border-box;font:inherit;color:#111;background:#fff;}",
//       ".bds-dropdown__search input:focus{border-color:#111;}",
//       ".bds-dropdown__list{overflow-y:auto;padding:6px 8px 10px;flex:1;-webkit-overflow-scrolling:touch;}",
//       ".bds-dropdown__item{",
//         "padding:14px 16px;cursor:pointer;font-size:14px;font-weight:500;color:#111;",
//         "display:flex;align-items:center;justify-content:space-between;line-height:1.3;",
//         "border-radius:9999px;background:#f5f5f5;margin:6px 0;border:1px solid transparent;",
//       "}",
//       ".bds-dropdown__item:hover{background:#eee;}",
//       ".bds-dropdown__item.is-active{background:#fff;border-color:#111;}",
//       ".bds-dropdown__item.latest::after{content:'NEW';margin-left:8px;font-size:9px;padding:2px 6px;background:#111;color:#fff;border-radius:4px;letter-spacing:.5px;}",
//       ".bds-dropdown__empty{padding:18px 14px;text-align:center;color:#999;font-size:13px;}",
//       ".bds-dropdown__header{padding:10px 14px 4px;font-size:10px;letter-spacing:.1em;text-transform:uppercase;color:#999;font-weight:600;}",
//     ].join("");
//     document.head.appendChild(s);
//   }

//   var dropdown = null;
//   var pickerMode = "brand";

//   function ensureDropdown(){
//     if (dropdown && document.body.contains(dropdown)) return dropdown;
//     ensurePickerStyles();
//     var root = $id(ROOT_ID) || $id(BRAND_FIELD_ID) && $id(BRAND_FIELD_ID).closest(".brand-device-selector");
//     if (!root) return null;
//     if (!root.id) root.id = ROOT_ID;
//     if (getComputedStyle(root).position === "static") root.style.position = "relative";
//     var dd = document.createElement("div");
//     dd.className = "bds-dropdown";
//     dd.innerHTML =
//       '<div class="bds-dropdown__search"><input type="text" placeholder="Search..." autocomplete="off"></div>' +
//       '<div class="bds-dropdown__list"></div>';
//     root.appendChild(dd);
//     dd.addEventListener("click", function(e){ e.stopPropagation(); });
//     dd.querySelector("input").addEventListener("input", renderList);
//     dropdown = dd;
//     return dd;
//   }

//   function closeDropdown(){
//     if (dropdown) dropdown.classList.remove("open");
//     var b = $id(BRAND_FIELD_ID), m = $id(MODEL_FIELD_ID);
//     if (b) b.setAttribute("aria-expanded","false");
//     if (m) m.setAttribute("aria-expanded","false");
//   }

//   function openBrand(e){
//     if (e) e.stopPropagation();
//     var dd = ensureDropdown();
//     if (!dd) return;
//     var wasOpen = dd.classList.contains("open") && pickerMode === "brand";
//     closeDropdown();
//     if (wasOpen) return;
//     pickerMode = "brand";
//     var inp = dd.querySelector("input");
//     inp.value = ""; inp.placeholder = "Search brand or device...";
//     renderList();
//     dd.classList.add("open");
//     var b = $id(BRAND_FIELD_ID); if (b) b.setAttribute("aria-expanded","true");
//     setTimeout(function(){ try { inp.focus({ preventScroll: true }); } catch(_e){ inp.focus(); } }, 40);
//   }

//   function openModel(e){
//     if (e) e.stopPropagation();
//     if (!currentBrandKey){ openBrand(); return; }
//     var dd = ensureDropdown();
//     if (!dd) return;
//     var wasOpen = dd.classList.contains("open") && pickerMode === "model";
//     closeDropdown();
//     if (wasOpen) return;
//     pickerMode = "model";
//     var inp = dd.querySelector("input");
//     inp.value = ""; inp.placeholder = "Search device...";
//     renderList();
//     dd.classList.add("open");
//     var m = $id(MODEL_FIELD_ID); if (m) m.setAttribute("aria-expanded","true");
//     setTimeout(function(){ try { inp.focus({ preventScroll: true }); } catch(_e){ inp.focus(); } }, 40);
//   }

//   function renderList(){
//     var dd = ensureDropdown();
//     if (!dd) return;
//     var index = buildIndex();
//     var q = norm(dd.querySelector("input").value);
//     var listEl = dd.querySelector(".bds-dropdown__list");
//     var items = [];
//     if (pickerMode === "brand"){
//       var brands = Object.keys(index);
//       var ordered = [];
//       BRAND_ORDER.forEach(function(b){ if (brands.indexOf(b) !== -1) ordered.push(b); });
//       brands.sort().forEach(function(b){ if (ordered.indexOf(b) === -1) ordered.push(b); });
//       var brandItems = [];
//       ordered.forEach(function(b){
//         var d = brandDisplay(b);
//         if (q && d.toLowerCase().indexOf(q) === -1 && b.indexOf(q) === -1) return;
//         brandItems.push({ type:"brand", key:b, label:d, active:(b === currentBrandKey) });
//       });
//       var deviceItems = [];
//       if (q){
//         ordered.forEach(function(b){
//           var list = index[b] || [];
//           list.forEach(function(full){
//             var label = brandDisplay(b) + " " + titleCaseModel(full, b);
//             if (label.toLowerCase().indexOf(q) === -1 && full.indexOf(q) === -1) return;
//             deviceItems.push({ type:"device", key:full, brand:b, label:label, rank:deviceRank(full) });
//           });
//         });
//         deviceItems.sort(function(a, c){
//           if (a.rank !== c.rank) return c.rank - a.rank;
//           return a.label < c.label ? -1 : a.label > c.label ? 1 : 0;
//         });
//         deviceItems = deviceItems.slice(0, 80);
//       }
//       if (brandItems.length){
//         items.push({ header:"Brands" });
//         items = items.concat(brandItems);
//       }
//       if (deviceItems.length){
//         items.push({ header:"Devices" });
//         items = items.concat(deviceItems);
//       }
//     } else {
//       var list = index[currentBrandKey] || [];
//       var maxRank = 0;
//       list.forEach(function(d){ var r = deviceRank(d); if (r > maxRank) maxRank = r; });
//       var currentModel = norm(STATE.modelDisplay);
//       list.forEach(function(full){
//         var label = titleCaseModel(full, currentBrandKey);
//         if (q && label.toLowerCase().indexOf(q) === -1 && full.indexOf(q) === -1) return;
//         items.push({
//           type:"model",
//           key:full,
//           label:label,
//           latest:Math.floor(deviceRank(full)) >= Math.floor(maxRank),
//           active: norm(label) === currentModel
//         });
//       });
//     }
//     if (!items.length || items.every(function(it){ return it.header; })){
//       listEl.innerHTML = '<div class="bds-dropdown__empty">No matches</div>';
//       return;
//     }
//     var newCount = 0;
//     listEl.innerHTML = items.map(function(it){
//       if (it.header){
//         return '<div class="bds-dropdown__header">' + it.header + '</div>';
//       }
//       var badge = it.latest && newCount < 3 && pickerMode === "model";
//       if (badge) newCount++;
//       var cls = "bds-dropdown__item" + (badge ? " latest" : "") + (it.active ? " is-active" : "");
//       var dataType = it.type || "brand";
//       var dataBrand = it.brand ? ' data-brand="' + it.brand.replace(/"/g, "&quot;") + '"' : "";
//       return '<div class="' + cls + '" data-type="' + dataType + '"' + dataBrand +
//         ' data-key="' + it.key.replace(/"/g, "&quot;") + '"><span>' + it.label + '</span></div>';
//     }).join("");
//   }

//   /* -------- 6. VALUE WRITERS -------- */
//   function setBrandValue(displayName){
//     STATE.brandDisplay = displayName || "";
//     saveSessionState();
//     var sb = $id(BRAND_TEXT_ID), hb = $id(BRAND_INPUT_ID);
//     if (sb) sb.textContent = displayName || "Select Brand";
//     if (hb) hb.value = displayName || "";
//   }
//   function setModelValue(displayName){
//     STATE.modelDisplay = displayName || "";
//     saveSessionState();
//     var sm = $id(MODEL_TEXT_ID), hm = $id(MODEL_INPUT_ID);
//     if (sm) sm.textContent = displayName || "Select Device";
//     if (hm) hm.value = displayName || "";
//   }
//   function restoreStateIfNeeded(){
//     if (STATE.brandKey && !currentBrandKey) currentBrandKey = STATE.brandKey;
//     var sb = $id(BRAND_TEXT_ID), hb = $id(BRAND_INPUT_ID);
//     var sm = $id(MODEL_TEXT_ID), hm = $id(MODEL_INPUT_ID);
//     if (STATE.brandDisplay){
//       if (sb && norm(sb.textContent) !== norm(STATE.brandDisplay)) sb.textContent = STATE.brandDisplay;
//       if (hb && hb.value !== STATE.brandDisplay) hb.value = STATE.brandDisplay;
//     }
//     if (STATE.modelDisplay){
//       if (sm && norm(sm.textContent) !== norm(STATE.modelDisplay)) sm.textContent = STATE.modelDisplay;
//       if (hm && hm.value !== STATE.modelDisplay) hm.value = STATE.modelDisplay;
//     }
//   }

//   /* -------- 7. VARIANT HIDE/UNHIDE  (no save/restore — pure prevention) -------- */
//   var STYLE_ID = "bds-variant-filter-style";
//   function getStyleEl(){
//     var s = $id(STYLE_ID);
//     if (!s){ s = document.createElement("style"); s.id = STYLE_ID; document.head.appendChild(s); }
//     return s;
//   }
//   function readRadioLabel(inp, container){
//     if (inp.getAttribute("aria-label")) return inp.getAttribute("aria-label");
//     if (inp.id){
//       var lbl = (container || document).querySelector('label[for="' + inp.id + '"]');
//       if (lbl){
//         var hidden = lbl.querySelector(".visually-hidden, .sr-only");
//         if (hidden && hidden.textContent.trim()) return hidden.textContent;
//         return lbl.textContent;
//       }
//     }
//     return inp.value;
//   }
//   function findCaseTypeContainers(){
//     var out = [];
//     var fieldsets = document.querySelectorAll(
//       "variant-picker fieldset, .variant-picker fieldset, fieldset.product-form__input"
//     );
//     fieldsets.forEach(function(fs){
//       var legendTxt = norm((fs.querySelector("legend") || {}).textContent || "");
//       var optionName = norm(fs.getAttribute("data-option-name") || "");
//       if (legendTxt.indexOf(CASE_TYPE_OPTION_LABEL) !== -1 ||
//           optionName.indexOf(CASE_TYPE_OPTION_LABEL) !== -1){
//         out.push(fs);
//       }
//     });
//     var swatchLists = document.querySelectorAll(".variant-swatch-list");
//     swatchLists.forEach(function(sl){
//       var inputs = sl.querySelectorAll('input[type="radio"]');
//       for (var i = 0; i < inputs.length; i++){
//         var lbl = readRadioLabel(inputs[i], sl);
//         if (caseKeyFromLabel(lbl)){
//           if (out.indexOf(sl) === -1) out.push(sl);
//           break;
//         }
//       }
//     });
//     return out;
//   }

//   function rebuildVariantCSS(){
//     var device = getSelectedDevice();
//     var style = getStyleEl();
//     if (!device){ style.textContent = ""; return null; }
//     var rules = [];
//     var containers = findCaseTypeContainers();
//     var selectedKey = null;
//     containers.forEach(function(c){
//       var inputs = c.querySelectorAll('input[type="radio"]');
//       inputs.forEach(function(inp){
//         var label = readRadioLabel(inp, c);
//         var key = caseKeyFromLabel(label);
//         var availableForDevice = key && caseAvailable(key, device);
//         if (!availableForDevice){
//           var wrapper =
//             inp.closest(".variant-swatch") ||
//             inp.closest("li") ||
//             inp.closest(".product-form__input-item") ||
//             null;
//           if (wrapper){
//             if (!wrapper.id) wrapper.id = "bds-vsw-" + Math.random().toString(36).slice(2, 8);
//             rules.push("#" + wrapper.id + "{display:none !important;}");
//           } else if (inp.id){
//             rules.push(
//               "#" + (typeof CSS !== "undefined" && CSS.escape ? CSS.escape(inp.id) : inp.id) +
//               ',label[for="' + inp.id + '"]{display:none !important;}'
//             );
//           }
//           if (inp.checked) inp.checked = false;
//         } else if (inp.checked){
//           selectedKey = key;
//         }
//       });
//     });

//     // Auto-select first valid variant if none currently checked.
//     // No scroll save/restore — the focus()/scrollIntoView patches above
//     // already prevent the page from moving.
//     if (!selectedKey){
//       var radioToClick = null;
//       containers.forEach(function(c){
//         if (radioToClick) return;
//         var inputs = c.querySelectorAll('input[type="radio"]');
//         for (var i = 0; i < inputs.length; i++){
//           var inp = inputs[i];
//           var key = caseKeyFromLabel(readRadioLabel(inp, c));
//           if (!key) continue;
//           if (caseAvailable(key, device)){
//             selectedKey = key;
//             radioToClick = inp;
//             break;
//           }
//         }
//       });
//       if (radioToClick && !radioToClick.checked){
//         radioToClick.checked = true;
//         try { radioToClick.dispatchEvent(new Event("input",  { bubbles: true })); } catch(_e){}
//         try { radioToClick.dispatchEvent(new Event("change", { bubbles: true })); } catch(_e){}
//       }
//     }
//     style.textContent = rules.join("\n");
//     return selectedKey;
//   }

//   /* -------- 8. IMAGE GALLERY FILTER -------- */
//   function getCurrentCaseKey(){
//     var containers = findCaseTypeContainers();
//     for (var i = 0; i < containers.length; i++){
//       var checked = containers[i].querySelector('input[type="radio"]:checked');
//       if (!checked) continue;
//       var k = caseKeyFromLabel(readRadioLabel(checked, containers[i]));
//       if (k) return k;
//     }
//     return null;
//   }

//   function findFlickity(el){
//     while (el){
//       if (el.flickity && typeof el.flickity.reloadCells === "function") return el.flickity;
//       if (window.Flickity && typeof window.Flickity.data === "function"){
//         var inst = window.Flickity.data(el);
//         if (inst) return inst;
//       }
//       el = el.parentElement;
//     }
//     return null;
//   }

//   function applyFlickityFilter(caseKey){
//     var pattern = caseKey ? IMAGE_PATTERN_BY_KEY[caseKey] : null;

//     document.querySelectorAll(".product__media-item").forEach(function(item){
//       var img = item.querySelector("img");
//       var src = img && (img.getAttribute("src") || img.getAttribute("data-src") ||
//                         img.getAttribute("data-original") || img.getAttribute("srcset")) || "";
//       var keep = !pattern || (src && pattern.test(src));
//       item.classList.toggle("is-filtered", !keep);
//       if (!keep) item.style.display = "none";
//       else item.style.display = "";
//     });

//     document.querySelectorAll(".product__thumbnail-item").forEach(function(item){
//       var img = item.querySelector("img");
//       var src = img && (img.getAttribute("src") || img.getAttribute("data-src") ||
//                         img.getAttribute("data-original") || img.getAttribute("srcset")) || "";
//       var keep = !pattern || (src && pattern.test(src));
//       item.style.display = keep ? "" : "none";
//     });

//     document.querySelectorAll(
//       ".product-media-list__item, .media-gallery__item, [data-media-id]"
//     ).forEach(function(item){
//       if (item.classList.contains("product__media-item") ||
//           item.classList.contains("product__thumbnail-item")) return;
//       var img = item.querySelector("img");
//       if (!img) return;
//       if (img.classList.contains("variant-swatch__image")) return;
//       if (img.closest(".variant-swatch-list, .variant-swatch, .product-sticky-form")) return;
//       var src = img.getAttribute("src") || img.getAttribute("data-src") ||
//                 img.getAttribute("data-original") || img.getAttribute("srcset") || "";
//       var keep = !pattern || (src && pattern.test(src));
//       item.style.display = keep ? "" : "none";
//     });

//     document.querySelectorAll("flickity-carousel, .flickity-enabled").forEach(function(fc){
//       var inst = findFlickity(fc);
//       if (!inst) return;
//       try {
//         if (typeof inst.reloadCells === "function") inst.reloadCells();
//         if (typeof inst.resize === "function") inst.resize();
//         var selected = inst.selectedElement;
//         if (!selected || selected.classList.contains("is-filtered")){
//           if (typeof inst.select === "function") inst.select(0, false, true);
//         }
//         if (typeof fc.reposition === "function") fc.reposition();
//         if (typeof fc.resize === "function") fc.resize();
//       } catch (_e) {}
//     });
//   }

//   /* -------- 9. CHANGE PIPELINE -------- */
//   function applyChange(force){
//     restoreStateIfNeeded();
//     var device = getSelectedDevice();
//     if (force || device !== applyChange._lastDevice){
//       applyChange._lastDevice = device;
//       rebuildVariantCSS();
//     } else {
//       if (variantDomLooksFresh()) rebuildVariantCSS();
//     }
//     applyFlickityFilter(getCurrentCaseKey());
//   }
//   applyChange._lastDevice = "__none__";

//   function variantDomLooksFresh(){
//     var containers = findCaseTypeContainers();
//     for (var i = 0; i < containers.length; i++){
//       var wrappers = containers[i].querySelectorAll(".variant-swatch, li, .product-form__input-item");
//       for (var j = 0; j < wrappers.length; j++){
//         if (wrappers[j].id && wrappers[j].id.indexOf("bds-vsw-") === 0) return false;
//       }
//       if (wrappers.length > 0) return true;
//     }
//     return false;
//   }

//   /* -------- 10. EVENT WIRING -------- */
//   function bindPickers(){
//     var b = $id(BRAND_FIELD_ID);
//     var m = $id(MODEL_FIELD_ID);
//     if (b && !b.__bdsBound){
//       b.__bdsBound = true;
//       b.addEventListener("click", openBrand);
//       b.addEventListener("keydown", function(e){
//         if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openBrand(); }
//       });
//     }
//     if (m && !m.__bdsBound){
//       m.__bdsBound = true;
//       m.addEventListener("click", openModel);
//       m.addEventListener("keydown", function(e){
//         if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openModel(); }
//       });
//     }

//     if (!window.__bdsCaptureBound){
//       window.__bdsCaptureBound = true;
//       document.addEventListener("click", function(e){
//         var item = e.target.closest && e.target.closest(".bds-dropdown__item");
//         if (!item) return;
//         var key = item.getAttribute("data-key");
//         if (!key) return;
//         var type = item.getAttribute("data-type") || (pickerMode === "model" ? "model" : "brand");

//         if (type === "device"){
//           var brandKey = item.getAttribute("data-brand") || key.split(" ")[0];
//           currentBrandKey = brandKey;
//           STATE.brandKey = brandKey;
//           saveSessionState();
//           setBrandValue(brandDisplay(brandKey));
//           setModelValue(titleCaseModel(key, brandKey));
//           applyChange(true);
//           closeDropdown();
//           return;
//         }

//         if (type === "brand" || pickerMode === "brand"){
//           currentBrandKey = key;
//           STATE.brandKey = key;
//           saveSessionState();
//           setBrandValue(brandDisplay(key));
//           setModelValue("");
//           applyChange(true);
//           closeDropdown();
//           openModel();
//           return;
//         }

//         setModelValue(titleCaseModel(key, currentBrandKey));
//         applyChange(true);
//         closeDropdown();
//       }, true);
//     }

//     if (!window.__bdsOutsideBound){
//       window.__bdsOutsideBound = true;
//       document.addEventListener("click", function(e){
//         var inside = e.target.closest && (
//           e.target.closest(".brand-device-selector") || e.target.closest(".bds-dropdown")
//         );
//         if (!inside) closeDropdown();
//       });
//       document.addEventListener("keydown", function(e){
//         if (e.key === "Escape") closeDropdown();
//       });
//     }
//     restoreStateIfNeeded();
//   }

//   function bindVariantWatchers(){
//     findCaseTypeContainers().forEach(function(c){
//       if (c.__bdsBound) return;
//       c.__bdsBound = true;
//       c.addEventListener("change", function(){
//         setTimeout(function(){ applyChange(true); }, 0);
//         setTimeout(function(){ applyChange(true); }, 80);
//         setTimeout(function(){ applyChange(true); }, 250);
//       });
//       c.addEventListener("click", function(){
//         setTimeout(function(){ applyChange(true); }, 50);
//         setTimeout(function(){ applyChange(true); }, 200);
//       });
//     });

//     document.querySelectorAll("variant-picker, .variant-picker, product-rerender").forEach(function(node){
//       if (node.__bdsObserved) return;
//       node.__bdsObserved = true;
//       new MutationObserver(function(){
//         bindVariantWatchers();
//         applyChange(true);
//       }).observe(node, { childList: true, subtree: true });
//     });
//   }

//   /* -------- 11. INIT -------- */
//   function init(){
//     bindPickers();
//     bindVariantWatchers();
//     applyChange(true);

//     if (!window.__bdsPoll){
//       window.__bdsPoll = true;
//       setInterval(function(){
//         bindPickers();
//         bindVariantWatchers();
//         applyChange(false);
//       }, 500);
//     }

//     if (!document.body.__bdsObs){
//       document.body.__bdsObs = true;
//       new MutationObserver(function(){
//         bindPickers();
//         bindVariantWatchers();
//       }).observe(document.body, { childList: true, subtree: true });
//     }
//   }

//   if (document.readyState === "loading"){
//     document.addEventListener("DOMContentLoaded", init);
//   } else {
//     init();
//   }

//   window.__bdsRefresh = function(){ applyChange(true); };
//   window.__bdsGetDevice = getSelectedDevice;
//   window.__bdsGetCase = getCurrentCaseKey;
//   window.__bdsGetState = function(){ return JSON.parse(JSON.stringify(STATE)); };
// })();

// /* ============== Variant price labels (unchanged) ============== */
// window.__bdsPriceInit = window.__bdsPriceInit || (function(){
//   "use strict";

//   function getHandle(){
//     var m = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
//     if (m) return m;
//     var n = document.querySelector("[product-handle],[data-product-handle],variant-picker[handle]");
//     return n && (n.getAttribute("product-handle") || n.getAttribute("data-product-handle") || n.getAttribute("handle"));
//   }
//   function norm(s){ return String(s||"").toLowerCase().replace(/\s+/g," ").trim(); }
//   function formatPrice(cents){
//     var amount = (Number(cents) || 0) / 100;
//     var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || "INR";
//     try {
//       return new Intl.NumberFormat(undefined, {
//         style: "currency", currency: currency,
//         maximumFractionDigits: amount % 1 === 0 ? 0 : 2,
//       }).format(amount);
//     } catch(e){
//       return "Rs. " + (amount % 1 === 0 ? amount : amount.toFixed(2));
//     }
//   }
//   var PRICES_BY_TITLE = null;
//   var isRendering = false;
//   function loadPrices(){
//     if (PRICES_BY_TITLE) return Promise.resolve(PRICES_BY_TITLE);
//     var handle = getHandle();
//     if (!handle){ console.warn("[variant-prices] no handle"); return Promise.resolve({}); }
//     return fetch("/products/" + handle + ".js", { credentials: "same-origin" })
//       .then(function(r){ return r.ok ? r.json() : null; })
//       .then(function(json){
//         var map = {};
//         if (json && json.variants){
//           json.variants.forEach(function(v){
//             if (v.title)    map[norm(v.title)]    = v.price;
//             if (v.option1)  map[norm(v.option1)]  = v.price;
//             if (v.option2)  map[norm(v.option2)]  = v.price;
//             if (v.option3)  map[norm(v.option3)]  = v.price;
//             if (v.name){
//               var parts = v.name.split(" - ");
//               map[norm(parts[parts.length - 1])] = v.price;
//             }
//           });
//         }
//         PRICES_BY_TITLE = map;
//         return map;
//       })
//       .catch(function(err){ console.error("[variant-prices] fetch failed", err); return {}; });
//   }
//   function getRadioLabel(input){
//     return input.getAttribute("aria-label") ||
//            (input.id && (document.querySelector('label[for="' + input.id + '"] .visually-hidden')
//                 || document.querySelector('label[for="' + input.id + '"]')) || {}).textContent ||
//            input.value;
//   }
//   function renderPrices(){
//     if (!PRICES_BY_TITLE || isRendering) return;
//     isRendering = true;
//     try {
//       document.querySelectorAll(".variant-swatch-list .variant-swatch").forEach(function(sw){
//         var input = sw.querySelector('input[type="radio"]');
//         if (!input) return;
//         var label = norm(getRadioLabel(input));
//         var cents = PRICES_BY_TITLE[label];
//         if (cents == null) return;
//         var text = formatPrice(cents);
//         var el = sw.querySelector(".bds-card-price");
//         if (!el){
//           el = document.createElement("div");
//           el.className = "bds-card-price";
//           sw.appendChild(el);
//         }
//         if (el.textContent !== text) el.textContent = text;
//       });
//     } finally {
//       isRendering = false;
//     }
//   }
//   function start(){
//     loadPrices().then(renderPrices);
//     new MutationObserver(function(){
//       if (isRendering) return;
//       renderPrices();
//     }).observe(document.body, { childList: true, subtree: true });
//     document.addEventListener("change", function(e){
//       if (e.target && e.target.matches && e.target.matches('.variant-swatch-list input[type="radio"]')){
//         setTimeout(renderPrices, 50);
//       }
//     });
//   }
//   if (document.readyState === "loading"){
//     document.addEventListener("DOMContentLoaded", start);
//   } else {
//     start();
//   }
//   return true;
// })();
// working wiht 2 lines
// (function installAntiScrollPatches(){
//   if (window.__bdsAntiScrollPatched) return;
//   window.__bdsAntiScrollPatched = true;

//   // 1) Patch focus() so any radio (anywhere) gets preventScroll:true by
//   //    default.  Other elements behave normally unless they're inside a
//   //    variant picker, in which case they also get preventScroll.
//   try {
//     var origFocus = HTMLElement.prototype.focus;
//     HTMLElement.prototype.focus = function(opts){
//       try {
//         var inVariant = this && this.closest && this.closest(
//           'variant-picker, .variant-picker, .variant-swatch-list, ' +
//           '.variant-swatch, fieldset.product-form__input, product-rerender'
//         );
//         var isRadio = this && this.tagName === 'INPUT' && this.type === 'radio';
//         if (isRadio || inVariant){
//           var merged = opts && typeof opts === 'object'
//             ? Object.assign({}, opts, { preventScroll: true })
//             : { preventScroll: true };
//           return origFocus.call(this, merged);
//         }
//       } catch(_e){}
//       return origFocus.call(this, opts);
//     };
//   } catch(_e){}

//   // 2) No-op scrollIntoView for anything inside the variant picker subtree.
//   try {
//     var origSIV = Element.prototype.scrollIntoView;
//     Element.prototype.scrollIntoView = function(arg){
//       try {
//         if (this.closest && this.closest(
//           'variant-picker, .variant-picker, .variant-swatch-list, ' +
//           '.variant-swatch, fieldset.product-form__input, product-rerender'
//         )) {
//           return; // suppress
//         }
//       } catch(_e){}
//       return origSIV.call(this, arg);
//     };
//   } catch(_e){}

//   // 3) CSS: disable scroll anchoring + reposition hidden radios behind
//   //    their swatch so focusing them does not jump the viewport.
//   function injectCSS(){
//     if (document.getElementById('bds-anti-scroll-css')) return;
//     var s = document.createElement('style');
//     s.id = 'bds-anti-scroll-css';
//     s.textContent = [
//       'html,body{overflow-anchor:none !important;}',
//       '.variant-swatch{position:relative;}',
//       '.variant-swatch input[type="radio"],',
//       '.variant-swatch-list input[type="radio"]{',
//         'position:absolute !important;',
//         'top:0 !important;left:0 !important;right:0 !important;bottom:0 !important;',
//         'width:100% !important;height:100% !important;',
//         'margin:0 !important;padding:0 !important;',
//         'opacity:0 !important;',
//         'clip:auto !important;clip-path:none !important;',
//         'pointer-events:none !important;',
//         'scroll-margin:0 !important;scroll-margin-top:0 !important;',
//       '}',
//       'variant-picker *,.variant-picker *,.variant-swatch-list *{scroll-margin:0 !important;}',
//     ].join('');
//     (document.head || document.documentElement).appendChild(s);
//   }
//   if (document.head) injectCSS();
//   else document.addEventListener('DOMContentLoaded', injectCSS);
// })();

// /* ====== Pre-existing IIFE-wrap guard (kept verbatim) ====== */
// (function(){
//   if (window.__bdsRerenderFix) return;
//   window.__bdsRerenderFix = true;
//   window.__bdsDeliveryDateFix = true;

//   function maybeWrap(node){
//     if (!node || node.nodeType !== 1) return;
//     var html = node.outerHTML;
//     if (!html || (html.indexOf("let ") === -1 && html.indexOf("const ") === -1)) return;
//     var scripts = node.tagName === "SCRIPT" ? [node] : node.querySelectorAll('script:not([src])');
//     for (var i = 0; i < scripts.length; i++){
//       var s = scripts[i], t = s.textContent;
//       if (!t || s.dataset.bdsWrapped) continue;
//       if (!/\b(let|const)\s+[A-Za-z_$]/.test(t)) continue;
//       s.textContent = "(function(){\ntry{\n" + t + "\n}catch(e){console.debug('[rerender-fix]',e.message);}\n})();";
//       s.dataset.bdsWrapped = "1";
//     }
//   }
//   function wrap(fnName){
//     var orig = Element.prototype[fnName];
//     if (!orig) return;
//     Element.prototype[fnName] = function(){
//       for (var i = 0; i < arguments.length; i++) maybeWrap(arguments[i]);
//       try { return orig.apply(this, arguments); }
//       catch(err){
//         if (err && /has already been declared/.test(String(err.message || err))) {
//           console.debug("[rerender-fix] suppressed", err.message);
//           return;
//         }
//         throw err;
//       }
//     };
//   }
//   wrap('replaceWith'); wrap('append'); wrap('after');
// })();

// (function () {
//   "use strict";

//   /* -------- 1. CONFIG -------- */
//   var BRAND_INPUT_ID  = "hiddenBrand";
//   var MODEL_INPUT_ID  = "hiddenModel";
//   var BRAND_TEXT_ID   = "selectedBrand";
//   var MODEL_TEXT_ID   = "selectedModel";
//   var BRAND_FIELD_ID  = "brandSelector";
//   var MODEL_FIELD_ID  = "modelSelector";
//   var ROOT_ID         = "bdsRoot";
//   var BRAND_PLACEHOLDER = "select brand";
//   var MODEL_PLACEHOLDER = "select device";

//   var CASE_TYPE_OPTION_LABEL = "case type";

//   var CASE_TYPE_LABEL_TO_KEY = {
//     "glossy double layer": "tough",
//     "glossy double layer case": "tough",
//     "glossy single layer": "snap",
//     "glossy single layer case": "snap",
//     "snap": "snap",
//     "snap case": "snap",
//     "hard": "hard",
//     "hard case": "hard",
//     "glass": "glass",
//     "glass case": "glass",
//   };

//   var IMAGE_PATTERN_BY_KEY = {
//     "tough": /-A\d+\./i,
//     "snap":  /angle-/i,
//     "hard":  /-G\d+\./i,
//     "glass": /-G\d+\./i,
//   };

//   /* -------- 2. STOCK DATA -------- */
//   var CASE_TYPE_MODELS = {
//     "hard": ["apple iphone 11","apple iphone 11 pro","apple iphone 11 pro max","apple iphone 12","apple iphone 12 mini","apple iphone 12 pro","apple iphone 12 pro max","apple iphone 13","apple iphone 13 mini","apple iphone 13 pro","apple iphone 13 pro max","apple iphone 14","apple iphone 14 plus","apple iphone 14 pro","apple iphone 14 pro max","apple iphone 15","apple iphone 15 plus","apple iphone 15 pro","apple iphone 15 pro max","apple iphone 16","apple iphone 16 plus","apple iphone 16 pro","apple iphone 16 pro max","apple iphone 16e","apple iphone 17","apple iphone 17 pro","apple iphone 17 pro max","apple iphone 17e","apple iphone 7","apple iphone 7 plus","apple iphone 8","apple iphone 8 plus","apple iphone air","apple iphone se 2020","apple iphone se 2022","apple iphone x","apple iphone xr","apple iphone xs","apple iphone xs max","google pixel 10","google pixel 10 pro","google pixel 10 pro xl","google pixel 10a","google pixel 6","google pixel 6 pro","google pixel 6a","google pixel 7","google pixel 7 pro","google pixel 7a","google pixel 8","google pixel 8 pro","google pixel 8a","google pixel 9","google pixel 9 pro","google pixel 9 pro xl","google pixel 9a","motorola edge 30","motorola edge 30 fusion","motorola edge 30 ultra","motorola edge 40","motorola edge 40 neo","motorola edge 50","motorola edge 50 fusion","motorola edge 50 pro","motorola edge 50 ultra","motorola edge 60 fusion","motorola edge 60 pro","motorola edge 70","motorola edge 70 fusion","motorola g96","motorola moto g45","motorola moto g54","motorola moto g64","motorola moto g84","motorola moto g85 5g","nothing cmf phone 1","nothing cmf phone 2 pro","nothing phone 1","nothing phone 2","nothing phone 2a","nothing phone 2a plus","nothing phone 3","nothing phone 3a","nothing phone 3a lite","nothing phone 3a pro","nothing phone 4a","nothing phone 4a pro","oneplus 10 pro 5g","oneplus 10r","oneplus 10t 5g","oneplus 11 5g","oneplus 11r 5g","oneplus 12","oneplus 12r","oneplus 13","oneplus 13r","oneplus 13s","oneplus 15","oneplus 15r","oneplus 6","oneplus 6t","oneplus 7","oneplus 7 pro","oneplus 7t","oneplus 7t pro","oneplus 8","oneplus 8 pro","oneplus 8t","oneplus 9","oneplus 9 pro","oneplus 9r","oneplus 9rt","oneplus ace 2v","oneplus ace racing","oneplus nord","oneplus nord 2","oneplus nord 2t 5g","oneplus nord 3 5g","oneplus nord 4","oneplus nord 5","oneplus nord ce 2 5g","oneplus nord ce 2 lite 5g","oneplus nord ce 3 5g","oneplus nord ce 3 lite","oneplus nord ce 4","oneplus nord ce 5g","oneplus nord ce4 lite 5g","oneplus nord ce5","oppo a11","oppo a11x","oppo a3 pro","oppo a5 2020","oppo a5 pro","oppo a59","oppo a73 2020","oppo a74","oppo a78 5g","oppo a9 2020","oppo a91","oppo a93","oppo f11 pro","oppo f15","oppo f17","oppo f17 pro","oppo f19","oppo f19 pro","oppo f19 pro plus","oppo f21 pro 4g","oppo f21 pro 5g","oppo f21s pro 4g","oppo f21s pro 5g","oppo f25 pro 5g","oppo f27 pro plus","oppo f29","oppo f29 pro","oppo f31 5g","oppo f31 pro 5g","oppo f31 pro plus 5g","oppo find x8","oppo find x8 pro","oppo find x9","oppo find x9 pro","oppo k12","oppo k13","oppo k13 turbo 5g","oppo k13 turbo pro 5g","oppo k3","oppo k5","oppo reno 10 5g","oppo reno 10 pro 5g","oppo reno 10 pro plus 5g","oppo reno 10x zoom","oppo reno 11","oppo reno 11 pro","oppo reno 12 5g","oppo reno 12 pro 5g","oppo reno 14","oppo reno 14 pro","oppo reno 15","oppo reno 15 pro","oppo reno 15 pro mini","oppo reno 15c","oppo reno 2","oppo reno 2f","oppo reno 2z","oppo reno 3","oppo reno 3 pro international","oppo reno 4 lite","oppo reno 4 pro","oppo reno 4f","oppo reno 5 pro","oppo reno 6 5g","oppo reno 6 pro 5g","oppo reno 7 5g","oppo reno 7 pro 5g","oppo reno 8 5g","oppo reno 8 pro 5g","oppo reno 8t 5g","oppo reno ace","oppo reno13","oppo reno13 pro","realme 10 pro 5g","realme 10 pro plus 5g","realme 11 5g","realme 11 pro","realme 11 pro plus","realme 11x 5g","realme 12","realme 12 plus","realme 12 pro 5g","realme 12 pro plus 5g","realme 12x","realme 13","realme 13 pro","realme 13 pro plus","realme 14 pro","realme 14 pro plus","realme 14x","realme 15","realme 15 pro","realme 3 pro","realme 5","realme 5 pro","realme 5s","realme 6","realme 6 pro","realme 6i","realme 6s","realme 7","realme 7 pro","realme 8","realme 8 5g","realme 8 pro","realme 8s 5g","realme 9 4g","realme 9 5g","realme 9 5g speed edition","realme 9 pro 5g","realme 9 pro plus 5g","realme 9i 4g","realme c65 5g","realme c75","realme gt 2","realme gt 2 pro","realme gt 5g","realme gt 6","realme gt 6t","realme gt 7","realme gt 7 pro","realme gt 7t","realme gt neo 2","realme gt neo 3","realme gt neo 3t","realme gt neo 6","realme gt neo 6 se","realme narzo 10","realme narzo 20 pro","realme narzo 30 5g","realme narzo 50 pro","realme narzo 60 pro","realme narzo 60x 5g","realme narzo 70","realme narzo 70 pro","realme narzo 70x","realme neo7x","realme p1","realme p1 pro","realme p2 pro","realme p3","realme p3 pro","realme p3 ultra","realme v60 pro","realme x","realme x lite","realme x2","realme x2 pro","realme x50 pro","realme x7","realme x7 max 5g","realme x7 pro","realme xt","samsung galaxy a02s","samsung galaxy a06","samsung galaxy a10","samsung galaxy a10s","samsung galaxy a11","samsung galaxy a12","samsung galaxy a14 5g","samsung galaxy a15 5g","samsung galaxy a16","samsung galaxy a17","samsung galaxy a20","samsung galaxy a22 4g","samsung galaxy a22 5g","samsung galaxy a23 5g","samsung galaxy a25 5g","samsung galaxy a26","samsung galaxy a27","samsung galaxy a30","samsung galaxy a30s","samsung galaxy a31","samsung galaxy a32 4g","samsung galaxy a32 5g","samsung galaxy a33 5g","samsung galaxy a34 5g","samsung galaxy a35 5g","samsung galaxy a36","samsung galaxy a37","samsung galaxy a40","samsung galaxy a40s","samsung galaxy a50","samsung galaxy a50s","samsung galaxy a51","samsung galaxy a52","samsung galaxy a52 5g","samsung galaxy a52s 5g","samsung galaxy a53 5g","samsung galaxy a54 5g","samsung galaxy a55 5g","samsung galaxy a56","samsung galaxy a57","samsung galaxy a60","samsung galaxy a70","samsung galaxy a70s","samsung galaxy a71","samsung galaxy a72","samsung galaxy a73 5g","samsung galaxy a81","samsung galaxy a91","samsung galaxy f02s","samsung galaxy f06 5g","samsung galaxy f07","samsung galaxy f12","samsung galaxy f14 5g","samsung galaxy f15","samsung galaxy f16","samsung galaxy f17","samsung galaxy f22","samsung galaxy f23 5g","samsung galaxy f34 5g","samsung galaxy f36","samsung galaxy f41","samsung galaxy f42 5g","samsung galaxy f54 5g","samsung galaxy f55","samsung galaxy f56 5g","samsung galaxy f62","samsung galaxy fold 6 back","samsung galaxy fold 6 front","samsung galaxy m02s","samsung galaxy m06","samsung galaxy m07","samsung galaxy m10","samsung galaxy m10s","samsung galaxy m11","samsung galaxy m12","samsung galaxy m14","samsung galaxy m16","samsung galaxy m20","samsung galaxy m21","samsung galaxy m21 2021","samsung galaxy m30","samsung galaxy m30s","samsung galaxy m31","samsung galaxy m31 prime","samsung galaxy m31s","samsung galaxy m32","samsung galaxy m32 5g","samsung galaxy m33 5g","samsung galaxy m34 5g","samsung galaxy m35","samsung galaxy m36","samsung galaxy m40","samsung galaxy m51","samsung galaxy m52 5g","samsung galaxy m53 5g","samsung galaxy m54 5g","samsung galaxy m55","samsung galaxy m56","samsung galaxy m62","samsung galaxy note 10","samsung galaxy note 10 lite","samsung galaxy note 10 plus","samsung galaxy note 20","samsung galaxy note 20 ultra","samsung galaxy note 9","samsung galaxy s10","samsung galaxy s10 lite","samsung galaxy s10 plus","samsung galaxy s10e","samsung galaxy s20","samsung galaxy s20 fe","samsung galaxy s20 fe 5g","samsung galaxy s20 plus","samsung galaxy s20 ultra","samsung galaxy s21","samsung galaxy s21 plus","samsung galaxy s21 ultra","samsung galaxy s21fe","samsung galaxy s22 5g","samsung galaxy s22 plus 5g","samsung galaxy s22 ultra 5g","samsung galaxy s23","samsung galaxy s23 plus","samsung galaxy s23 ultra","samsung galaxy s23fe","samsung galaxy s24","samsung galaxy s24 fe","samsung galaxy s24 plus","samsung galaxy s24 ultra","samsung galaxy s25","samsung galaxy s25 edge","samsung galaxy s25 fe","samsung galaxy s25 plus","samsung galaxy s25 ultra","samsung galaxy s26","samsung galaxy s26 plus","samsung galaxy s26 ultra","samsung galaxy s8","samsung galaxy s8 plus","samsung galaxy s9","samsung galaxy s9 plus","samsung galaxy z flip 3 5g bottom","samsung galaxy z flip 3 5g top","samsung galaxy z flip 4 bottom","samsung galaxy z flip 4 top","samsung galaxy z flip 5 bottom","samsung galaxy z flip 5 top","samsung galaxy z flip 6 bottom","samsung galaxy z flip 6 top","samsung galaxy z flip 7 bottom","samsung galaxy z flip 7 top","samsung galaxy z fold 3 5g back","samsung galaxy z fold 3 5g front","samsung galaxy z fold 4 back","samsung galaxy z fold 4 front","samsung galaxy z fold 5 back","samsung galaxy z fold 5 front","samsung galaxy z fold 7 back","samsung galaxy z fold 7 front","vivo iqoo 10","vivo iqoo 11","vivo iqoo 12","vivo iqoo 13","vivo iqoo 15","vivo iqoo 3","vivo iqoo 7","vivo iqoo 7 legend 5g","vivo iqoo 8 5g","vivo iqoo 9 5g","vivo iqoo 9 5g international","vivo iqoo 9 pro 5g","vivo iqoo 9 se 5g","vivo iqoo 9t 5g","vivo iqoo neo 10","vivo iqoo neo 10r","vivo iqoo neo 5","vivo iqoo neo 5 s","vivo iqoo neo 6 5g","vivo iqoo neo 7","vivo iqoo neo9","vivo iqoo neo9 pro","vivo iqoo u5e","vivo iqoo z10","vivo iqoo z10r 5g","vivo iqoo z10x","vivo iqoo z3","vivo iqoo z5","vivo iqoo z6","vivo iqoo z6 pro 5g","vivo iqoo z7 international","vivo iqoo z7 pro 5g","vivo iqoo z9","vivo iqoo z9 lite","vivo iqoo z9s","vivo iqoo z9s pro","vivo iqooz9x","vivo s1","vivo s1 pro","vivo s10e","vivo s15 pro","vivo s15e","vivo s18","vivo s18 pro","vivo s7","vivo t1 5g","vivo t1 pro 5g","vivo t2 pro 5g","vivo t3","vivo t3 5g","vivo t3 pro","vivo t3 ultra","vivo t4","vivo t4x","vivo v15 pro","vivo v17","vivo v17 pro","vivo v19","vivo v20","vivo v20 pro","vivo v20 se","vivo v21","vivo v21e","vivo v23 5g","vivo v23 pro 5g","vivo v23e 5g","vivo v25 5g","vivo v25 pro 5g","vivo v27","vivo v27 pro","vivo v27e","vivo v29","vivo v29 pro","vivo v29e","vivo v30","vivo v30 pro","vivo v30e","vivo v40","vivo v40 pro","vivo v40e","vivo v50","vivo v60","vivo v60e","vivo v70","vivo v70 elite","vivo v70 fe","vivo x100","vivo x100 pro","vivo x200","vivo x200 fe","vivo x200 pro","vivo x300","vivo x300 pro","vivo x60","vivo x60 pro","vivo x70","vivo x70 pro","vivo x80 5g","vivo x80 pro 5g","vivo x90","vivo x90 pro","vivo y100","vivo y200","vivo y200 pro","vivo y200e","vivo y22","vivo y22s","vivo y28s","vivo y29","vivo y30 5g","vivo y300","vivo y300 plus","vivo y33e","vivo y33s 5g","vivo y35","vivo y52t","vivo y55 5g","vivo y56 5g","vivo y58","vivo y73","vivo y75 5g","vivo z1 pro","vivo z1x","xiaomi 11 lite","xiaomi 11 lite ne 5g","xiaomi 11i 5g","xiaomi 11i hypercharge 5g","xiaomi 11t pro 5g","xiaomi 12 lite 5g","xiaomi 12 pro 5g","xiaomi 13 pro","xiaomi 14","xiaomi 14 civi","xiaomi 14 ultra","xiaomi 15","xiaomi 15 ultra","xiaomi 17","xiaomi 17 ultra","xiaomi mi 10i","xiaomi mi 10t","xiaomi mi 10t pro","xiaomi mi 11 ultra","xiaomi mi 11x","xiaomi mi 11x pro","xiaomi mi a3","xiaomi mi note 10 international","xiaomi poco f1","xiaomi poco f3","xiaomi poco f3 gt","xiaomi poco f4 5g","xiaomi poco f6","xiaomi poco m2 pro","xiaomi poco m3 pro 5g","xiaomi poco x2","xiaomi poco x3","xiaomi poco x3 pro","xiaomi poco x4 pro 5g","xiaomi redmi 13 5g","xiaomi redmi 13c 5g","xiaomi redmi 15 5g","xiaomi redmi 15c 5g","xiaomi redmi 7a","xiaomi redmi 9 power","xiaomi redmi 9t","xiaomi redmi k20","xiaomi redmi k20 pro","xiaomi redmi k30","xiaomi redmi k50i","xiaomi redmi note 10","xiaomi redmi note 10 5g","xiaomi redmi note 10 lite","xiaomi redmi note 10 pro","xiaomi redmi note 10 pro max","xiaomi redmi note 10s","xiaomi redmi note 10t 5g","xiaomi redmi note 11","xiaomi redmi note 11 international","xiaomi redmi note 11 pro","xiaomi redmi note 11 pro 5g international","xiaomi redmi note 11 pro plus 5g","xiaomi redmi note 11 pro plus 5g international","xiaomi redmi note 11s","xiaomi redmi note 11t 5g","xiaomi redmi note 11t pro","xiaomi redmi note 11t pro plus","xiaomi redmi note 12 5g","xiaomi redmi note 12 pro","xiaomi redmi note 12 pro plus","xiaomi redmi note 13","xiaomi redmi note 13 pro","xiaomi redmi note 13 pro plus","xiaomi redmi note 14","xiaomi redmi note 14 pro","xiaomi redmi note 14 pro plus","xiaomi redmi note 15","xiaomi redmi note 15 pro","xiaomi redmi note 15 pro plus","xiaomi redmi note 7","xiaomi redmi note 7 pro","xiaomi redmi note 7s","xiaomi redmi note 8","xiaomi redmi note 8 pro","xiaomi redmi note 9","xiaomi redmi note 9 pro","xiaomi redmi note 9 pro max","xiaomi redmi note 9s"],
//     "snap": ["apple iphone 11","apple iphone 11 pro","apple iphone 11 pro max","apple iphone 12","apple iphone 12 mini","apple iphone 12 pro","apple iphone 12 pro max","apple iphone 13","apple iphone 13 mini","apple iphone 13 pro","apple iphone 13 pro max","apple iphone 14","apple iphone 14 plus","apple iphone 14 pro","apple iphone 14 pro max","apple iphone 15","apple iphone 15 plus","apple iphone 15 pro","apple iphone 15 pro max","apple iphone 16","apple iphone 16 plus","apple iphone 16 pro","apple iphone 16 pro max","apple iphone 16e","apple iphone 17","apple iphone 17 pro","apple iphone 17 pro max","apple iphone 17e","apple iphone air","samsung galaxy s23","samsung galaxy s23 plus","samsung galaxy s23 ultra","samsung galaxy s24","samsung galaxy s24 plus","samsung galaxy s24 ultra","samsung galaxy s25","samsung galaxy s25 plus","samsung galaxy s25 ultra","samsung galaxy s26","samsung galaxy s26 plus","samsung galaxy s26 ultra"],
//     "tough": ["apple iphone 11","apple iphone 11 pro","apple iphone 11 pro max","apple iphone 12","apple iphone 12 mini","apple iphone 12 pro","apple iphone 12 pro max","apple iphone 13","apple iphone 13 mini","apple iphone 13 pro","apple iphone 13 pro max","apple iphone 14","apple iphone 14 plus","apple iphone 14 pro","apple iphone 14 pro max","apple iphone 15","apple iphone 15 plus","apple iphone 15 pro","apple iphone 15 pro max","apple iphone 16","apple iphone 16 plus","apple iphone 16 pro","apple iphone 16 pro max","apple iphone 16e","apple iphone 17","apple iphone 17 pro","apple iphone 17 pro max","apple iphone 17e","apple iphone air","samsung galaxy s23","samsung galaxy s23 plus","samsung galaxy s23 ultra","samsung galaxy s24","samsung galaxy s24 plus","samsung galaxy s24 ultra","samsung galaxy s25","samsung galaxy s25 plus","samsung galaxy s25 ultra","samsung galaxy s26","samsung galaxy s26 plus","samsung galaxy s26 ultra"],
//     "glass": ["apple iphone 11","apple iphone 11 pro","apple iphone 11 pro max","apple iphone 12","apple iphone 12 mini","apple iphone 12 pro","apple iphone 12 pro max","apple iphone 13","apple iphone 13 mini","apple iphone 13 pro","apple iphone 13 pro max","apple iphone 14","apple iphone 14 plus","apple iphone 14 pro","apple iphone 14 pro max","apple iphone 15","apple iphone 15 plus","apple iphone 15 pro","apple iphone 15 pro max","apple iphone 16","apple iphone 16 plus","apple iphone 16 pro","apple iphone 16 pro max","apple iphone 16e","apple iphone 17","apple iphone 17 pro","apple iphone 17 pro max","apple iphone 17e","apple iphone 6","apple iphone 6 plus","apple iphone 6s","apple iphone 6s plus","apple iphone 7","apple iphone 7 plus","apple iphone 8","apple iphone 8 plus","apple iphone air","apple iphone se 2020","apple iphone se 2022","apple iphone x","apple iphone xr","apple iphone xs","apple iphone xs max","google pixel 10","google pixel 10 pro","google pixel 10 pro xl","google pixel 10a","google pixel 6","google pixel 6 pro","google pixel 6a","google pixel 7","google pixel 7 pro","google pixel 7a","google pixel 8","google pixel 8 pro","google pixel 8a","google pixel 9","google pixel 9 pro","google pixel 9 pro xl","google pixel 9a","honor 90 5g","motorola edge 30","motorola edge 30 fusion","motorola edge 30 ultra","motorola edge 40","motorola edge 40 neo","motorola edge 50","motorola edge 50 fusion","motorola edge 50 pro","motorola edge 50 ultra","motorola edge 60 fusion","motorola edge 60 pro","motorola edge 70","motorola edge 70 fusion","motorola g96","motorola moto g45","motorola moto g54","motorola moto g64","motorola moto g84","motorola moto g85 5g","nothing cmf phone 1","nothing cmf phone 2 pro","nothing phone 1","nothing phone 2","nothing phone 2a","nothing phone 2a plus","nothing phone 3","nothing phone 3a","nothing phone 3a lite","nothing phone 3a pro","nothing phone 4a","nothing phone 4a pro","oneplus 10 pro 5g","oneplus 10r","oneplus 10t 5g","oneplus 11 5g","oneplus 11r 5g","oneplus 12","oneplus 12r","oneplus 13","oneplus 13r","oneplus 13s","oneplus 15","oneplus 15r","oneplus 5t","oneplus 6","oneplus 6t","oneplus 7","oneplus 7t","oneplus 7t pro","oneplus 8","oneplus 8 pro","oneplus 8t","oneplus 9","oneplus 9 pro","oneplus 9r","oneplus 9rt","oneplus ace 2 5g","oneplus ace 2v","oneplus ace 5g","oneplus ace pro 5g","oneplus ace racing","oneplus nord","oneplus nord 2","oneplus nord 2t 5g","oneplus nord 3 5g","oneplus nord 4","oneplus nord 5","oneplus nord ce 2 5g","oneplus nord ce 2 lite 5g","oneplus nord ce 3 5g","oneplus nord ce 3 lite","oneplus nord ce 4","oneplus nord ce 5g","oneplus nord ce4 lite 5g","oneplus nord ce5","oneplus nord n20 5g","oneplus open back","oneplus open front","oppo a1 pro","oppo a11","oppo a11x","oppo a3 pro","oppo a5 2020","oppo a5 pro","oppo a58 international","oppo a58x","oppo a59","oppo a73 2020","oppo a74","oppo a78 5g","oppo a79","oppo a9 2020","oppo a91","oppo a93","oppo a94","oppo a96 international","oppo f11 pro","oppo f15","oppo f17","oppo f17 pro","oppo f19","oppo f19 pro","oppo f19 pro plus","oppo f21 pro 4g","oppo f21 pro 5g","oppo f21s pro 4g","oppo f21s pro 5g","oppo f23 5g","oppo f25 pro","oppo f27 pro","oppo f27 pro plus","oppo f29","oppo f29 pro","oppo f31 5g","oppo f31 pro 5g","oppo f31 pro plus 5g","oppo find n3 back","oppo find n3 front","oppo find x8","oppo find x8 pro","oppo find x9","oppo find x9 pro","oppo k12","oppo k13","oppo k13 turbo 5g","oppo k13 turbo pro 5g","oppo k3","oppo k5","oppo reno 10 5g","oppo reno 10 pro 5g","oppo reno 10 pro plus 5g","oppo reno 10x zoom","oppo reno 11","oppo reno 11 pro","oppo reno 12 5g","oppo reno 12 pro 5g","oppo reno 14","oppo reno 14 pro","oppo reno 15","oppo reno 15 pro","oppo reno 15 pro mini","oppo reno 15c","oppo reno 2","oppo reno 2f","oppo reno 2z","oppo reno 3","oppo reno 3 pro international","oppo reno 4 lite","oppo reno 4 pro","oppo reno 4f","oppo reno 5 pro","oppo reno 6 5g","oppo reno 6 pro 5g","oppo reno 7 5g","oppo reno 7 pro 5g","oppo reno 8 5g","oppo reno 8 pro 5g","oppo reno 8t 5g","oppo reno ace","oppo reno13","oppo reno13 pro","oppo reno5 f","oppo reno5 lite","oppo reno6 pro 5g international","oppo reno6 pro plus 5g","oppo reno7","oppo reno7 lite","oppo reno7 z 5g","oppo reno8 4g","oppo reno8 lite","oppo reno8 z","realme 10 pro 5g","realme 10 pro plus 5g","realme 11 5g","realme 11 international","realme 11 pro","realme 11 pro plus","realme 11x 5g","realme 12","realme 12 plus","realme 12 pro","realme 12 pro plus","realme 12x","realme 13","realme 13 pro","realme 13 pro plus","realme 14 pro","realme 14 pro plus","realme 14x","realme 15","realme 15 pro","realme 3 pro","realme 5","realme 5 pro","realme 5s","realme 6","realme 6 pro","realme 6i","realme 6s","realme 7","realme 7 pro","realme 8","realme 8 5g","realme 8 pro","realme 8s 5g","realme 9 4g","realme 9 5g","realme 9 5g speed edition","realme 9 pro 5g","realme 9 pro plus 5g","realme 9i 4g","realme c65 5g","realme c75","realme gt 2","realme gt 2 pro","realme gt 5g","realme gt 6","realme gt 6t","realme gt 7","realme gt 7 pro","realme gt 7t","realme gt neo 2","realme gt neo 3","realme gt neo 3t","realme gt neo 6 se","realme gt neo flash","realme gt neo2t","realme gt neo6","realme narzo 10","realme narzo 20 pro","realme narzo 30 5g","realme narzo 50 pro","realme narzo 60","realme narzo 60 pro","realme narzo 60x 5g","realme narzo 70","realme narzo 70 pro","realme narzo 70x","realme neo7x","realme p1","realme p1 pro","realme p2 pro","realme p3","realme p3 pro","realme p3 ultra","realme q2 pro international","realme q3 5g","realme q3 pro 5g","realme q3i 5g","realme q5","realme q5 pro","realme v13 5g","realme v25","realme v60 pro","realme x","realme x lite","realme x2","realme x2 pro","realme x50 pro","realme x7 international","realme x7 max 5g","realme x7 pro","realme xt","samsung galaxy a02s","samsung galaxy a03s","samsung galaxy a04","samsung galaxy a05s","samsung galaxy a06","samsung galaxy a10","samsung galaxy a10s","samsung galaxy a11","samsung galaxy a12","samsung galaxy a14 4g","samsung galaxy a14 5g","samsung galaxy a15 5g","samsung galaxy a16","samsung galaxy a17","samsung galaxy a20","samsung galaxy a22 4g","samsung galaxy a22 5g","samsung galaxy a23 5g","samsung galaxy a25 5g","samsung galaxy a26","samsung galaxy a27","samsung galaxy a30","samsung galaxy a30s","samsung galaxy a31","samsung galaxy a32 4g","samsung galaxy a32 5g","samsung galaxy a33 5g","samsung galaxy a34 5g","samsung galaxy a35","samsung galaxy a36","samsung galaxy a37","samsung galaxy a40","samsung galaxy a40s","samsung galaxy a50","samsung galaxy a50s","samsung galaxy a51","samsung galaxy a52","samsung galaxy a52 5g","samsung galaxy a52s 5g","samsung galaxy a53 5g","samsung galaxy a54 5g","samsung galaxy a55","samsung galaxy a56","samsung galaxy a57","samsung galaxy a60","samsung galaxy a70","samsung galaxy a70s","samsung galaxy a71","samsung galaxy a72","samsung galaxy a73 5g","samsung galaxy a81","samsung galaxy a91","samsung galaxy f02s","samsung galaxy f06 5g","samsung galaxy f07","samsung galaxy f12","samsung galaxy f14 5g","samsung galaxy f15","samsung galaxy f16","samsung galaxy f22","samsung galaxy f23 5g","samsung galaxy f34 5g","samsung galaxy f36","samsung galaxy f41","samsung galaxy f42 5g","samsung galaxy f54 5g","samsung galaxy f55","samsung galaxy f56 5g","samsung galaxy f62","samsung galaxy fold 6 back","samsung galaxy fold 6 front","samsung galaxy m02s","samsung galaxy m06","samsung galaxy m07","samsung galaxy m10","samsung galaxy m10s","samsung galaxy m11","samsung galaxy m12","samsung galaxy m14","samsung galaxy m15","samsung galaxy m16","samsung galaxy m17","samsung galaxy m20","samsung galaxy m21","samsung galaxy m21 2021","samsung galaxy m23 5g","samsung galaxy m30","samsung galaxy m30s","samsung galaxy m31","samsung galaxy m31 prime","samsung galaxy m31s","samsung galaxy m32","samsung galaxy m32 5g","samsung galaxy m33 5g","samsung galaxy m34 5g","samsung galaxy m35","samsung galaxy m36","samsung galaxy m40","samsung galaxy m51","samsung galaxy m52 5g","samsung galaxy m53 5g","samsung galaxy m54 5g","samsung galaxy m55","samsung galaxy m56","samsung galaxy m62","samsung galaxy note 10","samsung galaxy note 10 lite","samsung galaxy note 10 plus","samsung galaxy note 20","samsung galaxy note 20 5g","samsung galaxy note 20 ultra","samsung galaxy note 9","samsung galaxy s10","samsung galaxy s10 lite","samsung galaxy s10 plus","samsung galaxy s10e","samsung galaxy s20","samsung galaxy s20 fe","samsung galaxy s20 fe 5g","samsung galaxy s20 plus","samsung galaxy s20 ultra","samsung galaxy s21","samsung galaxy s21 plus","samsung galaxy s21 ultra","samsung galaxy s21fe","samsung galaxy s22 5g","samsung galaxy s22 plus 5g","samsung galaxy s22 ultra 5g","samsung galaxy s23","samsung galaxy s23 plus","samsung galaxy s23 ultra","samsung galaxy s23fe","samsung galaxy s24","samsung galaxy s24 fe","samsung galaxy s24 plus","samsung galaxy s24 ultra","samsung galaxy s25","samsung galaxy s25 edge","samsung galaxy s25 fe","samsung galaxy s25 plus","samsung galaxy s25 ultra","samsung galaxy s26","samsung galaxy s26 plus","samsung galaxy s26 ultra","samsung galaxy s8","samsung galaxy s8 plus","samsung galaxy s9","samsung galaxy s9 plus","samsung galaxy z flip 3 5g bottom","samsung galaxy z flip 3 5g top","samsung galaxy z flip 4 bottom","samsung galaxy z flip 4 top","samsung galaxy z flip 5 bottom","samsung galaxy z flip 5 top","samsung galaxy z flip 6 bottom","samsung galaxy z flip 6 top","samsung galaxy z flip 7 bottom","samsung galaxy z flip 7 top","samsung galaxy z fold 3 5g back","samsung galaxy z fold 3 5g front","samsung galaxy z fold 4 back","samsung galaxy z fold 4 front","samsung galaxy z fold 5 back","samsung galaxy z fold 5 front","samsung galaxy z fold 7 back","samsung galaxy z fold 7 front","tecno pova 5 pro","vivo iqoo 10","vivo iqoo 11","vivo iqoo 12","vivo iqoo 13","vivo iqoo 15","vivo iqoo 3","vivo iqoo 7","vivo iqoo 7 legend 5g","vivo iqoo 8 5g","vivo iqoo 9 5g","vivo iqoo 9 5g international","vivo iqoo 9 pro 5g","vivo iqoo 9 se 5g","vivo iqoo 9t 5g","vivo iqoo neo 10","vivo iqoo neo 10r","vivo iqoo neo 5","vivo iqoo neo 5 s","vivo iqoo neo 6 5g","vivo iqoo neo 7","vivo iqoo neo 7 pro","vivo iqoo neo6 se","vivo iqoo neo7 racing","vivo iqoo neo7 se","vivo iqoo neo9","vivo iqoo neo9 pro","vivo iqoo u5e","vivo iqoo z10","vivo iqoo z10r 5g","vivo iqoo z10x","vivo iqoo z3","vivo iqoo z5","vivo iqoo z6","vivo iqoo z6 international","vivo iqoo z6 lite","vivo iqoo z6 pro 5g","vivo iqoo z6x","vivo iqoo z7 pro 5g","vivo iqoo z9","vivo iqoo z9 lite","vivo iqoo z9s","vivo iqoo z9s pro","vivo iqooz9x","vivo s1","vivo s1 pro","vivo s1 pro international","vivo s10e","vivo s12","vivo s12 pro","vivo s15 pro","vivo s15e","vivo s16","vivo s16 pro","vivo s16e","vivo s18","vivo s18 pro","vivo s7","vivo t1 5g","vivo t1 pro 5g","vivo t2 5g","vivo t2 pro 5g","vivo t2x 5g international","vivo t3 5g","vivo t3 pro","vivo t3 ultra","vivo t3x","vivo t4","vivo t4x","vivo v15 pro","vivo v17","vivo v17 pro","vivo v19","vivo v20","vivo v20 pro","vivo v20 se","vivo v21","vivo v21 5g","vivo v21e","vivo v21s","vivo v23 5g","vivo v23 pro 5g","vivo v23e 5g","vivo v25 5g","vivo v25 pro 5g","vivo v25e","vivo v27","vivo v27 pro","vivo v27e","vivo v29","vivo v29 pro","vivo v29e","vivo v30","vivo v30 pro","vivo v30e","vivo v40","vivo v40 pro","vivo v40e","vivo v50","vivo v60","vivo v60e","vivo v70","vivo v70 elite","vivo v70 fe","vivo x100","vivo x100 pro","vivo x200","vivo x200 fe","vivo x200 pro","vivo x300","vivo x300 pro","vivo x60","vivo x60 pro","vivo x60t","vivo x70","vivo x70 pro","vivo x80 5g","vivo x80 lite","vivo x80 pro 5g","vivo x90","vivo x90 pro","vivo y03","vivo y100","vivo y100 international","vivo y100a","vivo y16","vivo y18e","vivo y200","vivo y200 pro","vivo y200e","vivo y200t","vivo y22","vivo y22s","vivo y27","vivo y28s","vivo y29","vivo y30 5g","vivo y300","vivo y300 plus","vivo y300 pro","vivo y33e","vivo y33s 5g","vivo y35","vivo y35 plus 5g","vivo y36","vivo y38","vivo y52 5g","vivo y52t","vivo y55 5g","vivo y56 5g","vivo y70","vivo y72 5g international","vivo y73","vivo y73t","vivo y75 5g","vivo y75s","vivo z1 pro","vivo z1x","vivo z5x","xiaomi 11 lite","xiaomi 11 lite ne 5g","xiaomi 11i 5g","xiaomi 11i hypercharge 5g","xiaomi 11t 5g","xiaomi 11t pro 5g","xiaomi 12 lite 5g","xiaomi 12 pro 5g","xiaomi 12s pro","xiaomi 12x","xiaomi 13 pro","xiaomi 14","xiaomi 14 ultra","xiaomi 15","xiaomi 15 ultra","xiaomi 17","xiaomi 17 ultra","xiaomi mi 10i","xiaomi mi 10t","xiaomi mi 10t lite 5g","xiaomi mi 10t pro","xiaomi mi 11 ultra","xiaomi mi 11x","xiaomi mi 11x pro","xiaomi mi 9t","xiaomi mi 9t pro","xiaomi mi a3","xiaomi mi note 10 international","xiaomi poco f1","xiaomi poco f3","xiaomi poco f3 gt","xiaomi poco f4 5g","xiaomi poco f5 5g","xiaomi poco f6","xiaomi poco m2 pro","xiaomi poco m3 pro 5g","xiaomi poco m4 pro 5g","xiaomi poco m5s","xiaomi poco m6 pro 5g","xiaomi poco x2","xiaomi poco x3","xiaomi poco x3 nfc","xiaomi poco x3 pro","xiaomi poco x4 gt","xiaomi poco x4 pro 5g","xiaomi poco x5","xiaomi poco x5 5g","xiaomi poco x5 pro 5g","xiaomi poco x6","xiaomi poco x6 pro","xiaomi redmi 10x 4g","xiaomi redmi 12 4g","xiaomi redmi 12 5g","xiaomi redmi 13 5g","xiaomi redmi 13c 5g","xiaomi redmi 15 5g","xiaomi redmi 15c 5g","xiaomi redmi 7a","xiaomi redmi 9 power","xiaomi redmi 9t","xiaomi redmi k20","xiaomi redmi k20 pro","xiaomi redmi k30","xiaomi redmi k30i 5g","xiaomi redmi k40","xiaomi redmi k40 gaming","xiaomi redmi k50i","xiaomi redmi note 10","xiaomi redmi note 10 5g","xiaomi redmi note 10 lite","xiaomi redmi note 10 pro","xiaomi redmi note 10 pro max","xiaomi redmi note 10s","xiaomi redmi note 10t 5g","xiaomi redmi note 11","xiaomi redmi note 11 international","xiaomi redmi note 11 pro","xiaomi redmi note 11 pro 5g international","xiaomi redmi note 11 pro plus 5g","xiaomi redmi note 11 pro plus 5g international","xiaomi redmi note 11 se","xiaomi redmi note 11e pro","xiaomi redmi note 11s","xiaomi redmi note 11s 5g","xiaomi redmi note 11se 5g international","xiaomi redmi note 11t 5g","xiaomi redmi note 11t pro","xiaomi redmi note 11t pro plus","xiaomi redmi note 12 4g","xiaomi redmi note 12 5g","xiaomi redmi note 12 pro","xiaomi redmi note 12 pro plus","xiaomi redmi note 13","xiaomi redmi note 13 pro","xiaomi redmi note 13 pro plus","xiaomi redmi note 14","xiaomi redmi note 14 pro","xiaomi redmi note 14 pro plus","xiaomi redmi note 15","xiaomi redmi note 15 pro","xiaomi redmi note 15 pro plus","xiaomi redmi note 7","xiaomi redmi note 7 pro","xiaomi redmi note 7s","xiaomi redmi note 8","xiaomi redmi note 8 2021","xiaomi redmi note 8 pro","xiaomi redmi note 9","xiaomi redmi note 9 pro","xiaomi redmi note 9 pro 5g","xiaomi redmi note 9 pro max","xiaomi redmi note 9s"],
//   };

//   /* -------- 3. UTIL -------- */
//   function norm(s){ return String(s||"").toLowerCase().replace(/\s+/g," ").trim(); }
//   function $id(id){ return document.getElementById(id); }
//   function realPickerValue(raw){
//     var v = norm(raw);
//     if (!v) return "";
//     if (v === BRAND_PLACEHOLDER || v === MODEL_PLACEHOLDER) return "";
//     if (v.indexOf("select ") === 0) return "";
//     return v;
//   }
//   function readPicker(inputId, textId){
//     var inp = $id(inputId);
//     var v = inp ? realPickerValue(inp.value) : "";
//     if (v) return v;
//     var span = $id(textId);
//     return span ? realPickerValue(span.textContent) : "";
//   }
//   function getSelectedDevice(){
//     var brand = readPicker(BRAND_INPUT_ID, BRAND_TEXT_ID);
//     var device = readPicker(MODEL_INPUT_ID, MODEL_TEXT_ID);
//     if (!brand || !device) return "";
//     return norm(brand + " " + device);
//   }
//   function caseKeyFromLabel(label){
//     var n = norm(label);
//     if (CASE_TYPE_LABEL_TO_KEY[n]) return CASE_TYPE_LABEL_TO_KEY[n];
//     for (var k in CASE_TYPE_LABEL_TO_KEY){
//       if (n.indexOf(k) !== -1) return CASE_TYPE_LABEL_TO_KEY[k];
//     }
//     return null;
//   }
//   function caseAvailable(key, device){
//     if (!key) return false;
//     var list = CASE_TYPE_MODELS[key];
//     return list ? list.indexOf(device) !== -1 : false;
//   }

//   /* -------- 4. STATE / SESSION -------- */
//   var BRAND_DISPLAY = {
//     apple:"Apple", samsung:"Samsung", google:"Google", oneplus:"OnePlus",
//     xiaomi:"Xiaomi", oppo:"OPPO", vivo:"Vivo", realme:"realme",
//     motorola:"Motorola", nothing:"Nothing", honor:"Honor", tecno:"Tecno",
//   };
//   var BRAND_ORDER = ["apple","samsung","google","oneplus","xiaomi","vivo","oppo","realme","motorola","nothing"];
//   function brandDisplay(b){ return BRAND_DISPLAY[b] || (b.charAt(0).toUpperCase() + b.slice(1)); }
//   function titleCaseModel(modelFull, brand){
//     var m = modelFull;
//     if (m.indexOf(brand + " ") === 0) m = m.slice(brand.length + 1);
//     m = m.replace(/\b\w/g, function(c){ return c.toUpperCase(); });
//     m = m.replace(/\bIphone\b/g, "iPhone")
//          .replace(/\bIqoo/g, "iQOO")
//          .replace(/\bSe\b/g, "SE")
//          .replace(/\bXs\b/g, "XS")
//          .replace(/\bXr\b/g, "XR")
//          .replace(/\bFe\b/g, "FE")
//          .replace(/\b5g\b/gi, "5G")
//          .replace(/\b4g\b/gi, "4G")
//          .replace(/\bCmf\b/g, "CMF");
//     return m;
//   }
//   function deviceRank(name){
//     var nums = (name.match(/\d+/g) || []).map(Number).filter(function(n){ return n > 0 && n < 100; });
//     var base = nums.length ? Math.max.apply(null, nums) : 0;
//     if (/galaxy\s+s\d+/i.test(name)) base += 1000;
//     else if (/galaxy\s+note/i.test(name)) base += 900;
//     else if (/galaxy\s+z\s*fold/i.test(name)) base += 850;
//     else if (/galaxy\s+z\s*flip/i.test(name)) base += 800;
//     else if (/galaxy\s+a\d+/i.test(name)) base += 200;
//     else if (/galaxy\s+m\d+/i.test(name)) base += 100;
//     else if (/galaxy\s+f\d+/i.test(name)) base += 50;
//     if (/\bair\b/i.test(name)) base = Math.max(base, 100);
//     if (/ultra/i.test(name)) base += 0.4;
//     else if (/pro\s*max/i.test(name)) base += 0.35;
//     else if (/\bpro\b/i.test(name)) base += 0.2;
//     else if (/\bplus\b/i.test(name)) base += 0.1;
//     if (!nums.length){
//       if (/\bxs\b|\bxr\b/i.test(name)) base = 10.1;
//       else if (/\bx\b/i.test(name)) base = 10;
//       else if (/\bse\b/i.test(name)){
//         var yr = (name.match(/\b(20\d{2})\b/) || [0,0])[1];
//         base = 9 + (yr ? (yr - 2020)/10 : 0);
//       }
//     }
//     return base;
//   }
//   var DEVICE_INDEX = null;
//   function buildIndex(){
//     if (DEVICE_INDEX) return DEVICE_INDEX;
//     var all = {};
//     Object.keys(CASE_TYPE_MODELS).forEach(function(k){
//       CASE_TYPE_MODELS[k].forEach(function(d){ all[d] = true; });
//     });
//     var grouped = {};
//     Object.keys(all).forEach(function(full){
//       var brand = full.split(" ")[0];
//       (grouped[brand] = grouped[brand] || []).push(full);
//     });
//     Object.keys(grouped).forEach(function(b){
//       grouped[b].sort(function(a, c){
//         var ra = deviceRank(a), rc = deviceRank(c);
//         if (ra !== rc) return rc - ra;
//         return a < c ? -1 : a > c ? 1 : 0;
//       });
//     });
//     DEVICE_INDEX = grouped;
//     return grouped;
//   }

//   function loadSessionState(){
//     try {
//       return {
//         brandDisplay: sessionStorage.getItem("bds.brand") || "",
//         modelDisplay: sessionStorage.getItem("bds.model") || "",
//         brandKey:     sessionStorage.getItem("bds.brandKey") || "",
//       };
//     } catch(_e){ return { brandDisplay:"", modelDisplay:"", brandKey:"" }; }
//   }
//   function saveSessionState(){
//     try {
//       sessionStorage.setItem("bds.brand", STATE.brandDisplay || "");
//       sessionStorage.setItem("bds.model", STATE.modelDisplay || "");
//       sessionStorage.setItem("bds.brandKey", STATE.brandKey || "");
//     } catch(_e){}
//   }
//   if (!window.__bdsSTATE) window.__bdsSTATE = loadSessionState();
//   var STATE = window.__bdsSTATE;
//   var currentBrandKey = STATE.brandKey || "";

//   /* -------- 5. UNIFIED DROPDOWN -------- */
//   function ensurePickerStyles(){
//     if ($id("bds-picker-style")) return;
//     var s = document.createElement("style");
//     s.id = "bds-picker-style";
//     s.textContent = [
//       ".brand-device-selector{position:relative;}",
//       ".bds-dropdown{",
//         "position:absolute;top:calc(100% + 8px);left:0;right:0;",
//         "background:#fff;color:#111;border:1px solid #111;border-radius:18px;",
//         "box-shadow:0 16px 40px rgba(0,0,0,.12);z-index:99998;",
//         "display:none;flex-direction:column;max-height:380px;overflow:hidden;",
//         "font-family:inherit;",
//       "}",
//       ".bds-dropdown.open{display:flex;}",
//       ".bds-dropdown__search{padding:10px 12px;border-bottom:1px solid #eee;flex-shrink:0;}",
//       ".bds-dropdown__search input{width:100%;padding:10px 12px;border:1px solid #ddd;border-radius:9999px;font-size:13px;outline:none;box-sizing:border-box;font:inherit;color:#111;background:#fff;}",
//       ".bds-dropdown__search input:focus{border-color:#111;}",
//       ".bds-dropdown__list{overflow-y:auto;padding:6px 8px 10px;flex:1;-webkit-overflow-scrolling:touch;}",
//       ".bds-dropdown__item{",
//         "padding:14px 16px;cursor:pointer;font-size:14px;font-weight:500;color:#111;",
//         "display:flex;align-items:center;justify-content:space-between;line-height:1.3;",
//         "border-radius:9999px;background:#f5f5f5;margin:6px 0;border:1px solid transparent;",
//       "}",
//       ".bds-dropdown__item:hover{background:#eee;}",
//       ".bds-dropdown__item.is-active{background:#fff;border-color:#111;}",
//       ".bds-dropdown__item.latest::after{content:'NEW';margin-left:8px;font-size:9px;padding:2px 6px;background:#111;color:#fff;border-radius:4px;letter-spacing:.5px;}",
//       ".bds-dropdown__empty{padding:18px 14px;text-align:center;color:#999;font-size:13px;}",
//       ".bds-dropdown__header{padding:10px 14px 4px;font-size:10px;letter-spacing:.1em;text-transform:uppercase;color:#999;font-weight:600;}",
//     ].join("");
//     document.head.appendChild(s);
//   }

//   var dropdown = null;
//   var pickerMode = "brand";

//   function ensureDropdown(){
//     if (dropdown && document.body.contains(dropdown)) return dropdown;
//     ensurePickerStyles();
//     var root = $id(ROOT_ID) || $id(BRAND_FIELD_ID) && $id(BRAND_FIELD_ID).closest(".brand-device-selector");
//     if (!root) return null;
//     if (!root.id) root.id = ROOT_ID;
//     if (getComputedStyle(root).position === "static") root.style.position = "relative";
//     var dd = document.createElement("div");
//     dd.className = "bds-dropdown";
//     dd.innerHTML =
//       '<div class="bds-dropdown__search"><input type="text" placeholder="Search..." autocomplete="off"></div>' +
//       '<div class="bds-dropdown__list"></div>';
//     root.appendChild(dd);
//     dd.addEventListener("click", function(e){ e.stopPropagation(); });
//     dd.querySelector("input").addEventListener("input", renderList);
//     dropdown = dd;
//     return dd;
//   }

//   function closeDropdown(){
//     if (dropdown) dropdown.classList.remove("open");
//     var b = $id(BRAND_FIELD_ID), m = $id(MODEL_FIELD_ID);
//     if (b) b.setAttribute("aria-expanded","false");
//     if (m) m.setAttribute("aria-expanded","false");
//   }

//   function openBrand(e){
//     if (e) e.stopPropagation();
//     var dd = ensureDropdown();
//     if (!dd) return;
//     var wasOpen = dd.classList.contains("open") && pickerMode === "brand";
//     closeDropdown();
//     if (wasOpen) return;
//     pickerMode = "brand";
//     var inp = dd.querySelector("input");
//     inp.value = ""; inp.placeholder = "Search brand or device...";
//     renderList();
//     dd.classList.add("open");
//     var b = $id(BRAND_FIELD_ID); if (b) b.setAttribute("aria-expanded","true");
//     setTimeout(function(){ try { inp.focus({ preventScroll: true }); } catch(_e){ inp.focus(); } }, 40);
//   }

//   function openModel(e){
//     if (e) e.stopPropagation();
//     if (!currentBrandKey){ openBrand(); return; }
//     var dd = ensureDropdown();
//     if (!dd) return;
//     var wasOpen = dd.classList.contains("open") && pickerMode === "model";
//     closeDropdown();
//     if (wasOpen) return;
//     pickerMode = "model";
//     var inp = dd.querySelector("input");
//     inp.value = ""; inp.placeholder = "Search device...";
//     renderList();
//     dd.classList.add("open");
//     var m = $id(MODEL_FIELD_ID); if (m) m.setAttribute("aria-expanded","true");
//     setTimeout(function(){ try { inp.focus({ preventScroll: true }); } catch(_e){ inp.focus(); } }, 40);
//   }

//   function renderList(){
//     var dd = ensureDropdown();
//     if (!dd) return;
//     var index = buildIndex();
//     var q = norm(dd.querySelector("input").value);
//     var listEl = dd.querySelector(".bds-dropdown__list");
//     var items = [];
//     if (pickerMode === "brand"){
//       var brands = Object.keys(index);
//       var ordered = [];
//       BRAND_ORDER.forEach(function(b){ if (brands.indexOf(b) !== -1) ordered.push(b); });
//       brands.sort().forEach(function(b){ if (ordered.indexOf(b) === -1) ordered.push(b); });
//       var brandItems = [];
//       ordered.forEach(function(b){
//         var d = brandDisplay(b);
//         if (q && d.toLowerCase().indexOf(q) === -1 && b.indexOf(q) === -1) return;
//         brandItems.push({ type:"brand", key:b, label:d, active:(b === currentBrandKey) });
//       });
//       var deviceItems = [];
//       if (q){
//         ordered.forEach(function(b){
//           var list = index[b] || [];
//           list.forEach(function(full){
//             var label = brandDisplay(b) + " " + titleCaseModel(full, b);
//             if (label.toLowerCase().indexOf(q) === -1 && full.indexOf(q) === -1) return;
//             deviceItems.push({ type:"device", key:full, brand:b, label:label, rank:deviceRank(full) });
//           });
//         });
//         deviceItems.sort(function(a, c){
//           if (a.rank !== c.rank) return c.rank - a.rank;
//           return a.label < c.label ? -1 : a.label > c.label ? 1 : 0;
//         });
//         deviceItems = deviceItems.slice(0, 80);
//       }
//       if (brandItems.length){
//         items.push({ header:"Brands" });
//         items = items.concat(brandItems);
//       }
//       if (deviceItems.length){
//         items.push({ header:"Devices" });
//         items = items.concat(deviceItems);
//       }
//     } else {
//       var list = index[currentBrandKey] || [];
//       var maxRank = 0;
//       list.forEach(function(d){ var r = deviceRank(d); if (r > maxRank) maxRank = r; });
//       var currentModel = norm(STATE.modelDisplay);
//       list.forEach(function(full){
//         var label = titleCaseModel(full, currentBrandKey);
//         if (q && label.toLowerCase().indexOf(q) === -1 && full.indexOf(q) === -1) return;
//         items.push({
//           type:"model",
//           key:full,
//           label:label,
//           latest:Math.floor(deviceRank(full)) >= Math.floor(maxRank),
//           active: norm(label) === currentModel
//         });
//       });
//     }
//     if (!items.length || items.every(function(it){ return it.header; })){
//       listEl.innerHTML = '<div class="bds-dropdown__empty">No matches</div>';
//       return;
//     }
//     var newCount = 0;
//     listEl.innerHTML = items.map(function(it){
//       if (it.header){
//         return '<div class="bds-dropdown__header">' + it.header + '</div>';
//       }
//       var badge = it.latest && newCount < 3 && pickerMode === "model";
//       if (badge) newCount++;
//       var cls = "bds-dropdown__item" + (badge ? " latest" : "") + (it.active ? " is-active" : "");
//       var dataType = it.type || "brand";
//       var dataBrand = it.brand ? ' data-brand="' + it.brand.replace(/"/g, "&quot;") + '"' : "";
//       return '<div class="' + cls + '" data-type="' + dataType + '"' + dataBrand +
//         ' data-key="' + it.key.replace(/"/g, "&quot;") + '"><span>' + it.label + '</span></div>';
//     }).join("");
//   }

//   /* -------- 6. VALUE WRITERS -------- */
//   function setBrandValue(displayName){
//     STATE.brandDisplay = displayName || "";
//     saveSessionState();
//     var sb = $id(BRAND_TEXT_ID), hb = $id(BRAND_INPUT_ID);
//     if (sb) sb.textContent = displayName || "Select Brand";
//     if (hb) hb.value = displayName || "";
//     syncDeviceProperty();
//   }
//   function setModelValue(displayName){
//     STATE.modelDisplay = displayName || "";
//     saveSessionState();
//     var sm = $id(MODEL_TEXT_ID), hm = $id(MODEL_INPUT_ID);
//     if (sm) sm.textContent = displayName || "Select Device";
//     if (hm) hm.value = displayName || "";
//     syncDeviceProperty();
//   }
//   function restoreStateIfNeeded(){
//     if (STATE.brandKey && !currentBrandKey) currentBrandKey = STATE.brandKey;
//     var sb = $id(BRAND_TEXT_ID), hb = $id(BRAND_INPUT_ID);
//     var sm = $id(MODEL_TEXT_ID), hm = $id(MODEL_INPUT_ID);
//     if (STATE.brandDisplay){
//       if (sb && norm(sb.textContent) !== norm(STATE.brandDisplay)) sb.textContent = STATE.brandDisplay;
//       if (hb && hb.value !== STATE.brandDisplay) hb.value = STATE.brandDisplay;
//     }
//     if (STATE.modelDisplay){
//       if (sm && norm(sm.textContent) !== norm(STATE.modelDisplay)) sm.textContent = STATE.modelDisplay;
//       if (hm && hm.value !== STATE.modelDisplay) hm.value = STATE.modelDisplay;
//     }
//   }

//   /* -------- 6b. PUSH SELECTED DEVICE INTO PRODUCT FORM (cart line item property) -------- */
//   function getProductForms(){
//     // Cover all product forms on the page (PDP + sticky add-to-cart, quick view, etc.)
//     var forms = [];
//     var seen = new Set();
//     document.querySelectorAll(
//       'form[is="product-form"], product-form form, form[action*="/cart/add"]'
//     ).forEach(function(f){
//       if (!seen.has(f)){ seen.add(f); forms.push(f); }
//     });
//     return forms;
//   }

//   function ensureDevicePropertyInputs(form){
//     function ensure(name){
//       var inp = form.querySelector('input[name="' + name + '"]');
//       if (!inp){
//         inp = document.createElement("input");
//         inp.type  = "hidden";
//         inp.name  = name;
//         inp.className = "bds-device-prop";
//         form.appendChild(inp);
//       }
//       return inp;
//     }
//     return {
//       device: ensure('properties[Device]'),
//       brand:  ensure('properties[Brand]'),
//       model:  ensure('properties[Model]'),
//     };
//   }

//   function syncDeviceProperty(){
//     var brand = STATE.brandDisplay || "";
//     var model = STATE.modelDisplay || "";
//     var full  = (brand && model) ? (brand + " " + model) : "";

//     getProductForms().forEach(function(form){
//       var inputs = ensureDevicePropertyInputs(form);

//       if (inputs.device.value !== full){
//         inputs.device.value = full;
//         try { inputs.device.dispatchEvent(new Event("input",  { bubbles:true })); } catch(_e){}
//         try { inputs.device.dispatchEvent(new Event("change", { bubbles:true })); } catch(_e){}
//       }
//       if (inputs.brand.value !== brand){
//         inputs.brand.value = brand;
//         try { inputs.brand.dispatchEvent(new Event("change", { bubbles:true })); } catch(_e){}
//       }
//       if (inputs.model.value !== model){
//         inputs.model.value = model;
//         try { inputs.model.dispatchEvent(new Event("change", { bubbles:true })); } catch(_e){}
//       }

//       // Also clear the "please select device" error UI if it was shown
//       if (full){
//         var err = form.querySelector(".error_select_device") ||
//                   document.querySelector(".error_select_device");
//         if (err) err.hidden = true;
//       }
//     });
//   }

  

//   /* -------- 7. VARIANT HIDE/UNHIDE  (no save/restore — pure prevention) -------- */
//   var STYLE_ID = "bds-variant-filter-style";
//   function getStyleEl(){
//     var s = $id(STYLE_ID);
//     if (!s){ s = document.createElement("style"); s.id = STYLE_ID; document.head.appendChild(s); }
//     return s;
//   }
//   function readRadioLabel(inp, container){
//     if (inp.getAttribute("aria-label")) return inp.getAttribute("aria-label");
//     if (inp.id){
//       var lbl = (container || document).querySelector('label[for="' + inp.id + '"]');
//       if (lbl){
//         var hidden = lbl.querySelector(".visually-hidden, .sr-only");
//         if (hidden && hidden.textContent.trim()) return hidden.textContent;
//         return lbl.textContent;
//       }
//     }
//     return inp.value;
//   }
//   function findCaseTypeContainers(){
//     var out = [];
//     var fieldsets = document.querySelectorAll(
//       "variant-picker fieldset, .variant-picker fieldset, fieldset.product-form__input"
//     );
//     fieldsets.forEach(function(fs){
//       var legendTxt = norm((fs.querySelector("legend") || {}).textContent || "");
//       var optionName = norm(fs.getAttribute("data-option-name") || "");
//       if (legendTxt.indexOf(CASE_TYPE_OPTION_LABEL) !== -1 ||
//           optionName.indexOf(CASE_TYPE_OPTION_LABEL) !== -1){
//         out.push(fs);
//       }
//     });
//     var swatchLists = document.querySelectorAll(".variant-swatch-list");
//     swatchLists.forEach(function(sl){
//       var inputs = sl.querySelectorAll('input[type="radio"]');
//       for (var i = 0; i < inputs.length; i++){
//         var lbl = readRadioLabel(inputs[i], sl);
//         if (caseKeyFromLabel(lbl)){
//           if (out.indexOf(sl) === -1) out.push(sl);
//           break;
//         }
//       }
//     });
//     return out;
//   }

//   function rebuildVariantCSS(){
//     var device = getSelectedDevice();
//     var style = getStyleEl();
//     if (!device){ style.textContent = ""; return null; }
//     var rules = [];
//     var containers = findCaseTypeContainers();
//     var selectedKey = null;
//     containers.forEach(function(c){
//       var inputs = c.querySelectorAll('input[type="radio"]');
//       inputs.forEach(function(inp){
//         var label = readRadioLabel(inp, c);
//         var key = caseKeyFromLabel(label);
//         var availableForDevice = key && caseAvailable(key, device);
//         if (!availableForDevice){
//           var wrapper =
//             inp.closest(".variant-swatch") ||
//             inp.closest("li") ||
//             inp.closest(".product-form__input-item") ||
//             null;
//           if (wrapper){
//             if (!wrapper.id) wrapper.id = "bds-vsw-" + Math.random().toString(36).slice(2, 8);
//             rules.push("#" + wrapper.id + "{display:none !important;}");
//           } else if (inp.id){
//             rules.push(
//               "#" + (typeof CSS !== "undefined" && CSS.escape ? CSS.escape(inp.id) : inp.id) +
//               ',label[for="' + inp.id + '"]{display:none !important;}'
//             );
//           }
//           if (inp.checked) inp.checked = false;
//         } else if (inp.checked){
//           selectedKey = key;
//         }
//       });
//     });

//     if (!selectedKey){
//       var radioToClick = null;
//       containers.forEach(function(c){
//         if (radioToClick) return;
//         var inputs = c.querySelectorAll('input[type="radio"]');
//         for (var i = 0; i < inputs.length; i++){
//           var inp = inputs[i];
//           var key = caseKeyFromLabel(readRadioLabel(inp, c));
//           if (!key) continue;
//           if (caseAvailable(key, device)){
//             selectedKey = key;
//             radioToClick = inp;
//             break;
//           }
//         }
//       });
//       if (radioToClick && !radioToClick.checked){
//         radioToClick.checked = true;
//         try { radioToClick.dispatchEvent(new Event("input",  { bubbles: true })); } catch(_e){}
//         try { radioToClick.dispatchEvent(new Event("change", { bubbles: true })); } catch(_e){}
//       }
//     }
//     style.textContent = rules.join("\n");
//     return selectedKey;
//   }

//   /* -------- 8. IMAGE GALLERY FILTER -------- */
//   function getCurrentCaseKey(){
//     var containers = findCaseTypeContainers();
//     for (var i = 0; i < containers.length; i++){
//       var checked = containers[i].querySelector('input[type="radio"]:checked');
//       if (!checked) continue;
//       var k = caseKeyFromLabel(readRadioLabel(checked, containers[i]));
//       if (k) return k;
//     }
//     return null;
//   }

//   function findFlickity(el){
//     while (el){
//       if (el.flickity && typeof el.flickity.reloadCells === "function") return el.flickity;
//       if (window.Flickity && typeof window.Flickity.data === "function"){
//         var inst = window.Flickity.data(el);
//         if (inst) return inst;
//       }
//       el = el.parentElement;
//     }
//     return null;
//   }

//   function applyFlickityFilter(caseKey){
//     var pattern = caseKey ? IMAGE_PATTERN_BY_KEY[caseKey] : null;

//     document.querySelectorAll(".product__media-item").forEach(function(item){
//       var img = item.querySelector("img");
//       var src = img && (img.getAttribute("src") || img.getAttribute("data-src") ||
//                         img.getAttribute("data-original") || img.getAttribute("srcset")) || "";
//       var keep = !pattern || (src && pattern.test(src));
//       item.classList.toggle("is-filtered", !keep);
//       if (!keep) item.style.display = "none";
//       else item.style.display = "";
//     });

//     document.querySelectorAll(".product__thumbnail-item").forEach(function(item){
//       var img = item.querySelector("img");
//       var src = img && (img.getAttribute("src") || img.getAttribute("data-src") ||
//                         img.getAttribute("data-original") || img.getAttribute("srcset")) || "";
//       var keep = !pattern || (src && pattern.test(src));
//       item.style.display = keep ? "" : "none";
//     });

//     document.querySelectorAll(
//       ".product-media-list__item, .media-gallery__item, [data-media-id]"
//     ).forEach(function(item){
//       if (item.classList.contains("product__media-item") ||
//           item.classList.contains("product__thumbnail-item")) return;
//       var img = item.querySelector("img");
//       if (!img) return;
//       if (img.classList.contains("variant-swatch__image")) return;
//       if (img.closest(".variant-swatch-list, .variant-swatch, .product-sticky-form")) return;
//       var src = img.getAttribute("src") || img.getAttribute("data-src") ||
//                 img.getAttribute("data-original") || img.getAttribute("srcset") || "";
//       var keep = !pattern || (src && pattern.test(src));
//       item.style.display = keep ? "" : "none";
//     });

//     document.querySelectorAll("flickity-carousel, .flickity-enabled").forEach(function(fc){
//       var inst = findFlickity(fc);
//       if (!inst) return;
//       try {
//         if (typeof inst.reloadCells === "function") inst.reloadCells();
//         if (typeof inst.resize === "function") inst.resize();
//         var selected = inst.selectedElement;
//         if (!selected || selected.classList.contains("is-filtered")){
//           if (typeof inst.select === "function") inst.select(0, false, true);
//         }
//         if (typeof fc.reposition === "function") fc.reposition();
//         if (typeof fc.resize === "function") fc.resize();
//       } catch (_e) {}
//     });
//   }

//   /* -------- 9. CHANGE PIPELINE -------- */
//   function applyChange(force){
//     restoreStateIfNeeded();
//     syncDeviceProperty();
//     var device = getSelectedDevice();
//     if (force || device !== applyChange._lastDevice){
//       applyChange._lastDevice = device;
//       rebuildVariantCSS();
//     } else {
//       if (variantDomLooksFresh()) rebuildVariantCSS();
//     }
//     applyFlickityFilter(getCurrentCaseKey());
//   }
//   applyChange._lastDevice = "__none__";

//   function variantDomLooksFresh(){
//     var containers = findCaseTypeContainers();
//     for (var i = 0; i < containers.length; i++){
//       var wrappers = containers[i].querySelectorAll(".variant-swatch, li, .product-form__input-item");
//       for (var j = 0; j < wrappers.length; j++){
//         if (wrappers[j].id && wrappers[j].id.indexOf("bds-vsw-") === 0) return false;
//       }
//       if (wrappers.length > 0) return true;
//     }
//     return false;
//   }

//   /* -------- 10. EVENT WIRING -------- */
//   function bindPickers(){
//     var b = $id(BRAND_FIELD_ID);
//     var m = $id(MODEL_FIELD_ID);
//     if (b && !b.__bdsBound){
//       b.__bdsBound = true;
//       b.addEventListener("click", openBrand);
//       b.addEventListener("keydown", function(e){
//         if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openBrand(); }
//       });
//     }
//     if (m && !m.__bdsBound){
//       m.__bdsBound = true;
//       m.addEventListener("click", openModel);
//       m.addEventListener("keydown", function(e){
//         if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openModel(); }
//       });
//     }

//     if (!window.__bdsCaptureBound){
//       window.__bdsCaptureBound = true;
//       document.addEventListener("click", function(e){
//         var item = e.target.closest && e.target.closest(".bds-dropdown__item");
//         if (!item) return;
//         var key = item.getAttribute("data-key");
//         if (!key) return;
//         var type = item.getAttribute("data-type") || (pickerMode === "model" ? "model" : "brand");

//         if (type === "device"){
//           var brandKey = item.getAttribute("data-brand") || key.split(" ")[0];
//           currentBrandKey = brandKey;
//           STATE.brandKey = brandKey;
//           saveSessionState();
//           setBrandValue(brandDisplay(brandKey));
//           setModelValue(titleCaseModel(key, brandKey));
//           applyChange(true);
//           closeDropdown();
//           return;
//         }

//         if (type === "brand" || pickerMode === "brand"){
//           currentBrandKey = key;
//           STATE.brandKey = key;
//           saveSessionState();
//           setBrandValue(brandDisplay(key));
//           setModelValue("");
//           applyChange(true);
//           closeDropdown();
//           openModel();
//           return;
//         }

//         setModelValue(titleCaseModel(key, currentBrandKey));
//         applyChange(true);
//         closeDropdown();
//       }, true);
//     }

//     if (!window.__bdsOutsideBound){
//       window.__bdsOutsideBound = true;
//       document.addEventListener("click", function(e){
//         var inside = e.target.closest && (
//           e.target.closest(".brand-device-selector") || e.target.closest(".bds-dropdown")
//         );
//         if (!inside) closeDropdown();
//       });
//       document.addEventListener("keydown", function(e){
//         if (e.key === "Escape") closeDropdown();
//       });
//     }
//     restoreStateIfNeeded();
//   }

//   function bindVariantWatchers(){
//     findCaseTypeContainers().forEach(function(c){
//       if (c.__bdsBound) return;
//       c.__bdsBound = true;
//       c.addEventListener("change", function(){
//         setTimeout(function(){ applyChange(true); }, 0);
//         setTimeout(function(){ applyChange(true); }, 80);
//         setTimeout(function(){ applyChange(true); }, 250);
//       });
//       c.addEventListener("click", function(){
//         setTimeout(function(){ applyChange(true); }, 50);
//         setTimeout(function(){ applyChange(true); }, 200);
//       });
//     });

//     document.querySelectorAll("variant-picker, .variant-picker, product-rerender").forEach(function(node){
//       if (node.__bdsObserved) return;
//       node.__bdsObserved = true;
//       new MutationObserver(function(){
//         bindVariantWatchers();
//         applyChange(true);
//       }).observe(node, { childList: true, subtree: true });
//     });
//   }

//   /* -------- 10b. LAST-CHANCE SUBMIT GUARD (captures any form, even ones we missed) -------- */
//   if (!window.__bdsSubmitGuard){
//     window.__bdsSubmitGuard = true;
//     document.addEventListener("submit", function(e){
//       var form = e.target;
//       if (!form || !form.matches) return;
//       if (!form.matches('form[action*="/cart/add"], form[is="product-form"]')) return;
//       // ensure the latest state is mirrored into the form right before submission
//       syncDeviceProperty();
//     }, true);
//   }

//   /* -------- 11. INIT -------- */
//   function init(){
//     bindPickers();
//     bindVariantWatchers();
//     applyChange(true);

//     if (!window.__bdsPoll){
//       window.__bdsPoll = true;
//       setInterval(function(){
//         bindPickers();
//         bindVariantWatchers();
//         applyChange(false);
//       }, 500);
//     }

//     if (!document.body.__bdsObs){
//       document.body.__bdsObs = true;
//       new MutationObserver(function(){
//         bindPickers();
//         bindVariantWatchers();
//         syncDeviceProperty();
//       }).observe(document.body, { childList: true, subtree: true });
//     }
//   }

//   if (document.readyState === "loading"){
//     document.addEventListener("DOMContentLoaded", init);
//   } else {
//     init();
//   }

//   window.__bdsRefresh = function(){ applyChange(true); };
//   window.__bdsGetDevice = getSelectedDevice;
//   window.__bdsGetCase = getCurrentCaseKey;
//   window.__bdsGetState = function(){ return JSON.parse(JSON.stringify(STATE)); };
//   window.__bdsSyncDeviceProperty = syncDeviceProperty;
// })();

// /* ============== Variant price labels (unchanged) ============== */
// window.__bdsPriceInit = window.__bdsPriceInit || (function(){
//   "use strict";

//   function getHandle(){
//     var m = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
//     if (m) return m;
//     var n = document.querySelector("[product-handle],[data-product-handle],variant-picker[handle]");
//     return n && (n.getAttribute("product-handle") || n.getAttribute("data-product-handle") || n.getAttribute("handle"));
//   }
//   function norm(s){ return String(s||"").toLowerCase().replace(/\s+/g," ").trim(); }
//   function formatPrice(cents){
//     var amount = (Number(cents) || 0) / 100;
//     var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || "INR";
//     try {
//       return new Intl.NumberFormat(undefined, {
//         style: "currency", currency: currency,
//         maximumFractionDigits: amount % 1 === 0 ? 0 : 2,
//       }).format(amount);
//     } catch(e){
//       return "Rs. " + (amount % 1 === 0 ? amount : amount.toFixed(2));
//     }
//   }
//   var PRICES_BY_TITLE = null;
//   var isRendering = false;
//   function loadPrices(){
//     if (PRICES_BY_TITLE) return Promise.resolve(PRICES_BY_TITLE);
//     var handle = getHandle();
//     if (!handle){ console.warn("[variant-prices] no handle"); return Promise.resolve({}); }
//     return fetch("/products/" + handle + ".js", { credentials: "same-origin" })
//       .then(function(r){ return r.ok ? r.json() : null; })
//       .then(function(json){
//         var map = {};
//         if (json && json.variants){
//           json.variants.forEach(function(v){
//             if (v.title)    map[norm(v.title)]    = v.price;
//             if (v.option1)  map[norm(v.option1)]  = v.price;
//             if (v.option2)  map[norm(v.option2)]  = v.price;
//             if (v.option3)  map[norm(v.option3)]  = v.price;
//             if (v.name){
//               var parts = v.name.split(" - ");
//               map[norm(parts[parts.length - 1])] = v.price;
//             }
//           });
//         }
//         PRICES_BY_TITLE = map;
//         return map;
//       })
//       .catch(function(err){ console.error("[variant-prices] fetch failed", err); return {}; });
//   }
//   function getRadioLabel(input){
//     return input.getAttribute("aria-label") ||
//            (input.id && (document.querySelector('label[for="' + input.id + '"] .visually-hidden')
//                 || document.querySelector('label[for="' + input.id + '"]')) || {}).textContent ||
//            input.value;
//   }
//   function renderPrices(){
//     if (!PRICES_BY_TITLE || isRendering) return;
//     isRendering = true;
//     try {
//       document.querySelectorAll(".variant-swatch-list .variant-swatch").forEach(function(sw){
//         var input = sw.querySelector('input[type="radio"]');
//         if (!input) return;
//         var label = norm(getRadioLabel(input));
//         var cents = PRICES_BY_TITLE[label];
//         if (cents == null) return;
//         var text = formatPrice(cents);
//         var el = sw.querySelector(".bds-card-price");
//         if (!el){
//           el = document.createElement("div");
//           el.className = "bds-card-price";
//           sw.appendChild(el);
//         }
//         if (el.textContent !== text) el.textContent = text;
//       });
//     } finally {
//       isRendering = false;
//     }
//   }
//   function start(){
//     loadPrices().then(renderPrices);
//     new MutationObserver(function(){
//       if (isRendering) return;
//       renderPrices();
//     }).observe(document.body, { childList: true, subtree: true });
//     document.addEventListener("change", function(e){
//       if (e.target && e.target.matches && e.target.matches('.variant-swatch-list input[type="radio"]')){
//         setTimeout(renderPrices, 50);
//       }
//     });
//   }
//   if (document.readyState === "loading"){
//     document.addEventListener("DOMContentLoaded", start);
//   } else {
//     start();
//   }
//   return true;
// })();



(function installAntiScrollPatches(){
  if (window.__bdsAntiScrollPatched) return;
  window.__bdsAntiScrollPatched = true;

  try {
    var origFocus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function(opts){
      try {
        var inVariant = this && this.closest && this.closest(
          'variant-picker, .variant-picker, .variant-swatch-list, ' +
          '.variant-swatch, fieldset.product-form__input, product-rerender'
        );
        var isRadio = this && this.tagName === 'INPUT' && this.type === 'radio';
        if (isRadio || inVariant){
          var merged = opts && typeof opts === 'object'
            ? Object.assign({}, opts, { preventScroll: true })
            : { preventScroll: true };
          return origFocus.call(this, merged);
        }
      } catch(_e){}
      return origFocus.call(this, opts);
    };
  } catch(_e){}

  try {
    var origSIV = Element.prototype.scrollIntoView;
    Element.prototype.scrollIntoView = function(arg){
      try {
        if (this.closest && this.closest(
          'variant-picker, .variant-picker, .variant-swatch-list, ' +
          '.variant-swatch, fieldset.product-form__input, product-rerender'
        )) {
          return;
        }
      } catch(_e){}
      return origSIV.call(this, arg);
    };
  } catch(_e){}

  function injectCSS(){
    if (document.getElementById('bds-anti-scroll-css')) return;
    var s = document.createElement('style');
    s.id = 'bds-anti-scroll-css';
    s.textContent = [
      'html,body{overflow-anchor:none !important;}',
      '.variant-swatch{position:relative;}',
      '.variant-swatch input[type="radio"],',
      '.variant-swatch-list input[type="radio"]{',
        'position:absolute !important;',
        'top:0 !important;left:0 !important;right:0 !important;bottom:0 !important;',
        'width:100% !important;height:100% !important;',
        'margin:0 !important;padding:0 !important;',
        'opacity:0 !important;',
        'clip:auto !important;clip-path:none !important;',
        'pointer-events:none !important;',
        'scroll-margin:0 !important;scroll-margin-top:0 !important;',
      '}',
      'variant-picker *,.variant-picker *,.variant-swatch-list *{scroll-margin:0 !important;}',
    ].join('');
    (document.head || document.documentElement).appendChild(s);
  }
  if (document.head) injectCSS();
  else document.addEventListener('DOMContentLoaded', injectCSS);
})();

(function(){
  if (window.__bdsRerenderFix) return;
  window.__bdsRerenderFix = true;
  window.__bdsDeliveryDateFix = true;

  function maybeWrap(node){
    if (!node || node.nodeType !== 1) return;
    var html = node.outerHTML;
    if (!html || (html.indexOf("let ") === -1 && html.indexOf("const ") === -1)) return;
    var scripts = node.tagName === "SCRIPT" ? [node] : node.querySelectorAll('script:not([src])');
    for (var i = 0; i < scripts.length; i++){
      var s = scripts[i], t = s.textContent;
      if (!t || s.dataset.bdsWrapped) continue;
      if (!/\b(let|const)\s+[A-Za-z_$]/.test(t)) continue;
      s.textContent = "(function(){\ntry{\n" + t + "\n}catch(e){console.debug('[rerender-fix]',e.message);}\n})();";
      s.dataset.bdsWrapped = "1";
    }
  }
  function wrap(fnName){
    var orig = Element.prototype[fnName];
    if (!orig) return;
    Element.prototype[fnName] = function(){
      for (var i = 0; i < arguments.length; i++) maybeWrap(arguments[i]);
      try { return orig.apply(this, arguments); }
      catch(err){
        if (err && /has already been declared/.test(String(err.message || err))) {
          console.debug("[rerender-fix] suppressed", err.message);
          return;
        }
        throw err;
      }
    };
  }
  wrap('replaceWith'); wrap('append'); wrap('after');
})();

(function () {
  "use strict";

  /* -------- 1. CONFIG -------- */
  var BRAND_INPUT_ID  = "hiddenBrand";
  var MODEL_INPUT_ID  = "hiddenModel";
  var BRAND_TEXT_ID   = "selectedBrand";
  var MODEL_TEXT_ID   = "selectedModel";
  var BRAND_FIELD_ID  = "brandSelector";
  var MODEL_FIELD_ID  = "modelSelector";
  var ROOT_ID         = "bdsRoot";
  var BRAND_PLACEHOLDER = "select brand";
  var MODEL_PLACEHOLDER = "select device";

  var CASE_TYPE_OPTION_LABEL = "case type";

  var CASE_TYPE_LABEL_TO_KEY = {
    "glossy double layer": "tough",
    "glossy double layer case": "tough",
    "glossy single layer": "snap",
    "glossy single layer case": "snap",
    "snap": "snap",
    "snap case": "snap",
    "hard": "hard",
    "hard case": "hard",
    "glass": "glass",
    "glass case": "glass",
  };

  var IMAGE_PATTERN_BY_KEY = {
    "tough": /-A\d+\./i,
    "snap":  /angle-/i,
    "hard":  /-G\d+\./i,
    "glass": /-G\d+\./i,
  };

  /* -------- 2. STOCK DATA -------- */
  var CASE_TYPE_MODELS = {
    "hard": ["apple iphone 11","apple iphone 11 pro","apple iphone 11 pro max","apple iphone 12","apple iphone 12 mini","apple iphone 12 pro","apple iphone 12 pro max","apple iphone 13","apple iphone 13 mini","apple iphone 13 pro","apple iphone 13 pro max","apple iphone 14","apple iphone 14 plus","apple iphone 14 pro","apple iphone 14 pro max","apple iphone 15","apple iphone 15 plus","apple iphone 15 pro","apple iphone 15 pro max","apple iphone 16","apple iphone 16 plus","apple iphone 16 pro","apple iphone 16 pro max","apple iphone 16e","apple iphone 17","apple iphone 17 pro","apple iphone 17 pro max","apple iphone 17e","apple iphone 7","apple iphone 7 plus","apple iphone 8","apple iphone 8 plus","apple iphone air","apple iphone se 2020","apple iphone se 2022","apple iphone x","apple iphone xr","apple iphone xs","apple iphone xs max","google pixel 10","google pixel 10 pro","google pixel 10 pro xl","google pixel 10a","google pixel 6","google pixel 6 pro","google pixel 6a","google pixel 7","google pixel 7 pro","google pixel 7a","google pixel 8","google pixel 8 pro","google pixel 8a","google pixel 9","google pixel 9 pro","google pixel 9 pro xl","google pixel 9a","motorola edge 30","motorola edge 30 fusion","motorola edge 30 ultra","motorola edge 40","motorola edge 40 neo","motorola edge 50","motorola edge 50 fusion","motorola edge 50 pro","motorola edge 50 ultra","motorola edge 60 fusion","motorola edge 60 pro","motorola edge 70","motorola edge 70 fusion","motorola g96","motorola moto g45","motorola moto g54","motorola moto g64","motorola moto g84","motorola moto g85 5g","nothing cmf phone 1","nothing cmf phone 2 pro","nothing phone 1","nothing phone 2","nothing phone 2a","nothing phone 2a plus","nothing phone 3","nothing phone 3a","nothing phone 3a lite","nothing phone 3a pro","nothing phone 4a","nothing phone 4a pro","oneplus 10 pro 5g","oneplus 10r","oneplus 10t 5g","oneplus 11 5g","oneplus 11r 5g","oneplus 12","oneplus 12r","oneplus 13","oneplus 13r","oneplus 13s","oneplus 15","oneplus 15r","oneplus 6","oneplus 6t","oneplus 7","oneplus 7 pro","oneplus 7t","oneplus 7t pro","oneplus 8","oneplus 8 pro","oneplus 8t","oneplus 9","oneplus 9 pro","oneplus 9r","oneplus 9rt","oneplus ace 2v","oneplus ace racing","oneplus nord","oneplus nord 2","oneplus nord 2t 5g","oneplus nord 3 5g","oneplus nord 4","oneplus nord 5","oneplus nord ce 2 5g","oneplus nord ce 2 lite 5g","oneplus nord ce 3 5g","oneplus nord ce 3 lite","oneplus nord ce 4","oneplus nord ce 5g","oneplus nord ce4 lite 5g","oneplus nord ce5","oppo a11","oppo a11x","oppo a3 pro","oppo a5 2020","oppo a5 pro","oppo a59","oppo a73 2020","oppo a74","oppo a78 5g","oppo a9 2020","oppo a91","oppo a93","oppo f11 pro","oppo f15","oppo f17","oppo f17 pro","oppo f19","oppo f19 pro","oppo f19 pro plus","oppo f21 pro 4g","oppo f21 pro 5g","oppo f21s pro 4g","oppo f21s pro 5g","oppo f25 pro 5g","oppo f27 pro plus","oppo f29","oppo f29 pro","oppo f31 5g","oppo f31 pro 5g","oppo f31 pro plus 5g","oppo find x8","oppo find x8 pro","oppo find x9","oppo find x9 pro","oppo k12","oppo k13","oppo k13 turbo 5g","oppo k13 turbo pro 5g","oppo k3","oppo k5","oppo reno 10 5g","oppo reno 10 pro 5g","oppo reno 10 pro plus 5g","oppo reno 10x zoom","oppo reno 11","oppo reno 11 pro","oppo reno 12 5g","oppo reno 12 pro 5g","oppo reno 14","oppo reno 14 pro","oppo reno 15","oppo reno 15 pro","oppo reno 15 pro mini","oppo reno 15c","oppo reno 2","oppo reno 2f","oppo reno 2z","oppo reno 3","oppo reno 3 pro international","oppo reno 4 lite","oppo reno 4 pro","oppo reno 4f","oppo reno 5 pro","oppo reno 6 5g","oppo reno 6 pro 5g","oppo reno 7 5g","oppo reno 7 pro 5g","oppo reno 8 5g","oppo reno 8 pro 5g","oppo reno 8t 5g","oppo reno ace","oppo reno13","oppo reno13 pro","realme 10 pro 5g","realme 10 pro plus 5g","realme 11 5g","realme 11 pro","realme 11 pro plus","realme 11x 5g","realme 12","realme 12 plus","realme 12 pro 5g","realme 12 pro plus 5g","realme 12x","realme 13","realme 13 pro","realme 13 pro plus","realme 14 pro","realme 14 pro plus","realme 14x","realme 15","realme 15 pro","realme 3 pro","realme 5","realme 5 pro","realme 5s","realme 6","realme 6 pro","realme 6i","realme 6s","realme 7","realme 7 pro","realme 8","realme 8 5g","realme 8 pro","realme 8s 5g","realme 9 4g","realme 9 5g","realme 9 5g speed edition","realme 9 pro 5g","realme 9 pro plus 5g","realme 9i 4g","realme c65 5g","realme c75","realme gt 2","realme gt 2 pro","realme gt 5g","realme gt 6","realme gt 6t","realme gt 7","realme gt 7 pro","realme gt 7t","realme gt neo 2","realme gt neo 3","realme gt neo 3t","realme gt neo 6","realme gt neo 6 se","realme narzo 10","realme narzo 20 pro","realme narzo 30 5g","realme narzo 50 pro","realme narzo 60 pro","realme narzo 60x 5g","realme narzo 70","realme narzo 70 pro","realme narzo 70x","realme neo7x","realme p1","realme p1 pro","realme p2 pro","realme p3","realme p3 pro","realme p3 ultra","realme v60 pro","realme x","realme x lite","realme x2","realme x2 pro","realme x50 pro","realme x7","realme x7 max 5g","realme x7 pro","realme xt","samsung galaxy a02s","samsung galaxy a06","samsung galaxy a10","samsung galaxy a10s","samsung galaxy a11","samsung galaxy a12","samsung galaxy a14 5g","samsung galaxy a15 5g","samsung galaxy a16","samsung galaxy a17","samsung galaxy a20","samsung galaxy a22 4g","samsung galaxy a22 5g","samsung galaxy a23 5g","samsung galaxy a25 5g","samsung galaxy a26","samsung galaxy a27","samsung galaxy a30","samsung galaxy a30s","samsung galaxy a31","samsung galaxy a32 4g","samsung galaxy a32 5g","samsung galaxy a33 5g","samsung galaxy a34 5g","samsung galaxy a35 5g","samsung galaxy a36","samsung galaxy a37","samsung galaxy a40","samsung galaxy a40s","samsung galaxy a50","samsung galaxy a50s","samsung galaxy a51","samsung galaxy a52","samsung galaxy a52 5g","samsung galaxy a52s 5g","samsung galaxy a53 5g","samsung galaxy a54 5g","samsung galaxy a55 5g","samsung galaxy a56","samsung galaxy a57","samsung galaxy a60","samsung galaxy a70","samsung galaxy a70s","samsung galaxy a71","samsung galaxy a72","samsung galaxy a73 5g","samsung galaxy a81","samsung galaxy a91","samsung galaxy f02s","samsung galaxy f06 5g","samsung galaxy f07","samsung galaxy f12","samsung galaxy f14 5g","samsung galaxy f15","samsung galaxy f16","samsung galaxy f17","samsung galaxy f22","samsung galaxy f23 5g","samsung galaxy f34 5g","samsung galaxy f36","samsung galaxy f41","samsung galaxy f42 5g","samsung galaxy f54 5g","samsung galaxy f55","samsung galaxy f56 5g","samsung galaxy f62","samsung galaxy fold 6 back","samsung galaxy fold 6 front","samsung galaxy m02s","samsung galaxy m06","samsung galaxy m07","samsung galaxy m10","samsung galaxy m10s","samsung galaxy m11","samsung galaxy m12","samsung galaxy m14","samsung galaxy m16","samsung galaxy m20","samsung galaxy m21","samsung galaxy m21 2021","samsung galaxy m30","samsung galaxy m30s","samsung galaxy m31","samsung galaxy m31 prime","samsung galaxy m31s","samsung galaxy m32","samsung galaxy m32 5g","samsung galaxy m33 5g","samsung galaxy m34 5g","samsung galaxy m35","samsung galaxy m36","samsung galaxy m40","samsung galaxy m51","samsung galaxy m52 5g","samsung galaxy m53 5g","samsung galaxy m54 5g","samsung galaxy m55","samsung galaxy m56","samsung galaxy m62","samsung galaxy note 10","samsung galaxy note 10 lite","samsung galaxy note 10 plus","samsung galaxy note 20","samsung galaxy note 20 ultra","samsung galaxy note 9","samsung galaxy s10","samsung galaxy s10 lite","samsung galaxy s10 plus","samsung galaxy s10e","samsung galaxy s20","samsung galaxy s20 fe","samsung galaxy s20 fe 5g","samsung galaxy s20 plus","samsung galaxy s20 ultra","samsung galaxy s21","samsung galaxy s21 plus","samsung galaxy s21 ultra","samsung galaxy s21fe","samsung galaxy s22 5g","samsung galaxy s22 plus 5g","samsung galaxy s22 ultra 5g","samsung galaxy s23","samsung galaxy s23 plus","samsung galaxy s23 ultra","samsung galaxy s23fe","samsung galaxy s24","samsung galaxy s24 fe","samsung galaxy s24 plus","samsung galaxy s24 ultra","samsung galaxy s25","samsung galaxy s25 edge","samsung galaxy s25 fe","samsung galaxy s25 plus","samsung galaxy s25 ultra","samsung galaxy s26","samsung galaxy s26 plus","samsung galaxy s26 ultra","samsung galaxy s8","samsung galaxy s8 plus","samsung galaxy s9","samsung galaxy s9 plus","samsung galaxy z flip 3 5g bottom","samsung galaxy z flip 3 5g top","samsung galaxy z flip 4 bottom","samsung galaxy z flip 4 top","samsung galaxy z flip 5 bottom","samsung galaxy z flip 5 top","samsung galaxy z flip 6 bottom","samsung galaxy z flip 6 top","samsung galaxy z flip 7 bottom","samsung galaxy z flip 7 top","samsung galaxy z fold 3 5g back","samsung galaxy z fold 3 5g front","samsung galaxy z fold 4 back","samsung galaxy z fold 4 front","samsung galaxy z fold 5 back","samsung galaxy z fold 5 front","samsung galaxy z fold 7 back","samsung galaxy z fold 7 front","vivo iqoo 10","vivo iqoo 11","vivo iqoo 12","vivo iqoo 13","vivo iqoo 15","vivo iqoo 3","vivo iqoo 7","vivo iqoo 7 legend 5g","vivo iqoo 8 5g","vivo iqoo 9 5g","vivo iqoo 9 5g international","vivo iqoo 9 pro 5g","vivo iqoo 9 se 5g","vivo iqoo 9t 5g","vivo iqoo neo 10","vivo iqoo neo 10r","vivo iqoo neo 5","vivo iqoo neo 5 s","vivo iqoo neo 6 5g","vivo iqoo neo 7","vivo iqoo neo9","vivo iqoo neo9 pro","vivo iqoo u5e","vivo iqoo z10","vivo iqoo z10r 5g","vivo iqoo z10x","vivo iqoo z3","vivo iqoo z5","vivo iqoo z6","vivo iqoo z6 pro 5g","vivo iqoo z7 international","vivo iqoo z7 pro 5g","vivo iqoo z9","vivo iqoo z9 lite","vivo iqoo z9s","vivo iqoo z9s pro","vivo iqooz9x","vivo s1","vivo s1 pro","vivo s10e","vivo s15 pro","vivo s15e","vivo s18","vivo s18 pro","vivo s7","vivo t1 5g","vivo t1 pro 5g","vivo t2 pro 5g","vivo t3","vivo t3 5g","vivo t3 pro","vivo t3 ultra","vivo t4","vivo t4x","vivo v15 pro","vivo v17","vivo v17 pro","vivo v19","vivo v20","vivo v20 pro","vivo v20 se","vivo v21","vivo v21e","vivo v23 5g","vivo v23 pro 5g","vivo v23e 5g","vivo v25 5g","vivo v25 pro 5g","vivo v27","vivo v27 pro","vivo v27e","vivo v29","vivo v29 pro","vivo v29e","vivo v30","vivo v30 pro","vivo v30e","vivo v40","vivo v40 pro","vivo v40e","vivo v50","vivo v60","vivo v60e","vivo v70","vivo v70 elite","vivo v70 fe","vivo x100","vivo x100 pro","vivo x200","vivo x200 fe","vivo x200 pro","vivo x300","vivo x300 pro","vivo x60","vivo x60 pro","vivo x70","vivo x70 pro","vivo x80 5g","vivo x80 pro 5g","vivo x90","vivo x90 pro","vivo y100","vivo y200","vivo y200 pro","vivo y200e","vivo y22","vivo y22s","vivo y28s","vivo y29","vivo y30 5g","vivo y300","vivo y300 plus","vivo y33e","vivo y33s 5g","vivo y35","vivo y52t","vivo y55 5g","vivo y56 5g","vivo y58","vivo y73","vivo y75 5g","vivo z1 pro","vivo z1x","xiaomi 11 lite","xiaomi 11 lite ne 5g","xiaomi 11i 5g","xiaomi 11i hypercharge 5g","xiaomi 11t pro 5g","xiaomi 12 lite 5g","xiaomi 12 pro 5g","xiaomi 13 pro","xiaomi 14","xiaomi 14 civi","xiaomi 14 ultra","xiaomi 15","xiaomi 15 ultra","xiaomi 17","xiaomi 17 ultra","xiaomi mi 10i","xiaomi mi 10t","xiaomi mi 10t pro","xiaomi mi 11 ultra","xiaomi mi 11x","xiaomi mi 11x pro","xiaomi mi a3","xiaomi mi note 10 international","xiaomi poco f1","xiaomi poco f3","xiaomi poco f3 gt","xiaomi poco f4 5g","xiaomi poco f6","xiaomi poco m2 pro","xiaomi poco m3 pro 5g","xiaomi poco x2","xiaomi poco x3","xiaomi poco x3 pro","xiaomi poco x4 pro 5g","xiaomi redmi 13 5g","xiaomi redmi 13c 5g","xiaomi redmi 15 5g","xiaomi redmi 15c 5g","xiaomi redmi 7a","xiaomi redmi 9 power","xiaomi redmi 9t","xiaomi redmi k20","xiaomi redmi k20 pro","xiaomi redmi k30","xiaomi redmi k50i","xiaomi redmi note 10","xiaomi redmi note 10 5g","xiaomi redmi note 10 lite","xiaomi redmi note 10 pro","xiaomi redmi note 10 pro max","xiaomi redmi note 10s","xiaomi redmi note 10t 5g","xiaomi redmi note 11","xiaomi redmi note 11 international","xiaomi redmi note 11 pro","xiaomi redmi note 11 pro 5g international","xiaomi redmi note 11 pro plus 5g","xiaomi redmi note 11 pro plus 5g international","xiaomi redmi note 11s","xiaomi redmi note 11t 5g","xiaomi redmi note 11t pro","xiaomi redmi note 11t pro plus","xiaomi redmi note 12 5g","xiaomi redmi note 12 pro","xiaomi redmi note 12 pro plus","xiaomi redmi note 13","xiaomi redmi note 13 pro","xiaomi redmi note 13 pro plus","xiaomi redmi note 14","xiaomi redmi note 14 pro","xiaomi redmi note 14 pro plus","xiaomi redmi note 15","xiaomi redmi note 15 pro","xiaomi redmi note 15 pro plus","xiaomi redmi note 7","xiaomi redmi note 7 pro","xiaomi redmi note 7s","xiaomi redmi note 8","xiaomi redmi note 8 pro","xiaomi redmi note 9","xiaomi redmi note 9 pro","xiaomi redmi note 9 pro max","xiaomi redmi note 9s"],
    "snap": ["apple iphone 11","apple iphone 11 pro","apple iphone 11 pro max","apple iphone 12","apple iphone 12 mini","apple iphone 12 pro","apple iphone 12 pro max","apple iphone 13","apple iphone 13 mini","apple iphone 13 pro","apple iphone 13 pro max","apple iphone 14","apple iphone 14 plus","apple iphone 14 pro","apple iphone 14 pro max","apple iphone 15","apple iphone 15 plus","apple iphone 15 pro","apple iphone 15 pro max","apple iphone 16","apple iphone 16 plus","apple iphone 16 pro","apple iphone 16 pro max","apple iphone 16e","apple iphone 17","apple iphone 17 pro","apple iphone 17 pro max","apple iphone 17e","apple iphone air","samsung galaxy s23","samsung galaxy s23 plus","samsung galaxy s23 ultra","samsung galaxy s24","samsung galaxy s24 plus","samsung galaxy s24 ultra","samsung galaxy s25","samsung galaxy s25 plus","samsung galaxy s25 ultra","samsung galaxy s26","samsung galaxy s26 plus","samsung galaxy s26 ultra"],
    "tough": ["apple iphone 11","apple iphone 11 pro","apple iphone 11 pro max","apple iphone 12","apple iphone 12 mini","apple iphone 12 pro","apple iphone 12 pro max","apple iphone 13","apple iphone 13 mini","apple iphone 13 pro","apple iphone 13 pro max","apple iphone 14","apple iphone 14 plus","apple iphone 14 pro","apple iphone 14 pro max","apple iphone 15","apple iphone 15 plus","apple iphone 15 pro","apple iphone 15 pro max","apple iphone 16","apple iphone 16 plus","apple iphone 16 pro","apple iphone 16 pro max","apple iphone 16e","apple iphone 17","apple iphone 17 pro","apple iphone 17 pro max","apple iphone 17e","apple iphone air","samsung galaxy s23","samsung galaxy s23 plus","samsung galaxy s23 ultra","samsung galaxy s24","samsung galaxy s24 plus","samsung galaxy s24 ultra","samsung galaxy s25","samsung galaxy s25 plus","samsung galaxy s25 ultra","samsung galaxy s26","samsung galaxy s26 plus","samsung galaxy s26 ultra"],
    "glass": ["apple iphone 11","apple iphone 11 pro","apple iphone 11 pro max","apple iphone 12","apple iphone 12 mini","apple iphone 12 pro","apple iphone 12 pro max","apple iphone 13","apple iphone 13 mini","apple iphone 13 pro","apple iphone 13 pro max","apple iphone 14","apple iphone 14 plus","apple iphone 14 pro","apple iphone 14 pro max","apple iphone 15","apple iphone 15 plus","apple iphone 15 pro","apple iphone 15 pro max","apple iphone 16","apple iphone 16 plus","apple iphone 16 pro","apple iphone 16 pro max","apple iphone 16e","apple iphone 17","apple iphone 17 pro","apple iphone 17 pro max","apple iphone 17e","apple iphone 6","apple iphone 6 plus","apple iphone 6s","apple iphone 6s plus","apple iphone 7","apple iphone 7 plus","apple iphone 8","apple iphone 8 plus","apple iphone air","apple iphone se 2020","apple iphone se 2022","apple iphone x","apple iphone xr","apple iphone xs","apple iphone xs max","google pixel 10","google pixel 10 pro","google pixel 10 pro xl","google pixel 10a","google pixel 6","google pixel 6 pro","google pixel 6a","google pixel 7","google pixel 7 pro","google pixel 7a","google pixel 8","google pixel 8 pro","google pixel 8a","google pixel 9","google pixel 9 pro","google pixel 9 pro xl","google pixel 9a","honor 90 5g","motorola edge 30","motorola edge 30 fusion","motorola edge 30 ultra","motorola edge 40","motorola edge 40 neo","motorola edge 50","motorola edge 50 fusion","motorola edge 50 pro","motorola edge 50 ultra","motorola edge 60 fusion","motorola edge 60 pro","motorola edge 70","motorola edge 70 fusion","motorola g96","motorola moto g45","motorola moto g54","motorola moto g64","motorola moto g84","motorola moto g85 5g","nothing cmf phone 1","nothing cmf phone 2 pro","nothing phone 1","nothing phone 2","nothing phone 2a","nothing phone 2a plus","nothing phone 3","nothing phone 3a","nothing phone 3a lite","nothing phone 3a pro","nothing phone 4a","nothing phone 4a pro","oneplus 10 pro 5g","oneplus 10r","oneplus 10t 5g","oneplus 11 5g","oneplus 11r 5g","oneplus 12","oneplus 12r","oneplus 13","oneplus 13r","oneplus 13s","oneplus 15","oneplus 15r","oneplus 5t","oneplus 6","oneplus 6t","oneplus 7","oneplus 7t","oneplus 7t pro","oneplus 8","oneplus 8 pro","oneplus 8t","oneplus 9","oneplus 9 pro","oneplus 9r","oneplus 9rt","oneplus ace 2 5g","oneplus ace 2v","oneplus ace 5g","oneplus ace pro 5g","oneplus ace racing","oneplus nord","oneplus nord 2","oneplus nord 2t 5g","oneplus nord 3 5g","oneplus nord 4","oneplus nord 5","oneplus nord ce 2 5g","oneplus nord ce 2 lite 5g","oneplus nord ce 3 5g","oneplus nord ce 3 lite","oneplus nord ce 4","oneplus nord ce 5g","oneplus nord ce4 lite 5g","oneplus nord ce5","oneplus nord n20 5g","oneplus open back","oneplus open front","oppo a1 pro","oppo a11","oppo a11x","oppo a3 pro","oppo a5 2020","oppo a5 pro","oppo a58 international","oppo a58x","oppo a59","oppo a73 2020","oppo a74","oppo a78 5g","oppo a79","oppo a9 2020","oppo a91","oppo a93","oppo a94","oppo a96 international","oppo f11 pro","oppo f15","oppo f17","oppo f17 pro","oppo f19","oppo f19 pro","oppo f19 pro plus","oppo f21 pro 4g","oppo f21 pro 5g","oppo f21s pro 4g","oppo f21s pro 5g","oppo f23 5g","oppo f25 pro","oppo f27 pro","oppo f27 pro plus","oppo f29","oppo f29 pro","oppo f31 5g","oppo f31 pro 5g","oppo f31 pro plus 5g","oppo find n3 back","oppo find n3 front","oppo find x8","oppo find x8 pro","oppo find x9","oppo find x9 pro","oppo k12","oppo k13","oppo k13 turbo 5g","oppo k13 turbo pro 5g","oppo k3","oppo k5","oppo reno 10 5g","oppo reno 10 pro 5g","oppo reno 10 pro plus 5g","oppo reno 10x zoom","oppo reno 11","oppo reno 11 pro","oppo reno 12 5g","oppo reno 12 pro 5g","oppo reno 14","oppo reno 14 pro","oppo reno 15","oppo reno 15 pro","oppo reno 15 pro mini","oppo reno 15c","oppo reno 2","oppo reno 2f","oppo reno 2z","oppo reno 3","oppo reno 3 pro international","oppo reno 4 lite","oppo reno 4 pro","oppo reno 4f","oppo reno 5 pro","oppo reno 6 5g","oppo reno 6 pro 5g","oppo reno 7 5g","oppo reno 7 pro 5g","oppo reno 8 5g","oppo reno 8 pro 5g","oppo reno 8t 5g","oppo reno ace","oppo reno13","oppo reno13 pro","oppo reno5 f","oppo reno5 lite","oppo reno6 pro 5g international","oppo reno6 pro plus 5g","oppo reno7","oppo reno7 lite","oppo reno7 z 5g","oppo reno8 4g","oppo reno8 lite","oppo reno8 z","realme 10 pro 5g","realme 10 pro plus 5g","realme 11 5g","realme 11 international","realme 11 pro","realme 11 pro plus","realme 11x 5g","realme 12","realme 12 plus","realme 12 pro","realme 12 pro plus","realme 12x","realme 13","realme 13 pro","realme 13 pro plus","realme 14 pro","realme 14 pro plus","realme 14x","realme 15","realme 15 pro","realme 3 pro","realme 5","realme 5 pro","realme 5s","realme 6","realme 6 pro","realme 6i","realme 6s","realme 7","realme 7 pro","realme 8","realme 8 5g","realme 8 pro","realme 8s 5g","realme 9 4g","realme 9 5g","realme 9 5g speed edition","realme 9 pro 5g","realme 9 pro plus 5g","realme 9i 4g","realme c65 5g","realme c75","realme gt 2","realme gt 2 pro","realme gt 5g","realme gt 6","realme gt 6t","realme gt 7","realme gt 7 pro","realme gt 7t","realme gt neo 2","realme gt neo 3","realme gt neo 3t","realme gt neo 6 se","realme gt neo flash","realme gt neo2t","realme gt neo6","realme narzo 10","realme narzo 20 pro","realme narzo 30 5g","realme narzo 50 pro","realme narzo 60","realme narzo 60 pro","realme narzo 60x 5g","realme narzo 70","realme narzo 70 pro","realme narzo 70x","realme neo7x","realme p1","realme p1 pro","realme p2 pro","realme p3","realme p3 pro","realme p3 ultra","realme q2 pro international","realme q3 5g","realme q3 pro 5g","realme q3i 5g","realme q5","realme q5 pro","realme v13 5g","realme v25","realme v60 pro","realme x","realme x lite","realme x2","realme x2 pro","realme x50 pro","realme x7 international","realme x7 max 5g","realme x7 pro","realme xt","samsung galaxy a02s","samsung galaxy a03s","samsung galaxy a04","samsung galaxy a05s","samsung galaxy a06","samsung galaxy a10","samsung galaxy a10s","samsung galaxy a11","samsung galaxy a12","samsung galaxy a14 4g","samsung galaxy a14 5g","samsung galaxy a15 5g","samsung galaxy a16","samsung galaxy a17","samsung galaxy a20","samsung galaxy a22 4g","samsung galaxy a22 5g","samsung galaxy a23 5g","samsung galaxy a25 5g","samsung galaxy a26","samsung galaxy a27","samsung galaxy a30","samsung galaxy a30s","samsung galaxy a31","samsung galaxy a32 4g","samsung galaxy a32 5g","samsung galaxy a33 5g","samsung galaxy a34 5g","samsung galaxy a35","samsung galaxy a36","samsung galaxy a37","samsung galaxy a40","samsung galaxy a40s","samsung galaxy a50","samsung galaxy a50s","samsung galaxy a51","samsung galaxy a52","samsung galaxy a52 5g","samsung galaxy a52s 5g","samsung galaxy a53 5g","samsung galaxy a54 5g","samsung galaxy a55","samsung galaxy a56","samsung galaxy a57","samsung galaxy a60","samsung galaxy a70","samsung galaxy a70s","samsung galaxy a71","samsung galaxy a72","samsung galaxy a73 5g","samsung galaxy a81","samsung galaxy a91","samsung galaxy f02s","samsung galaxy f06 5g","samsung galaxy f07","samsung galaxy f12","samsung galaxy f14 5g","samsung galaxy f15","samsung galaxy f16","samsung galaxy f22","samsung galaxy f23 5g","samsung galaxy f34 5g","samsung galaxy f36","samsung galaxy f41","samsung galaxy f42 5g","samsung galaxy f54 5g","samsung galaxy f55","samsung galaxy f56 5g","samsung galaxy f62","samsung galaxy fold 6 back","samsung galaxy fold 6 front","samsung galaxy m02s","samsung galaxy m06","samsung galaxy m07","samsung galaxy m10","samsung galaxy m10s","samsung galaxy m11","samsung galaxy m12","samsung galaxy m14","samsung galaxy m15","samsung galaxy m16","samsung galaxy m17","samsung galaxy m20","samsung galaxy m21","samsung galaxy m21 2021","samsung galaxy m23 5g","samsung galaxy m30","samsung galaxy m30s","samsung galaxy m31","samsung galaxy m31 prime","samsung galaxy m31s","samsung galaxy m32","samsung galaxy m32 5g","samsung galaxy m33 5g","samsung galaxy m34 5g","samsung galaxy m35","samsung galaxy m36","samsung galaxy m40","samsung galaxy m51","samsung galaxy m52 5g","samsung galaxy m53 5g","samsung galaxy m54 5g","samsung galaxy m55","samsung galaxy m56","samsung galaxy m62","samsung galaxy note 10","samsung galaxy note 10 lite","samsung galaxy note 10 plus","samsung galaxy note 20","samsung galaxy note 20 5g","samsung galaxy note 20 ultra","samsung galaxy note 9","samsung galaxy s10","samsung galaxy s10 lite","samsung galaxy s10 plus","samsung galaxy s10e","samsung galaxy s20","samsung galaxy s20 fe","samsung galaxy s20 fe 5g","samsung galaxy s20 plus","samsung galaxy s20 ultra","samsung galaxy s21","samsung galaxy s21 plus","samsung galaxy s21 ultra","samsung galaxy s21fe","samsung galaxy s22 5g","samsung galaxy s22 plus 5g","samsung galaxy s22 ultra 5g","samsung galaxy s23","samsung galaxy s23 plus","samsung galaxy s23 ultra","samsung galaxy s23fe","samsung galaxy s24","samsung galaxy s24 fe","samsung galaxy s24 plus","samsung galaxy s24 ultra","samsung galaxy s25","samsung galaxy s25 edge","samsung galaxy s25 fe","samsung galaxy s25 plus","samsung galaxy s25 ultra","samsung galaxy s26","samsung galaxy s26 plus","samsung galaxy s26 ultra","samsung galaxy s8","samsung galaxy s8 plus","samsung galaxy s9","samsung galaxy s9 plus","samsung galaxy z flip 3 5g bottom","samsung galaxy z flip 3 5g top","samsung galaxy z flip 4 bottom","samsung galaxy z flip 4 top","samsung galaxy z flip 5 bottom","samsung galaxy z flip 5 top","samsung galaxy z flip 6 bottom","samsung galaxy z flip 6 top","samsung galaxy z flip 7 bottom","samsung galaxy z flip 7 top","samsung galaxy z fold 3 5g back","samsung galaxy z fold 3 5g front","samsung galaxy z fold 4 back","samsung galaxy z fold 4 front","samsung galaxy z fold 5 back","samsung galaxy z fold 5 front","samsung galaxy z fold 7 back","samsung galaxy z fold 7 front","tecno pova 5 pro","vivo iqoo 10","vivo iqoo 11","vivo iqoo 12","vivo iqoo 13","vivo iqoo 15","vivo iqoo 3","vivo iqoo 7","vivo iqoo 7 legend 5g","vivo iqoo 8 5g","vivo iqoo 9 5g","vivo iqoo 9 5g international","vivo iqoo 9 pro 5g","vivo iqoo 9 se 5g","vivo iqoo 9t 5g","vivo iqoo neo 10","vivo iqoo neo 10r","vivo iqoo neo 5","vivo iqoo neo 5 s","vivo iqoo neo 6 5g","vivo iqoo neo 7","vivo iqoo neo 7 pro","vivo iqoo neo6 se","vivo iqoo neo7 racing","vivo iqoo neo7 se","vivo iqoo neo9","vivo iqoo neo9 pro","vivo iqoo u5e","vivo iqoo z10","vivo iqoo z10r 5g","vivo iqoo z10x","vivo iqoo z3","vivo iqoo z5","vivo iqoo z6","vivo iqoo z6 international","vivo iqoo z6 lite","vivo iqoo z6 pro 5g","vivo iqoo z6x","vivo iqoo z7 pro 5g","vivo iqoo z9","vivo iqoo z9 lite","vivo iqoo z9s","vivo iqoo z9s pro","vivo iqooz9x","vivo s1","vivo s1 pro","vivo s1 pro international","vivo s10e","vivo s12","vivo s12 pro","vivo s15 pro","vivo s15e","vivo s16","vivo s16 pro","vivo s16e","vivo s18","vivo s18 pro","vivo s7","vivo t1 5g","vivo t1 pro 5g","vivo t2 5g","vivo t2 pro 5g","vivo t2x 5g international","vivo t3 5g","vivo t3 pro","vivo t3 ultra","vivo t3x","vivo t4","vivo t4x","vivo v15 pro","vivo v17","vivo v17 pro","vivo v19","vivo v20","vivo v20 pro","vivo v20 se","vivo v21","vivo v21 5g","vivo v21e","vivo v21s","vivo v23 5g","vivo v23 pro 5g","vivo v23e 5g","vivo v25 5g","vivo v25 pro 5g","vivo v25e","vivo v27","vivo v27 pro","vivo v27e","vivo v29","vivo v29 pro","vivo v29e","vivo v30","vivo v30 pro","vivo v30e","vivo v40","vivo v40 pro","vivo v40e","vivo v50","vivo v60","vivo v60e","vivo v70","vivo v70 elite","vivo v70 fe","vivo x100","vivo x100 pro","vivo x200","vivo x200 fe","vivo x200 pro","vivo x300","vivo x300 pro","vivo x60","vivo x60 pro","vivo x60t","vivo x70","vivo x70 pro","vivo x80 5g","vivo x80 lite","vivo x80 pro 5g","vivo x90","vivo x90 pro","vivo y03","vivo y100","vivo y100 international","vivo y100a","vivo y16","vivo y18e","vivo y200","vivo y200 pro","vivo y200e","vivo y200t","vivo y22","vivo y22s","vivo y27","vivo y28s","vivo y29","vivo y30 5g","vivo y300","vivo y300 plus","vivo y300 pro","vivo y33e","vivo y33s 5g","vivo y35","vivo y35 plus 5g","vivo y36","vivo y38","vivo y52 5g","vivo y52t","vivo y55 5g","vivo y56 5g","vivo y70","vivo y72 5g international","vivo y73","vivo y73t","vivo y75 5g","vivo y75s","vivo z1 pro","vivo z1x","vivo z5x","xiaomi 11 lite","xiaomi 11 lite ne 5g","xiaomi 11i 5g","xiaomi 11i hypercharge 5g","xiaomi 11t 5g","xiaomi 11t pro 5g","xiaomi 12 lite 5g","xiaomi 12 pro 5g","xiaomi 12s pro","xiaomi 12x","xiaomi 13 pro","xiaomi 14","xiaomi 14 ultra","xiaomi 15","xiaomi 15 ultra","xiaomi 17","xiaomi 17 ultra","xiaomi mi 10i","xiaomi mi 10t","xiaomi mi 10t lite 5g","xiaomi mi 10t pro","xiaomi mi 11 ultra","xiaomi mi 11x","xiaomi mi 11x pro","xiaomi mi 9t","xiaomi mi 9t pro","xiaomi mi a3","xiaomi mi note 10 international","xiaomi poco f1","xiaomi poco f3","xiaomi poco f3 gt","xiaomi poco f4 5g","xiaomi poco f5 5g","xiaomi poco f6","xiaomi poco m2 pro","xiaomi poco m3 pro 5g","xiaomi poco m4 pro 5g","xiaomi poco m5s","xiaomi poco m6 pro 5g","xiaomi poco x2","xiaomi poco x3","xiaomi poco x3 nfc","xiaomi poco x3 pro","xiaomi poco x4 gt","xiaomi poco x4 pro 5g","xiaomi poco x5","xiaomi poco x5 5g","xiaomi poco x5 pro 5g","xiaomi poco x6","xiaomi poco x6 pro","xiaomi redmi 10x 4g","xiaomi redmi 12 4g","xiaomi redmi 12 5g","xiaomi redmi 13 5g","xiaomi redmi 13c 5g","xiaomi redmi 15 5g","xiaomi redmi 15c 5g","xiaomi redmi 7a","xiaomi redmi 9 power","xiaomi redmi 9t","xiaomi redmi k20","xiaomi redmi k20 pro","xiaomi redmi k30","xiaomi redmi k30i 5g","xiaomi redmi k40","xiaomi redmi k40 gaming","xiaomi redmi k50i","xiaomi redmi note 10","xiaomi redmi note 10 5g","xiaomi redmi note 10 lite","xiaomi redmi note 10 pro","xiaomi redmi note 10 pro max","xiaomi redmi note 10s","xiaomi redmi note 10t 5g","xiaomi redmi note 11","xiaomi redmi note 11 international","xiaomi redmi note 11 pro","xiaomi redmi note 11 pro 5g international","xiaomi redmi note 11 pro plus 5g","xiaomi redmi note 11 pro plus 5g international","xiaomi redmi note 11 se","xiaomi redmi note 11e pro","xiaomi redmi note 11s","xiaomi redmi note 11s 5g","xiaomi redmi note 11se 5g international","xiaomi redmi note 11t 5g","xiaomi redmi note 11t pro","xiaomi redmi note 11t pro plus","xiaomi redmi note 12 4g","xiaomi redmi note 12 5g","xiaomi redmi note 12 pro","xiaomi redmi note 12 pro plus","xiaomi redmi note 13","xiaomi redmi note 13 pro","xiaomi redmi note 13 pro plus","xiaomi redmi note 14","xiaomi redmi note 14 pro","xiaomi redmi note 14 pro plus","xiaomi redmi note 15","xiaomi redmi note 15 pro","xiaomi redmi note 15 pro plus","xiaomi redmi note 7","xiaomi redmi note 7 pro","xiaomi redmi note 7s","xiaomi redmi note 8","xiaomi redmi note 8 2021","xiaomi redmi note 8 pro","xiaomi redmi note 9","xiaomi redmi note 9 pro","xiaomi redmi note 9 pro 5g","xiaomi redmi note 9 pro max","xiaomi redmi note 9s"],
  };

  /* -------- 3. UTIL -------- */
  function norm(s){ return String(s||"").toLowerCase().replace(/\s+/g," ").trim(); }
  function $id(id){ return document.getElementById(id); }
  function realPickerValue(raw){
    var v = norm(raw);
    if (!v) return "";
    if (v === BRAND_PLACEHOLDER || v === MODEL_PLACEHOLDER) return "";
    if (v.indexOf("select ") === 0) return "";
    return v;
  }
  function readPicker(inputId, textId){
    var inp = $id(inputId);
    var v = inp ? realPickerValue(inp.value) : "";
    if (v) return v;
    var span = $id(textId);
    return span ? realPickerValue(span.textContent) : "";
  }
  function getSelectedDevice(){
    var brand = readPicker(BRAND_INPUT_ID, BRAND_TEXT_ID);
    var device = readPicker(MODEL_INPUT_ID, MODEL_TEXT_ID);
    if (!brand || !device) return "";
    return norm(brand + " " + device);
  }
  function caseKeyFromLabel(label){
    var n = norm(label);
    if (CASE_TYPE_LABEL_TO_KEY[n]) return CASE_TYPE_LABEL_TO_KEY[n];
    for (var k in CASE_TYPE_LABEL_TO_KEY){
      if (n.indexOf(k) !== -1) return CASE_TYPE_LABEL_TO_KEY[k];
    }
    return null;
  }
  function caseAvailable(key, device){
    if (!key) return false;
    var list = CASE_TYPE_MODELS[key];
    return list ? list.indexOf(device) !== -1 : false;
  }

  /* -------- 4. STATE / SESSION -------- */
  var BRAND_DISPLAY = {
    apple:"Apple", samsung:"Samsung", google:"Google", oneplus:"OnePlus",
    xiaomi:"Xiaomi", oppo:"OPPO", vivo:"Vivo", realme:"realme",
    motorola:"Motorola", nothing:"Nothing", honor:"Honor", tecno:"Tecno",
  };
  var BRAND_ORDER = ["apple","samsung","google","oneplus","xiaomi","vivo","oppo","realme","motorola","nothing"];
  function brandDisplay(b){ return BRAND_DISPLAY[b] || (b.charAt(0).toUpperCase() + b.slice(1)); }
  function titleCaseModel(modelFull, brand){
    var m = modelFull;
    if (m.indexOf(brand + " ") === 0) m = m.slice(brand.length + 1);
    m = m.replace(/\b\w/g, function(c){ return c.toUpperCase(); });
    m = m.replace(/\bIphone\b/g, "iPhone")
         .replace(/\bIqoo/g, "iQOO")
         .replace(/\bSe\b/g, "SE")
         .replace(/\bXs\b/g, "XS")
         .replace(/\bXr\b/g, "XR")
         .replace(/\bFe\b/g, "FE")
         .replace(/\b5g\b/gi, "5G")
         .replace(/\b4g\b/gi, "4G")
         .replace(/\bCmf\b/g, "CMF");
    return m;
  }
  function deviceRank(name){
    var nums = (name.match(/\d+/g) || []).map(Number).filter(function(n){ return n > 0 && n < 100; });
    var base = nums.length ? Math.max.apply(null, nums) : 0;
    if (/galaxy\s+s\d+/i.test(name)) base += 1000;
    else if (/galaxy\s+note/i.test(name)) base += 900;
    else if (/galaxy\s+z\s*fold/i.test(name)) base += 850;
    else if (/galaxy\s+z\s*flip/i.test(name)) base += 800;
    else if (/galaxy\s+a\d+/i.test(name)) base += 200;
    else if (/galaxy\s+m\d+/i.test(name)) base += 100;
    else if (/galaxy\s+f\d+/i.test(name)) base += 50;
    if (/\bair\b/i.test(name)) base = Math.max(base, 100);
    if (/ultra/i.test(name)) base += 0.4;
    else if (/pro\s*max/i.test(name)) base += 0.35;
    else if (/\bpro\b/i.test(name)) base += 0.2;
    else if (/\bplus\b/i.test(name)) base += 0.1;
    if (!nums.length){
      if (/\bxs\b|\bxr\b/i.test(name)) base = 10.1;
      else if (/\bx\b/i.test(name)) base = 10;
      else if (/\bse\b/i.test(name)){
        var yr = (name.match(/\b(20\d{2})\b/) || [0,0])[1];
        base = 9 + (yr ? (yr - 2020)/10 : 0);
      }
    }
    return base;
  }
  var DEVICE_INDEX = null;
  function buildIndex(){
    if (DEVICE_INDEX) return DEVICE_INDEX;
    var all = {};
    Object.keys(CASE_TYPE_MODELS).forEach(function(k){
      CASE_TYPE_MODELS[k].forEach(function(d){ all[d] = true; });
    });
    var grouped = {};
    Object.keys(all).forEach(function(full){
      var brand = full.split(" ")[0];
      (grouped[brand] = grouped[brand] || []).push(full);
    });
    Object.keys(grouped).forEach(function(b){
      grouped[b].sort(function(a, c){
        var ra = deviceRank(a), rc = deviceRank(c);
        if (ra !== rc) return rc - ra;
        return a < c ? -1 : a > c ? 1 : 0;
      });
    });
    DEVICE_INDEX = grouped;
    return grouped;
  }

  function loadSessionState(){
    try {
      return {
        brandDisplay: sessionStorage.getItem("bds.brand") || "",
        modelDisplay: sessionStorage.getItem("bds.model") || "",
        brandKey:     sessionStorage.getItem("bds.brandKey") || "",
      };
    } catch(_e){ return { brandDisplay:"", modelDisplay:"", brandKey:"" }; }
  }
  function saveSessionState(){
    try {
      sessionStorage.setItem("bds.brand", STATE.brandDisplay || "");
      sessionStorage.setItem("bds.model", STATE.modelDisplay || "");
      sessionStorage.setItem("bds.brandKey", STATE.brandKey || "");
    } catch(_e){}
  }
  if (!window.__bdsSTATE) window.__bdsSTATE = loadSessionState();
  var STATE = window.__bdsSTATE;
  var currentBrandKey = STATE.brandKey || "";

  /* -------- 5. UNIFIED DROPDOWN -------- */
  function ensurePickerStyles(){
    if ($id("bds-picker-style")) return;
    var s = document.createElement("style");
    s.id = "bds-picker-style";
    s.textContent = [
      ".brand-device-selector{position:relative;}",
      ".bds-dropdown{",
        "position:absolute;top:calc(100% + 8px);left:0;right:0;",
        "background:#fff;color:#111;border:1px solid #111;border-radius:18px;",
        "box-shadow:0 16px 40px rgba(0,0,0,.12);z-index:99998;",
        "display:none;flex-direction:column;max-height:380px;overflow:hidden;",
        "font-family:inherit;",
      "}",
      ".bds-dropdown.open{display:flex;}",
      ".bds-dropdown__search{padding:10px 12px;border-bottom:1px solid #eee;flex-shrink:0;}",
      ".bds-dropdown__search input{width:100%;padding:10px 12px;border:1px solid #ddd;border-radius:9999px;font-size:13px;outline:none;box-sizing:border-box;font:inherit;color:#111;background:#fff;}",
      ".bds-dropdown__search input:focus{border-color:#111;}",
      ".bds-dropdown__list{overflow-y:auto;padding:6px 8px 10px;flex:1;-webkit-overflow-scrolling:touch;}",
      ".bds-dropdown__item{",
        "padding:14px 16px;cursor:pointer;font-size:14px;font-weight:500;color:#111;",
        "display:flex;align-items:center;justify-content:space-between;line-height:1.3;",
        "border-radius:9999px;background:#f5f5f5;margin:6px 0;border:1px solid transparent;",
      "}",
      ".bds-dropdown__item:hover{background:#eee;}",
      ".bds-dropdown__item.is-active{background:#fff;border-color:#111;}",
      ".bds-dropdown__item.latest::after{content:'NEW';margin-left:8px;font-size:9px;padding:2px 6px;background:#111;color:#fff;border-radius:4px;letter-spacing:.5px;}",
      ".bds-dropdown__empty{padding:18px 14px;text-align:center;color:#999;font-size:13px;}",
      ".bds-dropdown__header{padding:10px 14px 4px;font-size:10px;letter-spacing:.1em;text-transform:uppercase;color:#999;font-weight:600;}",
    ].join("");
    document.head.appendChild(s);
  }

  var dropdown = null;
  var pickerMode = "brand";

  function ensureDropdown(){
    if (dropdown && document.body.contains(dropdown)) return dropdown;
    ensurePickerStyles();
    var root = $id(ROOT_ID) || $id(BRAND_FIELD_ID) && $id(BRAND_FIELD_ID).closest(".brand-device-selector");
    if (!root) return null;
    if (!root.id) root.id = ROOT_ID;
    if (getComputedStyle(root).position === "static") root.style.position = "relative";
    var dd = document.createElement("div");
    dd.className = "bds-dropdown";
    dd.innerHTML =
      '<div class="bds-dropdown__search"><input type="text" placeholder="Search..." autocomplete="off"></div>' +
      '<div class="bds-dropdown__list"></div>';
    root.appendChild(dd);
    dd.addEventListener("click", function(e){ e.stopPropagation(); });
    dd.querySelector("input").addEventListener("input", renderList);
    dropdown = dd;
    return dd;
  }

  function closeDropdown(){
    if (dropdown) dropdown.classList.remove("open");
    var b = $id(BRAND_FIELD_ID), m = $id(MODEL_FIELD_ID);
    if (b) b.setAttribute("aria-expanded","false");
    if (m) m.setAttribute("aria-expanded","false");
  }

  function openBrand(e){
    if (e) e.stopPropagation();
    var dd = ensureDropdown();
    if (!dd) return;
    var wasOpen = dd.classList.contains("open") && pickerMode === "brand";
    closeDropdown();
    if (wasOpen) return;
    pickerMode = "brand";
    var inp = dd.querySelector("input");
    inp.value = ""; inp.placeholder = "Search brand or device...";
    renderList();
    dd.classList.add("open");
    var b = $id(BRAND_FIELD_ID); if (b) b.setAttribute("aria-expanded","true");
    setTimeout(function(){ try { inp.focus({ preventScroll: true }); } catch(_e){ inp.focus(); } }, 40);
  }

  function openModel(e){
    if (e) e.stopPropagation();
    if (!currentBrandKey){ openBrand(); return; }
    var dd = ensureDropdown();
    if (!dd) return;
    var wasOpen = dd.classList.contains("open") && pickerMode === "model";
    closeDropdown();
    if (wasOpen) return;
    pickerMode = "model";
    var inp = dd.querySelector("input");
    inp.value = ""; inp.placeholder = "Search device...";
    renderList();
    dd.classList.add("open");
    var m = $id(MODEL_FIELD_ID); if (m) m.setAttribute("aria-expanded","true");
    setTimeout(function(){ try { inp.focus({ preventScroll: true }); } catch(_e){ inp.focus(); } }, 40);
  }

  function renderList(){
    var dd = ensureDropdown();
    if (!dd) return;
    var index = buildIndex();
    var q = norm(dd.querySelector("input").value);
    var listEl = dd.querySelector(".bds-dropdown__list");
    var items = [];
    if (pickerMode === "brand"){
      var brands = Object.keys(index);
      var ordered = [];
      BRAND_ORDER.forEach(function(b){ if (brands.indexOf(b) !== -1) ordered.push(b); });
      brands.sort().forEach(function(b){ if (ordered.indexOf(b) === -1) ordered.push(b); });
      var brandItems = [];
      ordered.forEach(function(b){
        var d = brandDisplay(b);
        if (q && d.toLowerCase().indexOf(q) === -1 && b.indexOf(q) === -1) return;
        brandItems.push({ type:"brand", key:b, label:d, active:(b === currentBrandKey) });
      });
      var deviceItems = [];
      if (q){
        ordered.forEach(function(b){
          var list = index[b] || [];
          list.forEach(function(full){
            var label = brandDisplay(b) + " " + titleCaseModel(full, b);
            if (label.toLowerCase().indexOf(q) === -1 && full.indexOf(q) === -1) return;
            deviceItems.push({ type:"device", key:full, brand:b, label:label, rank:deviceRank(full) });
          });
        });
        deviceItems.sort(function(a, c){
          if (a.rank !== c.rank) return c.rank - a.rank;
          return a.label < c.label ? -1 : a.label > c.label ? 1 : 0;
        });
        deviceItems = deviceItems.slice(0, 80);
      }
      if (brandItems.length){
        items.push({ header:"Brands" });
        items = items.concat(brandItems);
      }
      if (deviceItems.length){
        items.push({ header:"Devices" });
        items = items.concat(deviceItems);
      }
    } else {
      var list = index[currentBrandKey] || [];
      var maxRank = 0;
      list.forEach(function(d){ var r = deviceRank(d); if (r > maxRank) maxRank = r; });
      var currentModel = norm(STATE.modelDisplay);
      list.forEach(function(full){
        var label = titleCaseModel(full, currentBrandKey);
        if (q && label.toLowerCase().indexOf(q) === -1 && full.indexOf(q) === -1) return;
        items.push({
          type:"model",
          key:full,
          label:label,
          latest:Math.floor(deviceRank(full)) >= Math.floor(maxRank),
          active: norm(label) === currentModel
        });
      });
    }
    if (!items.length || items.every(function(it){ return it.header; })){
      listEl.innerHTML = '<div class="bds-dropdown__empty">No matches</div>';
      return;
    }
    var newCount = 0;
    listEl.innerHTML = items.map(function(it){
      if (it.header){
        return '<div class="bds-dropdown__header">' + it.header + '</div>';
      }
      var badge = it.latest && newCount < 3 && pickerMode === "model";
      if (badge) newCount++;
      var cls = "bds-dropdown__item" + (badge ? " latest" : "") + (it.active ? " is-active" : "");
      var dataType = it.type || "brand";
      var dataBrand = it.brand ? ' data-brand="' + it.brand.replace(/"/g, "&quot;") + '"' : "";
      return '<div class="' + cls + '" data-type="' + dataType + '"' + dataBrand +
        ' data-key="' + it.key.replace(/"/g, "&quot;") + '"><span>' + it.label + '</span></div>';
    }).join("");
  }

  /* -------- 6. VALUE WRITERS -------- */
  function setBrandValue(displayName){
    STATE.brandDisplay = displayName || "";
    saveSessionState();
    var sb = $id(BRAND_TEXT_ID), hb = $id(BRAND_INPUT_ID);
    if (sb) sb.textContent = displayName || "Select Brand";
    if (hb) hb.value = displayName || "";
    syncDeviceProperty();
  }
  function setModelValue(displayName){
    STATE.modelDisplay = displayName || "";
    saveSessionState();
    var sm = $id(MODEL_TEXT_ID), hm = $id(MODEL_INPUT_ID);
    if (sm) sm.textContent = displayName || "Select Device";
    if (hm) hm.value = displayName || "";
    syncDeviceProperty();
  }
  function restoreStateIfNeeded(){
    if (STATE.brandKey && !currentBrandKey) currentBrandKey = STATE.brandKey;
    var sb = $id(BRAND_TEXT_ID), hb = $id(BRAND_INPUT_ID);
    var sm = $id(MODEL_TEXT_ID), hm = $id(MODEL_INPUT_ID);
    if (STATE.brandDisplay){
      if (sb && norm(sb.textContent) !== norm(STATE.brandDisplay)) sb.textContent = STATE.brandDisplay;
      if (hb && hb.value !== STATE.brandDisplay) hb.value = STATE.brandDisplay;
    }
    if (STATE.modelDisplay){
      if (sm && norm(sm.textContent) !== norm(STATE.modelDisplay)) sm.textContent = STATE.modelDisplay;
      if (hm && hm.value !== STATE.modelDisplay) hm.value = STATE.modelDisplay;
    }
  }

  /* -------- 6b. PUSH SELECTED DEVICE INTO PRODUCT FORM (ONE line in cart) -------- */
  function getProductForms(){
    var forms = [];
    var seen = [];
    document.querySelectorAll(
      'form[is="product-form"], product-form form, form[action*="/cart/add"]'
    ).forEach(function(f){
      if (seen.indexOf(f) === -1){ seen.push(f); forms.push(f); }
    });
    return forms;
  }

  function syncDeviceProperty(){
    var brand = STATE.brandDisplay || "";
    var model = STATE.modelDisplay || "";
    var full  = (brand && model) ? (brand + " " + model) : "";

    getProductForms().forEach(function(form){
      // Remove any stale Brand/Model props we may have created previously
      var stale = form.querySelectorAll(
        'input.bds-device-prop[name="properties[Brand]"],' +
        'input.bds-device-prop[name="properties[Model]"]'
      );
      for (var i = 0; i < stale.length; i++) stale[i].remove();

      // Ensure single Device input
      var inp = form.querySelector('input[name="properties[Device]"]');
      if (!inp){
        inp = document.createElement("input");
        inp.type = "hidden";
        inp.name = "properties[Device]";
        inp.className = "bds-device-prop";
        form.appendChild(inp);
      }
      if (inp.value !== full){
        inp.value = full;
        try { inp.dispatchEvent(new Event("input",  { bubbles:true })); } catch(_e){}
        try { inp.dispatchEvent(new Event("change", { bubbles:true })); } catch(_e){}
      }

      if (full){
        var err = form.querySelector(".error_select_device") ||
                  document.querySelector(".error_select_device");
        if (err) err.hidden = true;
      }
    });
  }

  /* -------- 7. VARIANT HIDE/UNHIDE -------- */
  var STYLE_ID = "bds-variant-filter-style";
  function getStyleEl(){
    var s = $id(STYLE_ID);
    if (!s){ s = document.createElement("style"); s.id = STYLE_ID; document.head.appendChild(s); }
    return s;
  }
  function readRadioLabel(inp, container){
    if (inp.getAttribute("aria-label")) return inp.getAttribute("aria-label");
    if (inp.id){
      var lbl = (container || document).querySelector('label[for="' + inp.id + '"]');
      if (lbl){
        var hidden = lbl.querySelector(".visually-hidden, .sr-only");
        if (hidden && hidden.textContent.trim()) return hidden.textContent;
        return lbl.textContent;
      }
    }
    return inp.value;
  }
  function findCaseTypeContainers(){
    var out = [];
    var fieldsets = document.querySelectorAll(
      "variant-picker fieldset, .variant-picker fieldset, fieldset.product-form__input"
    );
    fieldsets.forEach(function(fs){
      var legendTxt = norm((fs.querySelector("legend") || {}).textContent || "");
      var optionName = norm(fs.getAttribute("data-option-name") || "");
      if (legendTxt.indexOf(CASE_TYPE_OPTION_LABEL) !== -1 ||
          optionName.indexOf(CASE_TYPE_OPTION_LABEL) !== -1){
        out.push(fs);
      }
    });
    var swatchLists = document.querySelectorAll(".variant-swatch-list");
    swatchLists.forEach(function(sl){
      var inputs = sl.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < inputs.length; i++){
        var lbl = readRadioLabel(inputs[i], sl);
        if (caseKeyFromLabel(lbl)){
          if (out.indexOf(sl) === -1) out.push(sl);
          break;
        }
      }
    });
    return out;
  }

  function rebuildVariantCSS(){
    var device = getSelectedDevice();
    var style = getStyleEl();
    if (!device){ style.textContent = ""; return null; }
    var rules = [];
    var containers = findCaseTypeContainers();
    var selectedKey = null;
    containers.forEach(function(c){
      var inputs = c.querySelectorAll('input[type="radio"]');
      inputs.forEach(function(inp){
        var label = readRadioLabel(inp, c);
        var key = caseKeyFromLabel(label);
        var availableForDevice = key && caseAvailable(key, device);
        if (!availableForDevice){
          var wrapper =
            inp.closest(".variant-swatch") ||
            inp.closest("li") ||
            inp.closest(".product-form__input-item") ||
            null;
          if (wrapper){
            if (!wrapper.id) wrapper.id = "bds-vsw-" + Math.random().toString(36).slice(2, 8);
            rules.push("#" + wrapper.id + "{display:none !important;}");
          } else if (inp.id){
            rules.push(
              "#" + (typeof CSS !== "undefined" && CSS.escape ? CSS.escape(inp.id) : inp.id) +
              ',label[for="' + inp.id + '"]{display:none !important;}'
            );
          }
          if (inp.checked) inp.checked = false;
        } else if (inp.checked){
          selectedKey = key;
        }
      });
    });

    if (!selectedKey){
      var radioToClick = null;
      containers.forEach(function(c){
        if (radioToClick) return;
        var inputs = c.querySelectorAll('input[type="radio"]');
        for (var i = 0; i < inputs.length; i++){
          var inp = inputs[i];
          var key = caseKeyFromLabel(readRadioLabel(inp, c));
          if (!key) continue;
          if (caseAvailable(key, device)){
            selectedKey = key;
            radioToClick = inp;
            break;
          }
        }
      });
      if (radioToClick && !radioToClick.checked){
        radioToClick.checked = true;
        try { radioToClick.dispatchEvent(new Event("input",  { bubbles: true })); } catch(_e){}
        try { radioToClick.dispatchEvent(new Event("change", { bubbles: true })); } catch(_e){}
      }
    }
    style.textContent = rules.join("\n");
    return selectedKey;
  }

  /* -------- 8. IMAGE GALLERY FILTER -------- */
  function getCurrentCaseKey(){
    var containers = findCaseTypeContainers();
    for (var i = 0; i < containers.length; i++){
      var checked = containers[i].querySelector('input[type="radio"]:checked');
      if (!checked) continue;
      var k = caseKeyFromLabel(readRadioLabel(checked, containers[i]));
      if (k) return k;
    }
    return null;
  }

  function findFlickity(el){
    while (el){
      if (el.flickity && typeof el.flickity.reloadCells === "function") return el.flickity;
      if (window.Flickity && typeof window.Flickity.data === "function"){
        var inst = window.Flickity.data(el);
        if (inst) return inst;
      }
      el = el.parentElement;
    }
    return null;
  }

  function applyFlickityFilter(caseKey){
    var pattern = caseKey ? IMAGE_PATTERN_BY_KEY[caseKey] : null;

    document.querySelectorAll(".product__media-item").forEach(function(item){
      var img = item.querySelector("img");
      var src = img && (img.getAttribute("src") || img.getAttribute("data-src") ||
                        img.getAttribute("data-original") || img.getAttribute("srcset")) || "";
      var keep = !pattern || (src && pattern.test(src));
      item.classList.toggle("is-filtered", !keep);
      if (!keep) item.style.display = "none";
      else item.style.display = "";
    });

    document.querySelectorAll(".product__thumbnail-item").forEach(function(item){
      var img = item.querySelector("img");
      var src = img && (img.getAttribute("src") || img.getAttribute("data-src") ||
                        img.getAttribute("data-original") || img.getAttribute("srcset")) || "";
      var keep = !pattern || (src && pattern.test(src));
      item.style.display = keep ? "" : "none";
    });

    document.querySelectorAll(
      ".product-media-list__item, .media-gallery__item, [data-media-id]"
    ).forEach(function(item){
      if (item.classList.contains("product__media-item") ||
          item.classList.contains("product__thumbnail-item")) return;
      var img = item.querySelector("img");
      if (!img) return;
      if (img.classList.contains("variant-swatch__image")) return;
      if (img.closest(".variant-swatch-list, .variant-swatch, .product-sticky-form")) return;
      var src = img.getAttribute("src") || img.getAttribute("data-src") ||
                img.getAttribute("data-original") || img.getAttribute("srcset") || "";
      var keep = !pattern || (src && pattern.test(src));
      item.style.display = keep ? "" : "none";
    });

    document.querySelectorAll("flickity-carousel, .flickity-enabled").forEach(function(fc){
      var inst = findFlickity(fc);
      if (!inst) return;
      try {
        if (typeof inst.reloadCells === "function") inst.reloadCells();
        if (typeof inst.resize === "function") inst.resize();
        var selected = inst.selectedElement;
        if (!selected || selected.classList.contains("is-filtered")){
          if (typeof inst.select === "function") inst.select(0, false, true);
        }
        if (typeof fc.reposition === "function") fc.reposition();
        if (typeof fc.resize === "function") fc.resize();
      } catch (_e) {}
    });
  }

  /* -------- 9. CHANGE PIPELINE -------- */
  function applyChange(force){
    restoreStateIfNeeded();
    syncDeviceProperty();
    var device = getSelectedDevice();
    if (force || device !== applyChange._lastDevice){
      applyChange._lastDevice = device;
      rebuildVariantCSS();
    } else {
      if (variantDomLooksFresh()) rebuildVariantCSS();
    }
    applyFlickityFilter(getCurrentCaseKey());
  }
  applyChange._lastDevice = "__none__";

  function variantDomLooksFresh(){
    var containers = findCaseTypeContainers();
    for (var i = 0; i < containers.length; i++){
      var wrappers = containers[i].querySelectorAll(".variant-swatch, li, .product-form__input-item");
      for (var j = 0; j < wrappers.length; j++){
        if (wrappers[j].id && wrappers[j].id.indexOf("bds-vsw-") === 0) return false;
      }
      if (wrappers.length > 0) return true;
    }
    return false;
  }

  /* -------- 10. EVENT WIRING -------- */
  function bindPickers(){
    var b = $id(BRAND_FIELD_ID);
    var m = $id(MODEL_FIELD_ID);
    if (b && !b.__bdsBound){
      b.__bdsBound = true;
      b.addEventListener("click", openBrand);
      b.addEventListener("keydown", function(e){
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openBrand(); }
      });
    }
    if (m && !m.__bdsBound){
      m.__bdsBound = true;
      m.addEventListener("click", openModel);
      m.addEventListener("keydown", function(e){
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openModel(); }
      });
    }

    if (!window.__bdsCaptureBound){
      window.__bdsCaptureBound = true;
      document.addEventListener("click", function(e){
        var item = e.target.closest && e.target.closest(".bds-dropdown__item");
        if (!item) return;
        var key = item.getAttribute("data-key");
        if (!key) return;
        var type = item.getAttribute("data-type") || (pickerMode === "model" ? "model" : "brand");

        if (type === "device"){
          var brandKey = item.getAttribute("data-brand") || key.split(" ")[0];
          currentBrandKey = brandKey;
          STATE.brandKey = brandKey;
          saveSessionState();
          setBrandValue(brandDisplay(brandKey));
          setModelValue(titleCaseModel(key, brandKey));
          applyChange(true);
          closeDropdown();
          return;
        }

        if (type === "brand" || pickerMode === "brand"){
          currentBrandKey = key;
          STATE.brandKey = key;
          saveSessionState();
          setBrandValue(brandDisplay(key));
          setModelValue("");
          applyChange(true);
          closeDropdown();
          openModel();
          return;
        }

        setModelValue(titleCaseModel(key, currentBrandKey));
        applyChange(true);
        closeDropdown();
      }, true);
    }

    if (!window.__bdsOutsideBound){
      window.__bdsOutsideBound = true;
      document.addEventListener("click", function(e){
        var inside = e.target.closest && (
          e.target.closest(".brand-device-selector") || e.target.closest(".bds-dropdown")
        );
        if (!inside) closeDropdown();
      });
      document.addEventListener("keydown", function(e){
        if (e.key === "Escape") closeDropdown();
      });
    }
    restoreStateIfNeeded();
  }

  function bindVariantWatchers(){
    findCaseTypeContainers().forEach(function(c){
      if (c.__bdsBound) return;
      c.__bdsBound = true;
      c.addEventListener("change", function(){
        setTimeout(function(){ applyChange(true); }, 0);
        setTimeout(function(){ applyChange(true); }, 80);
        setTimeout(function(){ applyChange(true); }, 250);
      });
      c.addEventListener("click", function(){
        setTimeout(function(){ applyChange(true); }, 50);
        setTimeout(function(){ applyChange(true); }, 200);
      });
    });

    document.querySelectorAll("variant-picker, .variant-picker, product-rerender").forEach(function(node){
      if (node.__bdsObserved) return;
      node.__bdsObserved = true;
      new MutationObserver(function(){
        bindVariantWatchers();
        applyChange(true);
      }).observe(node, { childList: true, subtree: true });
    });
  }

  /* -------- 10b. SUBMIT GUARD -------- */
  if (!window.__bdsSubmitGuard){
    window.__bdsSubmitGuard = true;
    document.addEventListener("submit", function(e){
      var form = e.target;
      if (!form || !form.matches) return;
      if (!form.matches('form[action*="/cart/add"], form[is="product-form"]')) return;
      syncDeviceProperty();
    }, true);
  }

  /* -------- 11. INIT -------- */
  function init(){
    bindPickers();
    bindVariantWatchers();
    applyChange(true);

    if (!window.__bdsPoll){
      window.__bdsPoll = true;
      setInterval(function(){
        bindPickers();
        bindVariantWatchers();
        applyChange(false);
      }, 500);
    }

    if (!document.body.__bdsObs){
      document.body.__bdsObs = true;
      new MutationObserver(function(){
        bindPickers();
        bindVariantWatchers();
        syncDeviceProperty();
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.__bdsRefresh = function(){ applyChange(true); };
  window.__bdsGetDevice = getSelectedDevice;
  window.__bdsGetCase = getCurrentCaseKey;
  window.__bdsGetState = function(){ return JSON.parse(JSON.stringify(STATE)); };
  window.__bdsSyncDeviceProperty = syncDeviceProperty;
})();

/* ============== Variant price labels ============== */
window.__bdsPriceInit = window.__bdsPriceInit || (function(){
  "use strict";

  function getHandle(){
    var m = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
    if (m) return m;
    var n = document.querySelector("[product-handle],[data-product-handle],variant-picker[handle]");
    return n && (n.getAttribute("product-handle") || n.getAttribute("data-product-handle") || n.getAttribute("handle"));
  }
  function norm(s){ return String(s||"").toLowerCase().replace(/\s+/g," ").trim(); }
  function formatPrice(cents){
    var amount = (Number(cents) || 0) / 100;
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || "INR";
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency", currency: currency,
        maximumFractionDigits: amount % 1 === 0 ? 0 : 2,
      }).format(amount);
    } catch(e){
      return "Rs. " + (amount % 1 === 0 ? amount : amount.toFixed(2));
    }
  }
  var PRICES_BY_TITLE = null;
  var isRendering = false;
  function loadPrices(){
    if (PRICES_BY_TITLE) return Promise.resolve(PRICES_BY_TITLE);
    var handle = getHandle();
    if (!handle){ console.warn("[variant-prices] no handle"); return Promise.resolve({}); }
    return fetch("/products/" + handle + ".js", { credentials: "same-origin" })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(json){
        var map = {};
        if (json && json.variants){
          json.variants.forEach(function(v){
            if (v.title)    map[norm(v.title)]    = v.price;
            if (v.option1)  map[norm(v.option1)]  = v.price;
            if (v.option2)  map[norm(v.option2)]  = v.price;
            if (v.option3)  map[norm(v.option3)]  = v.price;
            if (v.name){
              var parts = v.name.split(" - ");
              map[norm(parts[parts.length - 1])] = v.price;
            }
          });
        }
        PRICES_BY_TITLE = map;
        return map;
      })
      .catch(function(err){ console.error("[variant-prices] fetch failed", err); return {}; });
  }
  function getRadioLabel(input){
    return input.getAttribute("aria-label") ||
           (input.id && (document.querySelector('label[for="' + input.id + '"] .visually-hidden')
                || document.querySelector('label[for="' + input.id + '"]')) || {}).textContent ||
           input.value;
  }
  function renderPrices(){
    if (!PRICES_BY_TITLE || isRendering) return;
    isRendering = true;
    try {
      document.querySelectorAll(".variant-swatch-list .variant-swatch").forEach(function(sw){
        var input = sw.querySelector('input[type="radio"]');
        if (!input) return;
        var label = norm(getRadioLabel(input));
        var cents = PRICES_BY_TITLE[label];
        if (cents == null) return;
        var text = formatPrice(cents);
        var el = sw.querySelector(".bds-card-price");
        if (!el){
          el = document.createElement("div");
          el.className = "bds-card-price";
          sw.appendChild(el);
        }
        if (el.textContent !== text) el.textContent = text;
      });
    } finally {
      isRendering = false;
    }
  }
  function start(){
    loadPrices().then(renderPrices);
    new MutationObserver(function(){
      if (isRendering) return;
      renderPrices();
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener("change", function(e){
      if (e.target && e.target.matches && e.target.matches('.variant-swatch-list input[type="radio"]')){
        setTimeout(renderPrices, 50);
      }
    });
  }
  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
  return true;
})();
